/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const createOrganization = /* GraphQL */ `
  mutation CreateOrganization(
    $input: CreateOrganizationInput!
    $condition: ModelOrganizationConditionInput
  ) {
    createOrganization(input: $input, condition: $condition) {
      id
      name
      organizationType
      groupType
      chairId
      chair {
        id
        name
        type
        organizations {
          nextToken
          __typename
        }
        members {
          nextToken
          __typename
        }
        createdAt
        createdByUserId
        createdBy {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        deleted
        modifications {
          fieldName
          fieldValue
          dataOperation
          modifiedAt
          id
          createdAt
          updatedAt
          __typename
        }
        updatedAt
        organizationCompaniesId
        __typename
      }
      chairContactId
      chairContact {
        id
        cognitoUserId
        termsAgree
        termsAgreeDate
        participationAgreement
        participationAgreementDate
        organization {
          nextToken
          __typename
        }
        roles
        companyId
        company {
          id
          name
          type
          createdAt
          createdByUserId
          deleted
          updatedAt
          organizationCompaniesId
          __typename
        }
        firstName
        lastName
        email
        office
        mobile
        linkedInUrl
        imageUrl
        timeZone
        monthlyUpdates
        generalAnnouncements
        createdAt
        createdByUserId
        createdBy {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        modifications {
          fieldName
          fieldValue
          dataOperation
          modifiedAt
          id
          createdAt
          updatedAt
          __typename
        }
        organizationAdmin {
          nextToken
          __typename
        }
        organizationMember {
          nextToken
          __typename
        }
        deleted
        lastLoginDate
        weeklyDigestNotification
        monthlyDigestNotification
        quarterlyEmailNotification
        annualDigestNotification
        membershipAlertsNotification
        generalEmailNotification
        organizationSupportAdmin {
          nextToken
          __typename
        }
        updatedAt
        organizationContactsId
        __typename
      }
      operatorId
      operator {
        id
        name
        type
        organizations {
          nextToken
          __typename
        }
        members {
          nextToken
          __typename
        }
        createdAt
        createdByUserId
        createdBy {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        deleted
        modifications {
          fieldName
          fieldValue
          dataOperation
          modifiedAt
          id
          createdAt
          updatedAt
          __typename
        }
        updatedAt
        organizationCompaniesId
        __typename
      }
      operatorContactId
      operatorContact {
        id
        cognitoUserId
        termsAgree
        termsAgreeDate
        participationAgreement
        participationAgreementDate
        organization {
          nextToken
          __typename
        }
        roles
        companyId
        company {
          id
          name
          type
          createdAt
          createdByUserId
          deleted
          updatedAt
          organizationCompaniesId
          __typename
        }
        firstName
        lastName
        email
        office
        mobile
        linkedInUrl
        imageUrl
        timeZone
        monthlyUpdates
        generalAnnouncements
        createdAt
        createdByUserId
        createdBy {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        modifications {
          fieldName
          fieldValue
          dataOperation
          modifiedAt
          id
          createdAt
          updatedAt
          __typename
        }
        organizationAdmin {
          nextToken
          __typename
        }
        organizationMember {
          nextToken
          __typename
        }
        deleted
        lastLoginDate
        weeklyDigestNotification
        monthlyDigestNotification
        quarterlyEmailNotification
        annualDigestNotification
        membershipAlertsNotification
        generalEmailNotification
        organizationSupportAdmin {
          nextToken
          __typename
        }
        updatedAt
        organizationContactsId
        __typename
      }
      admins {
        items {
          id
          organizationId
          userId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      airports {
        items {
          id
          organizationId
          airportId
          chairId
          chairContactId
          operatorId
          operatorGeneralManagerId
          secondaryContact
          facilityOwner
          facilityOwnerContact
          legalCounselContact
          legalCounsel
          facilityLocation
          totalCapacityDays
          totalCapacityGallons
          secured
          moExpiration
          moType
          moTypeCustomValue
          leaseExpiration
          leaseType
          leaseTypeCustomValue
          dateLastFinancialSUP
          dateLastA4aOperationalReview
          netInventoryCalculation
          entryFee
          nonMemberRate
          costSharingFormula
          reserveDepositPrebill
          thirdPartyDebt
          memberLoans
          dateLastPropertyAppraisal
          aviationLiabilityLimit
          environmentalLiabilityLimit
          comments
          deleted
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      companies {
        items {
          id
          name
          type
          createdAt
          createdByUserId
          deleted
          updatedAt
          organizationCompaniesId
          __typename
        }
        nextToken
        __typename
      }
      members {
        items {
          id
          organizationId
          userId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      documents {
        items {
          id
          organizationId
          airportId
          categoryType
          documentCategoryId
          bucketType
          title
          description
          publishedByUserId
          publishedDate
          url
          fileSize
          companyId
          createdAt
          createByUserId
          categoryTypeId
          deleted
          updatedAt
          organizationDocumentsId
          documentCategoryDocumentsId
          documentFileTypeId
          __typename
        }
        nextToken
        __typename
      }
      calendar {
        items {
          id
          organizationId
          calendarEventTypeId
          name
          startDateTime
          endDateTime
          description
          location
          website
          groupRateCode
          organizer
          specialRates
          venue
          venueWebSite
          createdAt
          createdByUserId
          modifiedByUserId
          updatedAt
          organizationCalendarId
          __typename
        }
        nextToken
        __typename
      }
      contacts {
        items {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      createdByUserId
      createdBy {
        id
        cognitoUserId
        termsAgree
        termsAgreeDate
        participationAgreement
        participationAgreementDate
        organization {
          nextToken
          __typename
        }
        roles
        companyId
        company {
          id
          name
          type
          createdAt
          createdByUserId
          deleted
          updatedAt
          organizationCompaniesId
          __typename
        }
        firstName
        lastName
        email
        office
        mobile
        linkedInUrl
        imageUrl
        timeZone
        monthlyUpdates
        generalAnnouncements
        createdAt
        createdByUserId
        createdBy {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        modifications {
          fieldName
          fieldValue
          dataOperation
          modifiedAt
          id
          createdAt
          updatedAt
          __typename
        }
        organizationAdmin {
          nextToken
          __typename
        }
        organizationMember {
          nextToken
          __typename
        }
        deleted
        lastLoginDate
        weeklyDigestNotification
        monthlyDigestNotification
        quarterlyEmailNotification
        annualDigestNotification
        membershipAlertsNotification
        generalEmailNotification
        organizationSupportAdmin {
          nextToken
          __typename
        }
        updatedAt
        organizationContactsId
        __typename
      }
      modifications {
        fieldName
        fieldValue
        dataOperation
        modifiedAt
        modifiedBy {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        id
        createdAt
        updatedAt
        __typename
      }
      supportAdmin {
        items {
          id
          organizationId
          userId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      deleted
      updatedAt
      companyOrganizationsId
      userOrganizationId
      __typename
    }
  }
`;
export const updateOrganization = /* GraphQL */ `
  mutation UpdateOrganization(
    $input: UpdateOrganizationInput!
    $condition: ModelOrganizationConditionInput
  ) {
    updateOrganization(input: $input, condition: $condition) {
      id
      name
      organizationType
      groupType
      chairId
      chair {
        id
        name
        type
        organizations {
          nextToken
          __typename
        }
        members {
          nextToken
          __typename
        }
        createdAt
        createdByUserId
        createdBy {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        deleted
        modifications {
          fieldName
          fieldValue
          dataOperation
          modifiedAt
          id
          createdAt
          updatedAt
          __typename
        }
        updatedAt
        organizationCompaniesId
        __typename
      }
      chairContactId
      chairContact {
        id
        cognitoUserId
        termsAgree
        termsAgreeDate
        participationAgreement
        participationAgreementDate
        organization {
          nextToken
          __typename
        }
        roles
        companyId
        company {
          id
          name
          type
          createdAt
          createdByUserId
          deleted
          updatedAt
          organizationCompaniesId
          __typename
        }
        firstName
        lastName
        email
        office
        mobile
        linkedInUrl
        imageUrl
        timeZone
        monthlyUpdates
        generalAnnouncements
        createdAt
        createdByUserId
        createdBy {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        modifications {
          fieldName
          fieldValue
          dataOperation
          modifiedAt
          id
          createdAt
          updatedAt
          __typename
        }
        organizationAdmin {
          nextToken
          __typename
        }
        organizationMember {
          nextToken
          __typename
        }
        deleted
        lastLoginDate
        weeklyDigestNotification
        monthlyDigestNotification
        quarterlyEmailNotification
        annualDigestNotification
        membershipAlertsNotification
        generalEmailNotification
        organizationSupportAdmin {
          nextToken
          __typename
        }
        updatedAt
        organizationContactsId
        __typename
      }
      operatorId
      operator {
        id
        name
        type
        organizations {
          nextToken
          __typename
        }
        members {
          nextToken
          __typename
        }
        createdAt
        createdByUserId
        createdBy {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        deleted
        modifications {
          fieldName
          fieldValue
          dataOperation
          modifiedAt
          id
          createdAt
          updatedAt
          __typename
        }
        updatedAt
        organizationCompaniesId
        __typename
      }
      operatorContactId
      operatorContact {
        id
        cognitoUserId
        termsAgree
        termsAgreeDate
        participationAgreement
        participationAgreementDate
        organization {
          nextToken
          __typename
        }
        roles
        companyId
        company {
          id
          name
          type
          createdAt
          createdByUserId
          deleted
          updatedAt
          organizationCompaniesId
          __typename
        }
        firstName
        lastName
        email
        office
        mobile
        linkedInUrl
        imageUrl
        timeZone
        monthlyUpdates
        generalAnnouncements
        createdAt
        createdByUserId
        createdBy {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        modifications {
          fieldName
          fieldValue
          dataOperation
          modifiedAt
          id
          createdAt
          updatedAt
          __typename
        }
        organizationAdmin {
          nextToken
          __typename
        }
        organizationMember {
          nextToken
          __typename
        }
        deleted
        lastLoginDate
        weeklyDigestNotification
        monthlyDigestNotification
        quarterlyEmailNotification
        annualDigestNotification
        membershipAlertsNotification
        generalEmailNotification
        organizationSupportAdmin {
          nextToken
          __typename
        }
        updatedAt
        organizationContactsId
        __typename
      }
      admins {
        items {
          id
          organizationId
          userId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      airports {
        items {
          id
          organizationId
          airportId
          chairId
          chairContactId
          operatorId
          operatorGeneralManagerId
          secondaryContact
          facilityOwner
          facilityOwnerContact
          legalCounselContact
          legalCounsel
          facilityLocation
          totalCapacityDays
          totalCapacityGallons
          secured
          moExpiration
          moType
          moTypeCustomValue
          leaseExpiration
          leaseType
          leaseTypeCustomValue
          dateLastFinancialSUP
          dateLastA4aOperationalReview
          netInventoryCalculation
          entryFee
          nonMemberRate
          costSharingFormula
          reserveDepositPrebill
          thirdPartyDebt
          memberLoans
          dateLastPropertyAppraisal
          aviationLiabilityLimit
          environmentalLiabilityLimit
          comments
          deleted
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      companies {
        items {
          id
          name
          type
          createdAt
          createdByUserId
          deleted
          updatedAt
          organizationCompaniesId
          __typename
        }
        nextToken
        __typename
      }
      members {
        items {
          id
          organizationId
          userId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      documents {
        items {
          id
          organizationId
          airportId
          categoryType
          documentCategoryId
          bucketType
          title
          description
          publishedByUserId
          publishedDate
          url
          fileSize
          companyId
          createdAt
          createByUserId
          categoryTypeId
          deleted
          updatedAt
          organizationDocumentsId
          documentCategoryDocumentsId
          documentFileTypeId
          __typename
        }
        nextToken
        __typename
      }
      calendar {
        items {
          id
          organizationId
          calendarEventTypeId
          name
          startDateTime
          endDateTime
          description
          location
          website
          groupRateCode
          organizer
          specialRates
          venue
          venueWebSite
          createdAt
          createdByUserId
          modifiedByUserId
          updatedAt
          organizationCalendarId
          __typename
        }
        nextToken
        __typename
      }
      contacts {
        items {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      createdByUserId
      createdBy {
        id
        cognitoUserId
        termsAgree
        termsAgreeDate
        participationAgreement
        participationAgreementDate
        organization {
          nextToken
          __typename
        }
        roles
        companyId
        company {
          id
          name
          type
          createdAt
          createdByUserId
          deleted
          updatedAt
          organizationCompaniesId
          __typename
        }
        firstName
        lastName
        email
        office
        mobile
        linkedInUrl
        imageUrl
        timeZone
        monthlyUpdates
        generalAnnouncements
        createdAt
        createdByUserId
        createdBy {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        modifications {
          fieldName
          fieldValue
          dataOperation
          modifiedAt
          id
          createdAt
          updatedAt
          __typename
        }
        organizationAdmin {
          nextToken
          __typename
        }
        organizationMember {
          nextToken
          __typename
        }
        deleted
        lastLoginDate
        weeklyDigestNotification
        monthlyDigestNotification
        quarterlyEmailNotification
        annualDigestNotification
        membershipAlertsNotification
        generalEmailNotification
        organizationSupportAdmin {
          nextToken
          __typename
        }
        updatedAt
        organizationContactsId
        __typename
      }
      modifications {
        fieldName
        fieldValue
        dataOperation
        modifiedAt
        modifiedBy {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        id
        createdAt
        updatedAt
        __typename
      }
      supportAdmin {
        items {
          id
          organizationId
          userId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      deleted
      updatedAt
      companyOrganizationsId
      userOrganizationId
      __typename
    }
  }
`;
export const deleteOrganization = /* GraphQL */ `
  mutation DeleteOrganization(
    $input: DeleteOrganizationInput!
    $condition: ModelOrganizationConditionInput
  ) {
    deleteOrganization(input: $input, condition: $condition) {
      id
      name
      organizationType
      groupType
      chairId
      chair {
        id
        name
        type
        organizations {
          nextToken
          __typename
        }
        members {
          nextToken
          __typename
        }
        createdAt
        createdByUserId
        createdBy {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        deleted
        modifications {
          fieldName
          fieldValue
          dataOperation
          modifiedAt
          id
          createdAt
          updatedAt
          __typename
        }
        updatedAt
        organizationCompaniesId
        __typename
      }
      chairContactId
      chairContact {
        id
        cognitoUserId
        termsAgree
        termsAgreeDate
        participationAgreement
        participationAgreementDate
        organization {
          nextToken
          __typename
        }
        roles
        companyId
        company {
          id
          name
          type
          createdAt
          createdByUserId
          deleted
          updatedAt
          organizationCompaniesId
          __typename
        }
        firstName
        lastName
        email
        office
        mobile
        linkedInUrl
        imageUrl
        timeZone
        monthlyUpdates
        generalAnnouncements
        createdAt
        createdByUserId
        createdBy {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        modifications {
          fieldName
          fieldValue
          dataOperation
          modifiedAt
          id
          createdAt
          updatedAt
          __typename
        }
        organizationAdmin {
          nextToken
          __typename
        }
        organizationMember {
          nextToken
          __typename
        }
        deleted
        lastLoginDate
        weeklyDigestNotification
        monthlyDigestNotification
        quarterlyEmailNotification
        annualDigestNotification
        membershipAlertsNotification
        generalEmailNotification
        organizationSupportAdmin {
          nextToken
          __typename
        }
        updatedAt
        organizationContactsId
        __typename
      }
      operatorId
      operator {
        id
        name
        type
        organizations {
          nextToken
          __typename
        }
        members {
          nextToken
          __typename
        }
        createdAt
        createdByUserId
        createdBy {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        deleted
        modifications {
          fieldName
          fieldValue
          dataOperation
          modifiedAt
          id
          createdAt
          updatedAt
          __typename
        }
        updatedAt
        organizationCompaniesId
        __typename
      }
      operatorContactId
      operatorContact {
        id
        cognitoUserId
        termsAgree
        termsAgreeDate
        participationAgreement
        participationAgreementDate
        organization {
          nextToken
          __typename
        }
        roles
        companyId
        company {
          id
          name
          type
          createdAt
          createdByUserId
          deleted
          updatedAt
          organizationCompaniesId
          __typename
        }
        firstName
        lastName
        email
        office
        mobile
        linkedInUrl
        imageUrl
        timeZone
        monthlyUpdates
        generalAnnouncements
        createdAt
        createdByUserId
        createdBy {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        modifications {
          fieldName
          fieldValue
          dataOperation
          modifiedAt
          id
          createdAt
          updatedAt
          __typename
        }
        organizationAdmin {
          nextToken
          __typename
        }
        organizationMember {
          nextToken
          __typename
        }
        deleted
        lastLoginDate
        weeklyDigestNotification
        monthlyDigestNotification
        quarterlyEmailNotification
        annualDigestNotification
        membershipAlertsNotification
        generalEmailNotification
        organizationSupportAdmin {
          nextToken
          __typename
        }
        updatedAt
        organizationContactsId
        __typename
      }
      admins {
        items {
          id
          organizationId
          userId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      airports {
        items {
          id
          organizationId
          airportId
          chairId
          chairContactId
          operatorId
          operatorGeneralManagerId
          secondaryContact
          facilityOwner
          facilityOwnerContact
          legalCounselContact
          legalCounsel
          facilityLocation
          totalCapacityDays
          totalCapacityGallons
          secured
          moExpiration
          moType
          moTypeCustomValue
          leaseExpiration
          leaseType
          leaseTypeCustomValue
          dateLastFinancialSUP
          dateLastA4aOperationalReview
          netInventoryCalculation
          entryFee
          nonMemberRate
          costSharingFormula
          reserveDepositPrebill
          thirdPartyDebt
          memberLoans
          dateLastPropertyAppraisal
          aviationLiabilityLimit
          environmentalLiabilityLimit
          comments
          deleted
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      companies {
        items {
          id
          name
          type
          createdAt
          createdByUserId
          deleted
          updatedAt
          organizationCompaniesId
          __typename
        }
        nextToken
        __typename
      }
      members {
        items {
          id
          organizationId
          userId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      documents {
        items {
          id
          organizationId
          airportId
          categoryType
          documentCategoryId
          bucketType
          title
          description
          publishedByUserId
          publishedDate
          url
          fileSize
          companyId
          createdAt
          createByUserId
          categoryTypeId
          deleted
          updatedAt
          organizationDocumentsId
          documentCategoryDocumentsId
          documentFileTypeId
          __typename
        }
        nextToken
        __typename
      }
      calendar {
        items {
          id
          organizationId
          calendarEventTypeId
          name
          startDateTime
          endDateTime
          description
          location
          website
          groupRateCode
          organizer
          specialRates
          venue
          venueWebSite
          createdAt
          createdByUserId
          modifiedByUserId
          updatedAt
          organizationCalendarId
          __typename
        }
        nextToken
        __typename
      }
      contacts {
        items {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      createdByUserId
      createdBy {
        id
        cognitoUserId
        termsAgree
        termsAgreeDate
        participationAgreement
        participationAgreementDate
        organization {
          nextToken
          __typename
        }
        roles
        companyId
        company {
          id
          name
          type
          createdAt
          createdByUserId
          deleted
          updatedAt
          organizationCompaniesId
          __typename
        }
        firstName
        lastName
        email
        office
        mobile
        linkedInUrl
        imageUrl
        timeZone
        monthlyUpdates
        generalAnnouncements
        createdAt
        createdByUserId
        createdBy {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        modifications {
          fieldName
          fieldValue
          dataOperation
          modifiedAt
          id
          createdAt
          updatedAt
          __typename
        }
        organizationAdmin {
          nextToken
          __typename
        }
        organizationMember {
          nextToken
          __typename
        }
        deleted
        lastLoginDate
        weeklyDigestNotification
        monthlyDigestNotification
        quarterlyEmailNotification
        annualDigestNotification
        membershipAlertsNotification
        generalEmailNotification
        organizationSupportAdmin {
          nextToken
          __typename
        }
        updatedAt
        organizationContactsId
        __typename
      }
      modifications {
        fieldName
        fieldValue
        dataOperation
        modifiedAt
        modifiedBy {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        id
        createdAt
        updatedAt
        __typename
      }
      supportAdmin {
        items {
          id
          organizationId
          userId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      deleted
      updatedAt
      companyOrganizationsId
      userOrganizationId
      __typename
    }
  }
`;
export const createCompany = /* GraphQL */ `
  mutation CreateCompany(
    $input: CreateCompanyInput!
    $condition: ModelCompanyConditionInput
  ) {
    createCompany(input: $input, condition: $condition) {
      id
      name
      type
      organizations {
        items {
          id
          name
          organizationType
          groupType
          chairId
          chairContactId
          operatorId
          operatorContactId
          createdAt
          createdByUserId
          deleted
          updatedAt
          companyOrganizationsId
          userOrganizationId
          __typename
        }
        nextToken
        __typename
      }
      members {
        items {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      createdByUserId
      createdBy {
        id
        cognitoUserId
        termsAgree
        termsAgreeDate
        participationAgreement
        participationAgreementDate
        organization {
          nextToken
          __typename
        }
        roles
        companyId
        company {
          id
          name
          type
          createdAt
          createdByUserId
          deleted
          updatedAt
          organizationCompaniesId
          __typename
        }
        firstName
        lastName
        email
        office
        mobile
        linkedInUrl
        imageUrl
        timeZone
        monthlyUpdates
        generalAnnouncements
        createdAt
        createdByUserId
        createdBy {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        modifications {
          fieldName
          fieldValue
          dataOperation
          modifiedAt
          id
          createdAt
          updatedAt
          __typename
        }
        organizationAdmin {
          nextToken
          __typename
        }
        organizationMember {
          nextToken
          __typename
        }
        deleted
        lastLoginDate
        weeklyDigestNotification
        monthlyDigestNotification
        quarterlyEmailNotification
        annualDigestNotification
        membershipAlertsNotification
        generalEmailNotification
        organizationSupportAdmin {
          nextToken
          __typename
        }
        updatedAt
        organizationContactsId
        __typename
      }
      deleted
      modifications {
        fieldName
        fieldValue
        dataOperation
        modifiedAt
        modifiedBy {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        id
        createdAt
        updatedAt
        __typename
      }
      updatedAt
      organizationCompaniesId
      __typename
    }
  }
`;
export const updateCompany = /* GraphQL */ `
  mutation UpdateCompany(
    $input: UpdateCompanyInput!
    $condition: ModelCompanyConditionInput
  ) {
    updateCompany(input: $input, condition: $condition) {
      id
      name
      type
      organizations {
        items {
          id
          name
          organizationType
          groupType
          chairId
          chairContactId
          operatorId
          operatorContactId
          createdAt
          createdByUserId
          deleted
          updatedAt
          companyOrganizationsId
          userOrganizationId
          __typename
        }
        nextToken
        __typename
      }
      members {
        items {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      createdByUserId
      createdBy {
        id
        cognitoUserId
        termsAgree
        termsAgreeDate
        participationAgreement
        participationAgreementDate
        organization {
          nextToken
          __typename
        }
        roles
        companyId
        company {
          id
          name
          type
          createdAt
          createdByUserId
          deleted
          updatedAt
          organizationCompaniesId
          __typename
        }
        firstName
        lastName
        email
        office
        mobile
        linkedInUrl
        imageUrl
        timeZone
        monthlyUpdates
        generalAnnouncements
        createdAt
        createdByUserId
        createdBy {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        modifications {
          fieldName
          fieldValue
          dataOperation
          modifiedAt
          id
          createdAt
          updatedAt
          __typename
        }
        organizationAdmin {
          nextToken
          __typename
        }
        organizationMember {
          nextToken
          __typename
        }
        deleted
        lastLoginDate
        weeklyDigestNotification
        monthlyDigestNotification
        quarterlyEmailNotification
        annualDigestNotification
        membershipAlertsNotification
        generalEmailNotification
        organizationSupportAdmin {
          nextToken
          __typename
        }
        updatedAt
        organizationContactsId
        __typename
      }
      deleted
      modifications {
        fieldName
        fieldValue
        dataOperation
        modifiedAt
        modifiedBy {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        id
        createdAt
        updatedAt
        __typename
      }
      updatedAt
      organizationCompaniesId
      __typename
    }
  }
`;
export const deleteCompany = /* GraphQL */ `
  mutation DeleteCompany(
    $input: DeleteCompanyInput!
    $condition: ModelCompanyConditionInput
  ) {
    deleteCompany(input: $input, condition: $condition) {
      id
      name
      type
      organizations {
        items {
          id
          name
          organizationType
          groupType
          chairId
          chairContactId
          operatorId
          operatorContactId
          createdAt
          createdByUserId
          deleted
          updatedAt
          companyOrganizationsId
          userOrganizationId
          __typename
        }
        nextToken
        __typename
      }
      members {
        items {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      createdByUserId
      createdBy {
        id
        cognitoUserId
        termsAgree
        termsAgreeDate
        participationAgreement
        participationAgreementDate
        organization {
          nextToken
          __typename
        }
        roles
        companyId
        company {
          id
          name
          type
          createdAt
          createdByUserId
          deleted
          updatedAt
          organizationCompaniesId
          __typename
        }
        firstName
        lastName
        email
        office
        mobile
        linkedInUrl
        imageUrl
        timeZone
        monthlyUpdates
        generalAnnouncements
        createdAt
        createdByUserId
        createdBy {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        modifications {
          fieldName
          fieldValue
          dataOperation
          modifiedAt
          id
          createdAt
          updatedAt
          __typename
        }
        organizationAdmin {
          nextToken
          __typename
        }
        organizationMember {
          nextToken
          __typename
        }
        deleted
        lastLoginDate
        weeklyDigestNotification
        monthlyDigestNotification
        quarterlyEmailNotification
        annualDigestNotification
        membershipAlertsNotification
        generalEmailNotification
        organizationSupportAdmin {
          nextToken
          __typename
        }
        updatedAt
        organizationContactsId
        __typename
      }
      deleted
      modifications {
        fieldName
        fieldValue
        dataOperation
        modifiedAt
        modifiedBy {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        id
        createdAt
        updatedAt
        __typename
      }
      updatedAt
      organizationCompaniesId
      __typename
    }
  }
`;
export const createUser = /* GraphQL */ `
  mutation CreateUser(
    $input: CreateUserInput!
    $condition: ModelUserConditionInput
  ) {
    createUser(input: $input, condition: $condition) {
      id
      cognitoUserId
      termsAgree
      termsAgreeDate
      participationAgreement
      participationAgreementDate
      organization {
        items {
          id
          name
          organizationType
          groupType
          chairId
          chairContactId
          operatorId
          operatorContactId
          createdAt
          createdByUserId
          deleted
          updatedAt
          companyOrganizationsId
          userOrganizationId
          __typename
        }
        nextToken
        __typename
      }
      roles
      companyId
      company {
        id
        name
        type
        organizations {
          nextToken
          __typename
        }
        members {
          nextToken
          __typename
        }
        createdAt
        createdByUserId
        createdBy {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        deleted
        modifications {
          fieldName
          fieldValue
          dataOperation
          modifiedAt
          id
          createdAt
          updatedAt
          __typename
        }
        updatedAt
        organizationCompaniesId
        __typename
      }
      firstName
      lastName
      email
      office
      mobile
      linkedInUrl
      imageUrl
      timeZone
      monthlyUpdates
      generalAnnouncements
      createdAt
      createdByUserId
      createdBy {
        id
        cognitoUserId
        termsAgree
        termsAgreeDate
        participationAgreement
        participationAgreementDate
        organization {
          nextToken
          __typename
        }
        roles
        companyId
        company {
          id
          name
          type
          createdAt
          createdByUserId
          deleted
          updatedAt
          organizationCompaniesId
          __typename
        }
        firstName
        lastName
        email
        office
        mobile
        linkedInUrl
        imageUrl
        timeZone
        monthlyUpdates
        generalAnnouncements
        createdAt
        createdByUserId
        createdBy {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        modifications {
          fieldName
          fieldValue
          dataOperation
          modifiedAt
          id
          createdAt
          updatedAt
          __typename
        }
        organizationAdmin {
          nextToken
          __typename
        }
        organizationMember {
          nextToken
          __typename
        }
        deleted
        lastLoginDate
        weeklyDigestNotification
        monthlyDigestNotification
        quarterlyEmailNotification
        annualDigestNotification
        membershipAlertsNotification
        generalEmailNotification
        organizationSupportAdmin {
          nextToken
          __typename
        }
        updatedAt
        organizationContactsId
        __typename
      }
      modifications {
        fieldName
        fieldValue
        dataOperation
        modifiedAt
        modifiedBy {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        id
        createdAt
        updatedAt
        __typename
      }
      organizationAdmin {
        items {
          id
          organizationId
          userId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      organizationMember {
        items {
          id
          organizationId
          userId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      deleted
      lastLoginDate
      weeklyDigestNotification
      monthlyDigestNotification
      quarterlyEmailNotification
      annualDigestNotification
      membershipAlertsNotification
      generalEmailNotification
      organizationSupportAdmin {
        items {
          id
          organizationId
          userId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      updatedAt
      organizationContactsId
      __typename
    }
  }
`;
export const updateUser = /* GraphQL */ `
  mutation UpdateUser(
    $input: UpdateUserInput!
    $condition: ModelUserConditionInput
  ) {
    updateUser(input: $input, condition: $condition) {
      id
      cognitoUserId
      termsAgree
      termsAgreeDate
      participationAgreement
      participationAgreementDate
      organization {
        items {
          id
          name
          organizationType
          groupType
          chairId
          chairContactId
          operatorId
          operatorContactId
          createdAt
          createdByUserId
          deleted
          updatedAt
          companyOrganizationsId
          userOrganizationId
          __typename
        }
        nextToken
        __typename
      }
      roles
      companyId
      company {
        id
        name
        type
        organizations {
          nextToken
          __typename
        }
        members {
          nextToken
          __typename
        }
        createdAt
        createdByUserId
        createdBy {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        deleted
        modifications {
          fieldName
          fieldValue
          dataOperation
          modifiedAt
          id
          createdAt
          updatedAt
          __typename
        }
        updatedAt
        organizationCompaniesId
        __typename
      }
      firstName
      lastName
      email
      office
      mobile
      linkedInUrl
      imageUrl
      timeZone
      monthlyUpdates
      generalAnnouncements
      createdAt
      createdByUserId
      createdBy {
        id
        cognitoUserId
        termsAgree
        termsAgreeDate
        participationAgreement
        participationAgreementDate
        organization {
          nextToken
          __typename
        }
        roles
        companyId
        company {
          id
          name
          type
          createdAt
          createdByUserId
          deleted
          updatedAt
          organizationCompaniesId
          __typename
        }
        firstName
        lastName
        email
        office
        mobile
        linkedInUrl
        imageUrl
        timeZone
        monthlyUpdates
        generalAnnouncements
        createdAt
        createdByUserId
        createdBy {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        modifications {
          fieldName
          fieldValue
          dataOperation
          modifiedAt
          id
          createdAt
          updatedAt
          __typename
        }
        organizationAdmin {
          nextToken
          __typename
        }
        organizationMember {
          nextToken
          __typename
        }
        deleted
        lastLoginDate
        weeklyDigestNotification
        monthlyDigestNotification
        quarterlyEmailNotification
        annualDigestNotification
        membershipAlertsNotification
        generalEmailNotification
        organizationSupportAdmin {
          nextToken
          __typename
        }
        updatedAt
        organizationContactsId
        __typename
      }
      modifications {
        fieldName
        fieldValue
        dataOperation
        modifiedAt
        modifiedBy {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        id
        createdAt
        updatedAt
        __typename
      }
      organizationAdmin {
        items {
          id
          organizationId
          userId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      organizationMember {
        items {
          id
          organizationId
          userId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      deleted
      lastLoginDate
      weeklyDigestNotification
      monthlyDigestNotification
      quarterlyEmailNotification
      annualDigestNotification
      membershipAlertsNotification
      generalEmailNotification
      organizationSupportAdmin {
        items {
          id
          organizationId
          userId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      updatedAt
      organizationContactsId
      __typename
    }
  }
`;
export const deleteUser = /* GraphQL */ `
  mutation DeleteUser(
    $input: DeleteUserInput!
    $condition: ModelUserConditionInput
  ) {
    deleteUser(input: $input, condition: $condition) {
      id
      cognitoUserId
      termsAgree
      termsAgreeDate
      participationAgreement
      participationAgreementDate
      organization {
        items {
          id
          name
          organizationType
          groupType
          chairId
          chairContactId
          operatorId
          operatorContactId
          createdAt
          createdByUserId
          deleted
          updatedAt
          companyOrganizationsId
          userOrganizationId
          __typename
        }
        nextToken
        __typename
      }
      roles
      companyId
      company {
        id
        name
        type
        organizations {
          nextToken
          __typename
        }
        members {
          nextToken
          __typename
        }
        createdAt
        createdByUserId
        createdBy {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        deleted
        modifications {
          fieldName
          fieldValue
          dataOperation
          modifiedAt
          id
          createdAt
          updatedAt
          __typename
        }
        updatedAt
        organizationCompaniesId
        __typename
      }
      firstName
      lastName
      email
      office
      mobile
      linkedInUrl
      imageUrl
      timeZone
      monthlyUpdates
      generalAnnouncements
      createdAt
      createdByUserId
      createdBy {
        id
        cognitoUserId
        termsAgree
        termsAgreeDate
        participationAgreement
        participationAgreementDate
        organization {
          nextToken
          __typename
        }
        roles
        companyId
        company {
          id
          name
          type
          createdAt
          createdByUserId
          deleted
          updatedAt
          organizationCompaniesId
          __typename
        }
        firstName
        lastName
        email
        office
        mobile
        linkedInUrl
        imageUrl
        timeZone
        monthlyUpdates
        generalAnnouncements
        createdAt
        createdByUserId
        createdBy {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        modifications {
          fieldName
          fieldValue
          dataOperation
          modifiedAt
          id
          createdAt
          updatedAt
          __typename
        }
        organizationAdmin {
          nextToken
          __typename
        }
        organizationMember {
          nextToken
          __typename
        }
        deleted
        lastLoginDate
        weeklyDigestNotification
        monthlyDigestNotification
        quarterlyEmailNotification
        annualDigestNotification
        membershipAlertsNotification
        generalEmailNotification
        organizationSupportAdmin {
          nextToken
          __typename
        }
        updatedAt
        organizationContactsId
        __typename
      }
      modifications {
        fieldName
        fieldValue
        dataOperation
        modifiedAt
        modifiedBy {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        id
        createdAt
        updatedAt
        __typename
      }
      organizationAdmin {
        items {
          id
          organizationId
          userId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      organizationMember {
        items {
          id
          organizationId
          userId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      deleted
      lastLoginDate
      weeklyDigestNotification
      monthlyDigestNotification
      quarterlyEmailNotification
      annualDigestNotification
      membershipAlertsNotification
      generalEmailNotification
      organizationSupportAdmin {
        items {
          id
          organizationId
          userId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      updatedAt
      organizationContactsId
      __typename
    }
  }
`;
export const createDocument = /* GraphQL */ `
  mutation CreateDocument(
    $input: CreateDocumentInput!
    $condition: ModelDocumentConditionInput
  ) {
    createDocument(input: $input, condition: $condition) {
      id
      organizationId
      organization {
        id
        name
        organizationType
        groupType
        chairId
        chair {
          id
          name
          type
          createdAt
          createdByUserId
          deleted
          updatedAt
          organizationCompaniesId
          __typename
        }
        chairContactId
        chairContact {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        operatorId
        operator {
          id
          name
          type
          createdAt
          createdByUserId
          deleted
          updatedAt
          organizationCompaniesId
          __typename
        }
        operatorContactId
        operatorContact {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        admins {
          nextToken
          __typename
        }
        airports {
          nextToken
          __typename
        }
        companies {
          nextToken
          __typename
        }
        members {
          nextToken
          __typename
        }
        documents {
          nextToken
          __typename
        }
        calendar {
          nextToken
          __typename
        }
        contacts {
          nextToken
          __typename
        }
        createdAt
        createdByUserId
        createdBy {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        modifications {
          fieldName
          fieldValue
          dataOperation
          modifiedAt
          id
          createdAt
          updatedAt
          __typename
        }
        supportAdmin {
          nextToken
          __typename
        }
        deleted
        updatedAt
        companyOrganizationsId
        userOrganizationId
        __typename
      }
      airportId
      airport {
        id
        name
        code
        oldCode
        facility
        region
        state
        place {
          terminal
          gate
          lat
          lon
          __typename
        }
        consortiumGroup {
          nextToken
          __typename
        }
        consortiumType
        documents {
          nextToken
          __typename
        }
        chairId
        chair {
          id
          name
          type
          createdAt
          createdByUserId
          deleted
          updatedAt
          organizationCompaniesId
          __typename
        }
        chairContactId
        chairContact {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        operatorId
        operator {
          id
          name
          type
          createdAt
          createdByUserId
          deleted
          updatedAt
          organizationCompaniesId
          __typename
        }
        operatorGeneralManagerId
        operatorGeneralManager {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        secondaryContactId
        secondaryContact {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        facilityOwnerId
        facilityOwner {
          id
          name
          type
          createdAt
          createdByUserId
          deleted
          updatedAt
          organizationCompaniesId
          __typename
        }
        facilityOwnerContactId
        facilityOwnerContact {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        inventoryAccounting
        deliveryToPlane {
          nextToken
          __typename
        }
        deliveryToFacility {
          nextToken
          __typename
        }
        storage {
          nextToken
          __typename
        }
        createdAt
        createdBy {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        modifications {
          fieldName
          fieldValue
          dataOperation
          modifiedAt
          id
          createdAt
          updatedAt
          __typename
        }
        organizationAirportsId
        deleted
        updatedAt
        __typename
      }
      categoryType
      documentCategoryId
      documentCategory {
        id
        name
        type
        bucketType
        documents {
          nextToken
          __typename
        }
        description
        createdAt
        createdByUserId
        createdBy {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        deleted
        modifications {
          fieldName
          fieldValue
          dataOperation
          modifiedAt
          id
          createdAt
          updatedAt
          __typename
        }
        updatedAt
        __typename
      }
      bucketType
      title
      description
      publishedByUserId
      publishedBy {
        id
        cognitoUserId
        termsAgree
        termsAgreeDate
        participationAgreement
        participationAgreementDate
        organization {
          nextToken
          __typename
        }
        roles
        companyId
        company {
          id
          name
          type
          createdAt
          createdByUserId
          deleted
          updatedAt
          organizationCompaniesId
          __typename
        }
        firstName
        lastName
        email
        office
        mobile
        linkedInUrl
        imageUrl
        timeZone
        monthlyUpdates
        generalAnnouncements
        createdAt
        createdByUserId
        createdBy {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        modifications {
          fieldName
          fieldValue
          dataOperation
          modifiedAt
          id
          createdAt
          updatedAt
          __typename
        }
        organizationAdmin {
          nextToken
          __typename
        }
        organizationMember {
          nextToken
          __typename
        }
        deleted
        lastLoginDate
        weeklyDigestNotification
        monthlyDigestNotification
        quarterlyEmailNotification
        annualDigestNotification
        membershipAlertsNotification
        generalEmailNotification
        organizationSupportAdmin {
          nextToken
          __typename
        }
        updatedAt
        organizationContactsId
        __typename
      }
      publishedDate
      url
      fileSize
      fileType {
        id
        name
        description
        createdAt
        updatedAt
        __typename
      }
      companyId
      createdAt
      createByUserId
      createdBy {
        id
        cognitoUserId
        termsAgree
        termsAgreeDate
        participationAgreement
        participationAgreementDate
        organization {
          nextToken
          __typename
        }
        roles
        companyId
        company {
          id
          name
          type
          createdAt
          createdByUserId
          deleted
          updatedAt
          organizationCompaniesId
          __typename
        }
        firstName
        lastName
        email
        office
        mobile
        linkedInUrl
        imageUrl
        timeZone
        monthlyUpdates
        generalAnnouncements
        createdAt
        createdByUserId
        createdBy {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        modifications {
          fieldName
          fieldValue
          dataOperation
          modifiedAt
          id
          createdAt
          updatedAt
          __typename
        }
        organizationAdmin {
          nextToken
          __typename
        }
        organizationMember {
          nextToken
          __typename
        }
        deleted
        lastLoginDate
        weeklyDigestNotification
        monthlyDigestNotification
        quarterlyEmailNotification
        annualDigestNotification
        membershipAlertsNotification
        generalEmailNotification
        organizationSupportAdmin {
          nextToken
          __typename
        }
        updatedAt
        organizationContactsId
        __typename
      }
      categoryTypeId
      category {
        id
        name
        type
        bucketType
        documents {
          nextToken
          __typename
        }
        description
        createdAt
        createdByUserId
        createdBy {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        deleted
        modifications {
          fieldName
          fieldValue
          dataOperation
          modifiedAt
          id
          createdAt
          updatedAt
          __typename
        }
        updatedAt
        __typename
      }
      deleted
      modifications {
        fieldName
        fieldValue
        dataOperation
        modifiedAt
        modifiedBy {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        id
        createdAt
        updatedAt
        __typename
      }
      updatedAt
      organizationDocumentsId
      documentCategoryDocumentsId
      documentFileTypeId
      __typename
    }
  }
`;
export const updateDocument = /* GraphQL */ `
  mutation UpdateDocument(
    $input: UpdateDocumentInput!
    $condition: ModelDocumentConditionInput
  ) {
    updateDocument(input: $input, condition: $condition) {
      id
      organizationId
      organization {
        id
        name
        organizationType
        groupType
        chairId
        chair {
          id
          name
          type
          createdAt
          createdByUserId
          deleted
          updatedAt
          organizationCompaniesId
          __typename
        }
        chairContactId
        chairContact {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        operatorId
        operator {
          id
          name
          type
          createdAt
          createdByUserId
          deleted
          updatedAt
          organizationCompaniesId
          __typename
        }
        operatorContactId
        operatorContact {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        admins {
          nextToken
          __typename
        }
        airports {
          nextToken
          __typename
        }
        companies {
          nextToken
          __typename
        }
        members {
          nextToken
          __typename
        }
        documents {
          nextToken
          __typename
        }
        calendar {
          nextToken
          __typename
        }
        contacts {
          nextToken
          __typename
        }
        createdAt
        createdByUserId
        createdBy {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        modifications {
          fieldName
          fieldValue
          dataOperation
          modifiedAt
          id
          createdAt
          updatedAt
          __typename
        }
        supportAdmin {
          nextToken
          __typename
        }
        deleted
        updatedAt
        companyOrganizationsId
        userOrganizationId
        __typename
      }
      airportId
      airport {
        id
        name
        code
        oldCode
        facility
        region
        state
        place {
          terminal
          gate
          lat
          lon
          __typename
        }
        consortiumGroup {
          nextToken
          __typename
        }
        consortiumType
        documents {
          nextToken
          __typename
        }
        chairId
        chair {
          id
          name
          type
          createdAt
          createdByUserId
          deleted
          updatedAt
          organizationCompaniesId
          __typename
        }
        chairContactId
        chairContact {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        operatorId
        operator {
          id
          name
          type
          createdAt
          createdByUserId
          deleted
          updatedAt
          organizationCompaniesId
          __typename
        }
        operatorGeneralManagerId
        operatorGeneralManager {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        secondaryContactId
        secondaryContact {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        facilityOwnerId
        facilityOwner {
          id
          name
          type
          createdAt
          createdByUserId
          deleted
          updatedAt
          organizationCompaniesId
          __typename
        }
        facilityOwnerContactId
        facilityOwnerContact {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        inventoryAccounting
        deliveryToPlane {
          nextToken
          __typename
        }
        deliveryToFacility {
          nextToken
          __typename
        }
        storage {
          nextToken
          __typename
        }
        createdAt
        createdBy {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        modifications {
          fieldName
          fieldValue
          dataOperation
          modifiedAt
          id
          createdAt
          updatedAt
          __typename
        }
        organizationAirportsId
        deleted
        updatedAt
        __typename
      }
      categoryType
      documentCategoryId
      documentCategory {
        id
        name
        type
        bucketType
        documents {
          nextToken
          __typename
        }
        description
        createdAt
        createdByUserId
        createdBy {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        deleted
        modifications {
          fieldName
          fieldValue
          dataOperation
          modifiedAt
          id
          createdAt
          updatedAt
          __typename
        }
        updatedAt
        __typename
      }
      bucketType
      title
      description
      publishedByUserId
      publishedBy {
        id
        cognitoUserId
        termsAgree
        termsAgreeDate
        participationAgreement
        participationAgreementDate
        organization {
          nextToken
          __typename
        }
        roles
        companyId
        company {
          id
          name
          type
          createdAt
          createdByUserId
          deleted
          updatedAt
          organizationCompaniesId
          __typename
        }
        firstName
        lastName
        email
        office
        mobile
        linkedInUrl
        imageUrl
        timeZone
        monthlyUpdates
        generalAnnouncements
        createdAt
        createdByUserId
        createdBy {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        modifications {
          fieldName
          fieldValue
          dataOperation
          modifiedAt
          id
          createdAt
          updatedAt
          __typename
        }
        organizationAdmin {
          nextToken
          __typename
        }
        organizationMember {
          nextToken
          __typename
        }
        deleted
        lastLoginDate
        weeklyDigestNotification
        monthlyDigestNotification
        quarterlyEmailNotification
        annualDigestNotification
        membershipAlertsNotification
        generalEmailNotification
        organizationSupportAdmin {
          nextToken
          __typename
        }
        updatedAt
        organizationContactsId
        __typename
      }
      publishedDate
      url
      fileSize
      fileType {
        id
        name
        description
        createdAt
        updatedAt
        __typename
      }
      companyId
      createdAt
      createByUserId
      createdBy {
        id
        cognitoUserId
        termsAgree
        termsAgreeDate
        participationAgreement
        participationAgreementDate
        organization {
          nextToken
          __typename
        }
        roles
        companyId
        company {
          id
          name
          type
          createdAt
          createdByUserId
          deleted
          updatedAt
          organizationCompaniesId
          __typename
        }
        firstName
        lastName
        email
        office
        mobile
        linkedInUrl
        imageUrl
        timeZone
        monthlyUpdates
        generalAnnouncements
        createdAt
        createdByUserId
        createdBy {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        modifications {
          fieldName
          fieldValue
          dataOperation
          modifiedAt
          id
          createdAt
          updatedAt
          __typename
        }
        organizationAdmin {
          nextToken
          __typename
        }
        organizationMember {
          nextToken
          __typename
        }
        deleted
        lastLoginDate
        weeklyDigestNotification
        monthlyDigestNotification
        quarterlyEmailNotification
        annualDigestNotification
        membershipAlertsNotification
        generalEmailNotification
        organizationSupportAdmin {
          nextToken
          __typename
        }
        updatedAt
        organizationContactsId
        __typename
      }
      categoryTypeId
      category {
        id
        name
        type
        bucketType
        documents {
          nextToken
          __typename
        }
        description
        createdAt
        createdByUserId
        createdBy {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        deleted
        modifications {
          fieldName
          fieldValue
          dataOperation
          modifiedAt
          id
          createdAt
          updatedAt
          __typename
        }
        updatedAt
        __typename
      }
      deleted
      modifications {
        fieldName
        fieldValue
        dataOperation
        modifiedAt
        modifiedBy {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        id
        createdAt
        updatedAt
        __typename
      }
      updatedAt
      organizationDocumentsId
      documentCategoryDocumentsId
      documentFileTypeId
      __typename
    }
  }
`;
export const deleteDocument = /* GraphQL */ `
  mutation DeleteDocument(
    $input: DeleteDocumentInput!
    $condition: ModelDocumentConditionInput
  ) {
    deleteDocument(input: $input, condition: $condition) {
      id
      organizationId
      organization {
        id
        name
        organizationType
        groupType
        chairId
        chair {
          id
          name
          type
          createdAt
          createdByUserId
          deleted
          updatedAt
          organizationCompaniesId
          __typename
        }
        chairContactId
        chairContact {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        operatorId
        operator {
          id
          name
          type
          createdAt
          createdByUserId
          deleted
          updatedAt
          organizationCompaniesId
          __typename
        }
        operatorContactId
        operatorContact {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        admins {
          nextToken
          __typename
        }
        airports {
          nextToken
          __typename
        }
        companies {
          nextToken
          __typename
        }
        members {
          nextToken
          __typename
        }
        documents {
          nextToken
          __typename
        }
        calendar {
          nextToken
          __typename
        }
        contacts {
          nextToken
          __typename
        }
        createdAt
        createdByUserId
        createdBy {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        modifications {
          fieldName
          fieldValue
          dataOperation
          modifiedAt
          id
          createdAt
          updatedAt
          __typename
        }
        supportAdmin {
          nextToken
          __typename
        }
        deleted
        updatedAt
        companyOrganizationsId
        userOrganizationId
        __typename
      }
      airportId
      airport {
        id
        name
        code
        oldCode
        facility
        region
        state
        place {
          terminal
          gate
          lat
          lon
          __typename
        }
        consortiumGroup {
          nextToken
          __typename
        }
        consortiumType
        documents {
          nextToken
          __typename
        }
        chairId
        chair {
          id
          name
          type
          createdAt
          createdByUserId
          deleted
          updatedAt
          organizationCompaniesId
          __typename
        }
        chairContactId
        chairContact {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        operatorId
        operator {
          id
          name
          type
          createdAt
          createdByUserId
          deleted
          updatedAt
          organizationCompaniesId
          __typename
        }
        operatorGeneralManagerId
        operatorGeneralManager {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        secondaryContactId
        secondaryContact {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        facilityOwnerId
        facilityOwner {
          id
          name
          type
          createdAt
          createdByUserId
          deleted
          updatedAt
          organizationCompaniesId
          __typename
        }
        facilityOwnerContactId
        facilityOwnerContact {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        inventoryAccounting
        deliveryToPlane {
          nextToken
          __typename
        }
        deliveryToFacility {
          nextToken
          __typename
        }
        storage {
          nextToken
          __typename
        }
        createdAt
        createdBy {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        modifications {
          fieldName
          fieldValue
          dataOperation
          modifiedAt
          id
          createdAt
          updatedAt
          __typename
        }
        organizationAirportsId
        deleted
        updatedAt
        __typename
      }
      categoryType
      documentCategoryId
      documentCategory {
        id
        name
        type
        bucketType
        documents {
          nextToken
          __typename
        }
        description
        createdAt
        createdByUserId
        createdBy {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        deleted
        modifications {
          fieldName
          fieldValue
          dataOperation
          modifiedAt
          id
          createdAt
          updatedAt
          __typename
        }
        updatedAt
        __typename
      }
      bucketType
      title
      description
      publishedByUserId
      publishedBy {
        id
        cognitoUserId
        termsAgree
        termsAgreeDate
        participationAgreement
        participationAgreementDate
        organization {
          nextToken
          __typename
        }
        roles
        companyId
        company {
          id
          name
          type
          createdAt
          createdByUserId
          deleted
          updatedAt
          organizationCompaniesId
          __typename
        }
        firstName
        lastName
        email
        office
        mobile
        linkedInUrl
        imageUrl
        timeZone
        monthlyUpdates
        generalAnnouncements
        createdAt
        createdByUserId
        createdBy {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        modifications {
          fieldName
          fieldValue
          dataOperation
          modifiedAt
          id
          createdAt
          updatedAt
          __typename
        }
        organizationAdmin {
          nextToken
          __typename
        }
        organizationMember {
          nextToken
          __typename
        }
        deleted
        lastLoginDate
        weeklyDigestNotification
        monthlyDigestNotification
        quarterlyEmailNotification
        annualDigestNotification
        membershipAlertsNotification
        generalEmailNotification
        organizationSupportAdmin {
          nextToken
          __typename
        }
        updatedAt
        organizationContactsId
        __typename
      }
      publishedDate
      url
      fileSize
      fileType {
        id
        name
        description
        createdAt
        updatedAt
        __typename
      }
      companyId
      createdAt
      createByUserId
      createdBy {
        id
        cognitoUserId
        termsAgree
        termsAgreeDate
        participationAgreement
        participationAgreementDate
        organization {
          nextToken
          __typename
        }
        roles
        companyId
        company {
          id
          name
          type
          createdAt
          createdByUserId
          deleted
          updatedAt
          organizationCompaniesId
          __typename
        }
        firstName
        lastName
        email
        office
        mobile
        linkedInUrl
        imageUrl
        timeZone
        monthlyUpdates
        generalAnnouncements
        createdAt
        createdByUserId
        createdBy {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        modifications {
          fieldName
          fieldValue
          dataOperation
          modifiedAt
          id
          createdAt
          updatedAt
          __typename
        }
        organizationAdmin {
          nextToken
          __typename
        }
        organizationMember {
          nextToken
          __typename
        }
        deleted
        lastLoginDate
        weeklyDigestNotification
        monthlyDigestNotification
        quarterlyEmailNotification
        annualDigestNotification
        membershipAlertsNotification
        generalEmailNotification
        organizationSupportAdmin {
          nextToken
          __typename
        }
        updatedAt
        organizationContactsId
        __typename
      }
      categoryTypeId
      category {
        id
        name
        type
        bucketType
        documents {
          nextToken
          __typename
        }
        description
        createdAt
        createdByUserId
        createdBy {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        deleted
        modifications {
          fieldName
          fieldValue
          dataOperation
          modifiedAt
          id
          createdAt
          updatedAt
          __typename
        }
        updatedAt
        __typename
      }
      deleted
      modifications {
        fieldName
        fieldValue
        dataOperation
        modifiedAt
        modifiedBy {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        id
        createdAt
        updatedAt
        __typename
      }
      updatedAt
      organizationDocumentsId
      documentCategoryDocumentsId
      documentFileTypeId
      __typename
    }
  }
`;
export const createFileType = /* GraphQL */ `
  mutation CreateFileType(
    $input: CreateFileTypeInput!
    $condition: ModelFileTypeConditionInput
  ) {
    createFileType(input: $input, condition: $condition) {
      id
      name
      description
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateFileType = /* GraphQL */ `
  mutation UpdateFileType(
    $input: UpdateFileTypeInput!
    $condition: ModelFileTypeConditionInput
  ) {
    updateFileType(input: $input, condition: $condition) {
      id
      name
      description
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteFileType = /* GraphQL */ `
  mutation DeleteFileType(
    $input: DeleteFileTypeInput!
    $condition: ModelFileTypeConditionInput
  ) {
    deleteFileType(input: $input, condition: $condition) {
      id
      name
      description
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createDocumentCategory = /* GraphQL */ `
  mutation CreateDocumentCategory(
    $input: CreateDocumentCategoryInput!
    $condition: ModelDocumentCategoryConditionInput
  ) {
    createDocumentCategory(input: $input, condition: $condition) {
      id
      name
      type
      bucketType
      documents {
        items {
          id
          organizationId
          airportId
          categoryType
          documentCategoryId
          bucketType
          title
          description
          publishedByUserId
          publishedDate
          url
          fileSize
          companyId
          createdAt
          createByUserId
          categoryTypeId
          deleted
          updatedAt
          organizationDocumentsId
          documentCategoryDocumentsId
          documentFileTypeId
          __typename
        }
        nextToken
        __typename
      }
      description
      createdAt
      createdByUserId
      createdBy {
        id
        cognitoUserId
        termsAgree
        termsAgreeDate
        participationAgreement
        participationAgreementDate
        organization {
          nextToken
          __typename
        }
        roles
        companyId
        company {
          id
          name
          type
          createdAt
          createdByUserId
          deleted
          updatedAt
          organizationCompaniesId
          __typename
        }
        firstName
        lastName
        email
        office
        mobile
        linkedInUrl
        imageUrl
        timeZone
        monthlyUpdates
        generalAnnouncements
        createdAt
        createdByUserId
        createdBy {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        modifications {
          fieldName
          fieldValue
          dataOperation
          modifiedAt
          id
          createdAt
          updatedAt
          __typename
        }
        organizationAdmin {
          nextToken
          __typename
        }
        organizationMember {
          nextToken
          __typename
        }
        deleted
        lastLoginDate
        weeklyDigestNotification
        monthlyDigestNotification
        quarterlyEmailNotification
        annualDigestNotification
        membershipAlertsNotification
        generalEmailNotification
        organizationSupportAdmin {
          nextToken
          __typename
        }
        updatedAt
        organizationContactsId
        __typename
      }
      deleted
      modifications {
        fieldName
        fieldValue
        dataOperation
        modifiedAt
        modifiedBy {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        id
        createdAt
        updatedAt
        __typename
      }
      updatedAt
      __typename
    }
  }
`;
export const updateDocumentCategory = /* GraphQL */ `
  mutation UpdateDocumentCategory(
    $input: UpdateDocumentCategoryInput!
    $condition: ModelDocumentCategoryConditionInput
  ) {
    updateDocumentCategory(input: $input, condition: $condition) {
      id
      name
      type
      bucketType
      documents {
        items {
          id
          organizationId
          airportId
          categoryType
          documentCategoryId
          bucketType
          title
          description
          publishedByUserId
          publishedDate
          url
          fileSize
          companyId
          createdAt
          createByUserId
          categoryTypeId
          deleted
          updatedAt
          organizationDocumentsId
          documentCategoryDocumentsId
          documentFileTypeId
          __typename
        }
        nextToken
        __typename
      }
      description
      createdAt
      createdByUserId
      createdBy {
        id
        cognitoUserId
        termsAgree
        termsAgreeDate
        participationAgreement
        participationAgreementDate
        organization {
          nextToken
          __typename
        }
        roles
        companyId
        company {
          id
          name
          type
          createdAt
          createdByUserId
          deleted
          updatedAt
          organizationCompaniesId
          __typename
        }
        firstName
        lastName
        email
        office
        mobile
        linkedInUrl
        imageUrl
        timeZone
        monthlyUpdates
        generalAnnouncements
        createdAt
        createdByUserId
        createdBy {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        modifications {
          fieldName
          fieldValue
          dataOperation
          modifiedAt
          id
          createdAt
          updatedAt
          __typename
        }
        organizationAdmin {
          nextToken
          __typename
        }
        organizationMember {
          nextToken
          __typename
        }
        deleted
        lastLoginDate
        weeklyDigestNotification
        monthlyDigestNotification
        quarterlyEmailNotification
        annualDigestNotification
        membershipAlertsNotification
        generalEmailNotification
        organizationSupportAdmin {
          nextToken
          __typename
        }
        updatedAt
        organizationContactsId
        __typename
      }
      deleted
      modifications {
        fieldName
        fieldValue
        dataOperation
        modifiedAt
        modifiedBy {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        id
        createdAt
        updatedAt
        __typename
      }
      updatedAt
      __typename
    }
  }
`;
export const deleteDocumentCategory = /* GraphQL */ `
  mutation DeleteDocumentCategory(
    $input: DeleteDocumentCategoryInput!
    $condition: ModelDocumentCategoryConditionInput
  ) {
    deleteDocumentCategory(input: $input, condition: $condition) {
      id
      name
      type
      bucketType
      documents {
        items {
          id
          organizationId
          airportId
          categoryType
          documentCategoryId
          bucketType
          title
          description
          publishedByUserId
          publishedDate
          url
          fileSize
          companyId
          createdAt
          createByUserId
          categoryTypeId
          deleted
          updatedAt
          organizationDocumentsId
          documentCategoryDocumentsId
          documentFileTypeId
          __typename
        }
        nextToken
        __typename
      }
      description
      createdAt
      createdByUserId
      createdBy {
        id
        cognitoUserId
        termsAgree
        termsAgreeDate
        participationAgreement
        participationAgreementDate
        organization {
          nextToken
          __typename
        }
        roles
        companyId
        company {
          id
          name
          type
          createdAt
          createdByUserId
          deleted
          updatedAt
          organizationCompaniesId
          __typename
        }
        firstName
        lastName
        email
        office
        mobile
        linkedInUrl
        imageUrl
        timeZone
        monthlyUpdates
        generalAnnouncements
        createdAt
        createdByUserId
        createdBy {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        modifications {
          fieldName
          fieldValue
          dataOperation
          modifiedAt
          id
          createdAt
          updatedAt
          __typename
        }
        organizationAdmin {
          nextToken
          __typename
        }
        organizationMember {
          nextToken
          __typename
        }
        deleted
        lastLoginDate
        weeklyDigestNotification
        monthlyDigestNotification
        quarterlyEmailNotification
        annualDigestNotification
        membershipAlertsNotification
        generalEmailNotification
        organizationSupportAdmin {
          nextToken
          __typename
        }
        updatedAt
        organizationContactsId
        __typename
      }
      deleted
      modifications {
        fieldName
        fieldValue
        dataOperation
        modifiedAt
        modifiedBy {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        id
        createdAt
        updatedAt
        __typename
      }
      updatedAt
      __typename
    }
  }
`;
export const createCalendar = /* GraphQL */ `
  mutation CreateCalendar(
    $input: CreateCalendarInput!
    $condition: ModelCalendarConditionInput
  ) {
    createCalendar(input: $input, condition: $condition) {
      id
      organizationId
      organization {
        id
        name
        organizationType
        groupType
        chairId
        chair {
          id
          name
          type
          createdAt
          createdByUserId
          deleted
          updatedAt
          organizationCompaniesId
          __typename
        }
        chairContactId
        chairContact {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        operatorId
        operator {
          id
          name
          type
          createdAt
          createdByUserId
          deleted
          updatedAt
          organizationCompaniesId
          __typename
        }
        operatorContactId
        operatorContact {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        admins {
          nextToken
          __typename
        }
        airports {
          nextToken
          __typename
        }
        companies {
          nextToken
          __typename
        }
        members {
          nextToken
          __typename
        }
        documents {
          nextToken
          __typename
        }
        calendar {
          nextToken
          __typename
        }
        contacts {
          nextToken
          __typename
        }
        createdAt
        createdByUserId
        createdBy {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        modifications {
          fieldName
          fieldValue
          dataOperation
          modifiedAt
          id
          createdAt
          updatedAt
          __typename
        }
        supportAdmin {
          nextToken
          __typename
        }
        deleted
        updatedAt
        companyOrganizationsId
        userOrganizationId
        __typename
      }
      calendarEventTypeId
      calendarEventType {
        id
        name
        description
        createdAt
        createdBy {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        modifications {
          fieldName
          fieldValue
          dataOperation
          modifiedAt
          id
          createdAt
          updatedAt
          __typename
        }
        updatedAt
        __typename
      }
      name
      startDateTime
      endDateTime
      description
      location
      website
      groupRateCode
      organizer
      specialRates
      venue
      venueWebSite
      createdAt
      createdByUserId
      createdBy {
        id
        cognitoUserId
        termsAgree
        termsAgreeDate
        participationAgreement
        participationAgreementDate
        organization {
          nextToken
          __typename
        }
        roles
        companyId
        company {
          id
          name
          type
          createdAt
          createdByUserId
          deleted
          updatedAt
          organizationCompaniesId
          __typename
        }
        firstName
        lastName
        email
        office
        mobile
        linkedInUrl
        imageUrl
        timeZone
        monthlyUpdates
        generalAnnouncements
        createdAt
        createdByUserId
        createdBy {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        modifications {
          fieldName
          fieldValue
          dataOperation
          modifiedAt
          id
          createdAt
          updatedAt
          __typename
        }
        organizationAdmin {
          nextToken
          __typename
        }
        organizationMember {
          nextToken
          __typename
        }
        deleted
        lastLoginDate
        weeklyDigestNotification
        monthlyDigestNotification
        quarterlyEmailNotification
        annualDigestNotification
        membershipAlertsNotification
        generalEmailNotification
        organizationSupportAdmin {
          nextToken
          __typename
        }
        updatedAt
        organizationContactsId
        __typename
      }
      modifiedByUserId
      modifiedBy {
        id
        cognitoUserId
        termsAgree
        termsAgreeDate
        participationAgreement
        participationAgreementDate
        organization {
          nextToken
          __typename
        }
        roles
        companyId
        company {
          id
          name
          type
          createdAt
          createdByUserId
          deleted
          updatedAt
          organizationCompaniesId
          __typename
        }
        firstName
        lastName
        email
        office
        mobile
        linkedInUrl
        imageUrl
        timeZone
        monthlyUpdates
        generalAnnouncements
        createdAt
        createdByUserId
        createdBy {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        modifications {
          fieldName
          fieldValue
          dataOperation
          modifiedAt
          id
          createdAt
          updatedAt
          __typename
        }
        organizationAdmin {
          nextToken
          __typename
        }
        organizationMember {
          nextToken
          __typename
        }
        deleted
        lastLoginDate
        weeklyDigestNotification
        monthlyDigestNotification
        quarterlyEmailNotification
        annualDigestNotification
        membershipAlertsNotification
        generalEmailNotification
        organizationSupportAdmin {
          nextToken
          __typename
        }
        updatedAt
        organizationContactsId
        __typename
      }
      modifications {
        fieldName
        fieldValue
        dataOperation
        modifiedAt
        modifiedBy {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        id
        createdAt
        updatedAt
        __typename
      }
      updatedAt
      organizationCalendarId
      __typename
    }
  }
`;
export const updateCalendar = /* GraphQL */ `
  mutation UpdateCalendar(
    $input: UpdateCalendarInput!
    $condition: ModelCalendarConditionInput
  ) {
    updateCalendar(input: $input, condition: $condition) {
      id
      organizationId
      organization {
        id
        name
        organizationType
        groupType
        chairId
        chair {
          id
          name
          type
          createdAt
          createdByUserId
          deleted
          updatedAt
          organizationCompaniesId
          __typename
        }
        chairContactId
        chairContact {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        operatorId
        operator {
          id
          name
          type
          createdAt
          createdByUserId
          deleted
          updatedAt
          organizationCompaniesId
          __typename
        }
        operatorContactId
        operatorContact {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        admins {
          nextToken
          __typename
        }
        airports {
          nextToken
          __typename
        }
        companies {
          nextToken
          __typename
        }
        members {
          nextToken
          __typename
        }
        documents {
          nextToken
          __typename
        }
        calendar {
          nextToken
          __typename
        }
        contacts {
          nextToken
          __typename
        }
        createdAt
        createdByUserId
        createdBy {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        modifications {
          fieldName
          fieldValue
          dataOperation
          modifiedAt
          id
          createdAt
          updatedAt
          __typename
        }
        supportAdmin {
          nextToken
          __typename
        }
        deleted
        updatedAt
        companyOrganizationsId
        userOrganizationId
        __typename
      }
      calendarEventTypeId
      calendarEventType {
        id
        name
        description
        createdAt
        createdBy {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        modifications {
          fieldName
          fieldValue
          dataOperation
          modifiedAt
          id
          createdAt
          updatedAt
          __typename
        }
        updatedAt
        __typename
      }
      name
      startDateTime
      endDateTime
      description
      location
      website
      groupRateCode
      organizer
      specialRates
      venue
      venueWebSite
      createdAt
      createdByUserId
      createdBy {
        id
        cognitoUserId
        termsAgree
        termsAgreeDate
        participationAgreement
        participationAgreementDate
        organization {
          nextToken
          __typename
        }
        roles
        companyId
        company {
          id
          name
          type
          createdAt
          createdByUserId
          deleted
          updatedAt
          organizationCompaniesId
          __typename
        }
        firstName
        lastName
        email
        office
        mobile
        linkedInUrl
        imageUrl
        timeZone
        monthlyUpdates
        generalAnnouncements
        createdAt
        createdByUserId
        createdBy {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        modifications {
          fieldName
          fieldValue
          dataOperation
          modifiedAt
          id
          createdAt
          updatedAt
          __typename
        }
        organizationAdmin {
          nextToken
          __typename
        }
        organizationMember {
          nextToken
          __typename
        }
        deleted
        lastLoginDate
        weeklyDigestNotification
        monthlyDigestNotification
        quarterlyEmailNotification
        annualDigestNotification
        membershipAlertsNotification
        generalEmailNotification
        organizationSupportAdmin {
          nextToken
          __typename
        }
        updatedAt
        organizationContactsId
        __typename
      }
      modifiedByUserId
      modifiedBy {
        id
        cognitoUserId
        termsAgree
        termsAgreeDate
        participationAgreement
        participationAgreementDate
        organization {
          nextToken
          __typename
        }
        roles
        companyId
        company {
          id
          name
          type
          createdAt
          createdByUserId
          deleted
          updatedAt
          organizationCompaniesId
          __typename
        }
        firstName
        lastName
        email
        office
        mobile
        linkedInUrl
        imageUrl
        timeZone
        monthlyUpdates
        generalAnnouncements
        createdAt
        createdByUserId
        createdBy {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        modifications {
          fieldName
          fieldValue
          dataOperation
          modifiedAt
          id
          createdAt
          updatedAt
          __typename
        }
        organizationAdmin {
          nextToken
          __typename
        }
        organizationMember {
          nextToken
          __typename
        }
        deleted
        lastLoginDate
        weeklyDigestNotification
        monthlyDigestNotification
        quarterlyEmailNotification
        annualDigestNotification
        membershipAlertsNotification
        generalEmailNotification
        organizationSupportAdmin {
          nextToken
          __typename
        }
        updatedAt
        organizationContactsId
        __typename
      }
      modifications {
        fieldName
        fieldValue
        dataOperation
        modifiedAt
        modifiedBy {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        id
        createdAt
        updatedAt
        __typename
      }
      updatedAt
      organizationCalendarId
      __typename
    }
  }
`;
export const deleteCalendar = /* GraphQL */ `
  mutation DeleteCalendar(
    $input: DeleteCalendarInput!
    $condition: ModelCalendarConditionInput
  ) {
    deleteCalendar(input: $input, condition: $condition) {
      id
      organizationId
      organization {
        id
        name
        organizationType
        groupType
        chairId
        chair {
          id
          name
          type
          createdAt
          createdByUserId
          deleted
          updatedAt
          organizationCompaniesId
          __typename
        }
        chairContactId
        chairContact {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        operatorId
        operator {
          id
          name
          type
          createdAt
          createdByUserId
          deleted
          updatedAt
          organizationCompaniesId
          __typename
        }
        operatorContactId
        operatorContact {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        admins {
          nextToken
          __typename
        }
        airports {
          nextToken
          __typename
        }
        companies {
          nextToken
          __typename
        }
        members {
          nextToken
          __typename
        }
        documents {
          nextToken
          __typename
        }
        calendar {
          nextToken
          __typename
        }
        contacts {
          nextToken
          __typename
        }
        createdAt
        createdByUserId
        createdBy {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        modifications {
          fieldName
          fieldValue
          dataOperation
          modifiedAt
          id
          createdAt
          updatedAt
          __typename
        }
        supportAdmin {
          nextToken
          __typename
        }
        deleted
        updatedAt
        companyOrganizationsId
        userOrganizationId
        __typename
      }
      calendarEventTypeId
      calendarEventType {
        id
        name
        description
        createdAt
        createdBy {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        modifications {
          fieldName
          fieldValue
          dataOperation
          modifiedAt
          id
          createdAt
          updatedAt
          __typename
        }
        updatedAt
        __typename
      }
      name
      startDateTime
      endDateTime
      description
      location
      website
      groupRateCode
      organizer
      specialRates
      venue
      venueWebSite
      createdAt
      createdByUserId
      createdBy {
        id
        cognitoUserId
        termsAgree
        termsAgreeDate
        participationAgreement
        participationAgreementDate
        organization {
          nextToken
          __typename
        }
        roles
        companyId
        company {
          id
          name
          type
          createdAt
          createdByUserId
          deleted
          updatedAt
          organizationCompaniesId
          __typename
        }
        firstName
        lastName
        email
        office
        mobile
        linkedInUrl
        imageUrl
        timeZone
        monthlyUpdates
        generalAnnouncements
        createdAt
        createdByUserId
        createdBy {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        modifications {
          fieldName
          fieldValue
          dataOperation
          modifiedAt
          id
          createdAt
          updatedAt
          __typename
        }
        organizationAdmin {
          nextToken
          __typename
        }
        organizationMember {
          nextToken
          __typename
        }
        deleted
        lastLoginDate
        weeklyDigestNotification
        monthlyDigestNotification
        quarterlyEmailNotification
        annualDigestNotification
        membershipAlertsNotification
        generalEmailNotification
        organizationSupportAdmin {
          nextToken
          __typename
        }
        updatedAt
        organizationContactsId
        __typename
      }
      modifiedByUserId
      modifiedBy {
        id
        cognitoUserId
        termsAgree
        termsAgreeDate
        participationAgreement
        participationAgreementDate
        organization {
          nextToken
          __typename
        }
        roles
        companyId
        company {
          id
          name
          type
          createdAt
          createdByUserId
          deleted
          updatedAt
          organizationCompaniesId
          __typename
        }
        firstName
        lastName
        email
        office
        mobile
        linkedInUrl
        imageUrl
        timeZone
        monthlyUpdates
        generalAnnouncements
        createdAt
        createdByUserId
        createdBy {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        modifications {
          fieldName
          fieldValue
          dataOperation
          modifiedAt
          id
          createdAt
          updatedAt
          __typename
        }
        organizationAdmin {
          nextToken
          __typename
        }
        organizationMember {
          nextToken
          __typename
        }
        deleted
        lastLoginDate
        weeklyDigestNotification
        monthlyDigestNotification
        quarterlyEmailNotification
        annualDigestNotification
        membershipAlertsNotification
        generalEmailNotification
        organizationSupportAdmin {
          nextToken
          __typename
        }
        updatedAt
        organizationContactsId
        __typename
      }
      modifications {
        fieldName
        fieldValue
        dataOperation
        modifiedAt
        modifiedBy {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        id
        createdAt
        updatedAt
        __typename
      }
      updatedAt
      organizationCalendarId
      __typename
    }
  }
`;
export const createCalendarEventType = /* GraphQL */ `
  mutation CreateCalendarEventType(
    $input: CreateCalendarEventTypeInput!
    $condition: ModelCalendarEventTypeConditionInput
  ) {
    createCalendarEventType(input: $input, condition: $condition) {
      id
      name
      description
      createdAt
      createdBy {
        id
        cognitoUserId
        termsAgree
        termsAgreeDate
        participationAgreement
        participationAgreementDate
        organization {
          nextToken
          __typename
        }
        roles
        companyId
        company {
          id
          name
          type
          createdAt
          createdByUserId
          deleted
          updatedAt
          organizationCompaniesId
          __typename
        }
        firstName
        lastName
        email
        office
        mobile
        linkedInUrl
        imageUrl
        timeZone
        monthlyUpdates
        generalAnnouncements
        createdAt
        createdByUserId
        createdBy {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        modifications {
          fieldName
          fieldValue
          dataOperation
          modifiedAt
          id
          createdAt
          updatedAt
          __typename
        }
        organizationAdmin {
          nextToken
          __typename
        }
        organizationMember {
          nextToken
          __typename
        }
        deleted
        lastLoginDate
        weeklyDigestNotification
        monthlyDigestNotification
        quarterlyEmailNotification
        annualDigestNotification
        membershipAlertsNotification
        generalEmailNotification
        organizationSupportAdmin {
          nextToken
          __typename
        }
        updatedAt
        organizationContactsId
        __typename
      }
      modifications {
        fieldName
        fieldValue
        dataOperation
        modifiedAt
        modifiedBy {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        id
        createdAt
        updatedAt
        __typename
      }
      updatedAt
      __typename
    }
  }
`;
export const updateCalendarEventType = /* GraphQL */ `
  mutation UpdateCalendarEventType(
    $input: UpdateCalendarEventTypeInput!
    $condition: ModelCalendarEventTypeConditionInput
  ) {
    updateCalendarEventType(input: $input, condition: $condition) {
      id
      name
      description
      createdAt
      createdBy {
        id
        cognitoUserId
        termsAgree
        termsAgreeDate
        participationAgreement
        participationAgreementDate
        organization {
          nextToken
          __typename
        }
        roles
        companyId
        company {
          id
          name
          type
          createdAt
          createdByUserId
          deleted
          updatedAt
          organizationCompaniesId
          __typename
        }
        firstName
        lastName
        email
        office
        mobile
        linkedInUrl
        imageUrl
        timeZone
        monthlyUpdates
        generalAnnouncements
        createdAt
        createdByUserId
        createdBy {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        modifications {
          fieldName
          fieldValue
          dataOperation
          modifiedAt
          id
          createdAt
          updatedAt
          __typename
        }
        organizationAdmin {
          nextToken
          __typename
        }
        organizationMember {
          nextToken
          __typename
        }
        deleted
        lastLoginDate
        weeklyDigestNotification
        monthlyDigestNotification
        quarterlyEmailNotification
        annualDigestNotification
        membershipAlertsNotification
        generalEmailNotification
        organizationSupportAdmin {
          nextToken
          __typename
        }
        updatedAt
        organizationContactsId
        __typename
      }
      modifications {
        fieldName
        fieldValue
        dataOperation
        modifiedAt
        modifiedBy {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        id
        createdAt
        updatedAt
        __typename
      }
      updatedAt
      __typename
    }
  }
`;
export const deleteCalendarEventType = /* GraphQL */ `
  mutation DeleteCalendarEventType(
    $input: DeleteCalendarEventTypeInput!
    $condition: ModelCalendarEventTypeConditionInput
  ) {
    deleteCalendarEventType(input: $input, condition: $condition) {
      id
      name
      description
      createdAt
      createdBy {
        id
        cognitoUserId
        termsAgree
        termsAgreeDate
        participationAgreement
        participationAgreementDate
        organization {
          nextToken
          __typename
        }
        roles
        companyId
        company {
          id
          name
          type
          createdAt
          createdByUserId
          deleted
          updatedAt
          organizationCompaniesId
          __typename
        }
        firstName
        lastName
        email
        office
        mobile
        linkedInUrl
        imageUrl
        timeZone
        monthlyUpdates
        generalAnnouncements
        createdAt
        createdByUserId
        createdBy {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        modifications {
          fieldName
          fieldValue
          dataOperation
          modifiedAt
          id
          createdAt
          updatedAt
          __typename
        }
        organizationAdmin {
          nextToken
          __typename
        }
        organizationMember {
          nextToken
          __typename
        }
        deleted
        lastLoginDate
        weeklyDigestNotification
        monthlyDigestNotification
        quarterlyEmailNotification
        annualDigestNotification
        membershipAlertsNotification
        generalEmailNotification
        organizationSupportAdmin {
          nextToken
          __typename
        }
        updatedAt
        organizationContactsId
        __typename
      }
      modifications {
        fieldName
        fieldValue
        dataOperation
        modifiedAt
        modifiedBy {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        id
        createdAt
        updatedAt
        __typename
      }
      updatedAt
      __typename
    }
  }
`;
export const createAirportVolume = /* GraphQL */ `
  mutation CreateAirportVolume(
    $input: CreateAirportVolumeInput!
    $condition: ModelAirportVolumeConditionInput
  ) {
    createAirportVolume(input: $input, condition: $condition) {
      id
      airportId
      airport {
        id
        name
        code
        oldCode
        facility
        region
        state
        place {
          terminal
          gate
          lat
          lon
          __typename
        }
        consortiumGroup {
          nextToken
          __typename
        }
        consortiumType
        documents {
          nextToken
          __typename
        }
        chairId
        chair {
          id
          name
          type
          createdAt
          createdByUserId
          deleted
          updatedAt
          organizationCompaniesId
          __typename
        }
        chairContactId
        chairContact {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        operatorId
        operator {
          id
          name
          type
          createdAt
          createdByUserId
          deleted
          updatedAt
          organizationCompaniesId
          __typename
        }
        operatorGeneralManagerId
        operatorGeneralManager {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        secondaryContactId
        secondaryContact {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        facilityOwnerId
        facilityOwner {
          id
          name
          type
          createdAt
          createdByUserId
          deleted
          updatedAt
          organizationCompaniesId
          __typename
        }
        facilityOwnerContactId
        facilityOwnerContact {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        inventoryAccounting
        deliveryToPlane {
          nextToken
          __typename
        }
        deliveryToFacility {
          nextToken
          __typename
        }
        storage {
          nextToken
          __typename
        }
        createdAt
        createdBy {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        modifications {
          fieldName
          fieldValue
          dataOperation
          modifiedAt
          id
          createdAt
          updatedAt
          __typename
        }
        organizationAirportsId
        deleted
        updatedAt
        __typename
      }
      year
      volume
      createdAt
      createdBy {
        id
        cognitoUserId
        termsAgree
        termsAgreeDate
        participationAgreement
        participationAgreementDate
        organization {
          nextToken
          __typename
        }
        roles
        companyId
        company {
          id
          name
          type
          createdAt
          createdByUserId
          deleted
          updatedAt
          organizationCompaniesId
          __typename
        }
        firstName
        lastName
        email
        office
        mobile
        linkedInUrl
        imageUrl
        timeZone
        monthlyUpdates
        generalAnnouncements
        createdAt
        createdByUserId
        createdBy {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        modifications {
          fieldName
          fieldValue
          dataOperation
          modifiedAt
          id
          createdAt
          updatedAt
          __typename
        }
        organizationAdmin {
          nextToken
          __typename
        }
        organizationMember {
          nextToken
          __typename
        }
        deleted
        lastLoginDate
        weeklyDigestNotification
        monthlyDigestNotification
        quarterlyEmailNotification
        annualDigestNotification
        membershipAlertsNotification
        generalEmailNotification
        organizationSupportAdmin {
          nextToken
          __typename
        }
        updatedAt
        organizationContactsId
        __typename
      }
      modifications {
        fieldName
        fieldValue
        dataOperation
        modifiedAt
        modifiedBy {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        id
        createdAt
        updatedAt
        __typename
      }
      updatedAt
      __typename
    }
  }
`;
export const updateAirportVolume = /* GraphQL */ `
  mutation UpdateAirportVolume(
    $input: UpdateAirportVolumeInput!
    $condition: ModelAirportVolumeConditionInput
  ) {
    updateAirportVolume(input: $input, condition: $condition) {
      id
      airportId
      airport {
        id
        name
        code
        oldCode
        facility
        region
        state
        place {
          terminal
          gate
          lat
          lon
          __typename
        }
        consortiumGroup {
          nextToken
          __typename
        }
        consortiumType
        documents {
          nextToken
          __typename
        }
        chairId
        chair {
          id
          name
          type
          createdAt
          createdByUserId
          deleted
          updatedAt
          organizationCompaniesId
          __typename
        }
        chairContactId
        chairContact {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        operatorId
        operator {
          id
          name
          type
          createdAt
          createdByUserId
          deleted
          updatedAt
          organizationCompaniesId
          __typename
        }
        operatorGeneralManagerId
        operatorGeneralManager {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        secondaryContactId
        secondaryContact {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        facilityOwnerId
        facilityOwner {
          id
          name
          type
          createdAt
          createdByUserId
          deleted
          updatedAt
          organizationCompaniesId
          __typename
        }
        facilityOwnerContactId
        facilityOwnerContact {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        inventoryAccounting
        deliveryToPlane {
          nextToken
          __typename
        }
        deliveryToFacility {
          nextToken
          __typename
        }
        storage {
          nextToken
          __typename
        }
        createdAt
        createdBy {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        modifications {
          fieldName
          fieldValue
          dataOperation
          modifiedAt
          id
          createdAt
          updatedAt
          __typename
        }
        organizationAirportsId
        deleted
        updatedAt
        __typename
      }
      year
      volume
      createdAt
      createdBy {
        id
        cognitoUserId
        termsAgree
        termsAgreeDate
        participationAgreement
        participationAgreementDate
        organization {
          nextToken
          __typename
        }
        roles
        companyId
        company {
          id
          name
          type
          createdAt
          createdByUserId
          deleted
          updatedAt
          organizationCompaniesId
          __typename
        }
        firstName
        lastName
        email
        office
        mobile
        linkedInUrl
        imageUrl
        timeZone
        monthlyUpdates
        generalAnnouncements
        createdAt
        createdByUserId
        createdBy {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        modifications {
          fieldName
          fieldValue
          dataOperation
          modifiedAt
          id
          createdAt
          updatedAt
          __typename
        }
        organizationAdmin {
          nextToken
          __typename
        }
        organizationMember {
          nextToken
          __typename
        }
        deleted
        lastLoginDate
        weeklyDigestNotification
        monthlyDigestNotification
        quarterlyEmailNotification
        annualDigestNotification
        membershipAlertsNotification
        generalEmailNotification
        organizationSupportAdmin {
          nextToken
          __typename
        }
        updatedAt
        organizationContactsId
        __typename
      }
      modifications {
        fieldName
        fieldValue
        dataOperation
        modifiedAt
        modifiedBy {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        id
        createdAt
        updatedAt
        __typename
      }
      updatedAt
      __typename
    }
  }
`;
export const deleteAirportVolume = /* GraphQL */ `
  mutation DeleteAirportVolume(
    $input: DeleteAirportVolumeInput!
    $condition: ModelAirportVolumeConditionInput
  ) {
    deleteAirportVolume(input: $input, condition: $condition) {
      id
      airportId
      airport {
        id
        name
        code
        oldCode
        facility
        region
        state
        place {
          terminal
          gate
          lat
          lon
          __typename
        }
        consortiumGroup {
          nextToken
          __typename
        }
        consortiumType
        documents {
          nextToken
          __typename
        }
        chairId
        chair {
          id
          name
          type
          createdAt
          createdByUserId
          deleted
          updatedAt
          organizationCompaniesId
          __typename
        }
        chairContactId
        chairContact {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        operatorId
        operator {
          id
          name
          type
          createdAt
          createdByUserId
          deleted
          updatedAt
          organizationCompaniesId
          __typename
        }
        operatorGeneralManagerId
        operatorGeneralManager {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        secondaryContactId
        secondaryContact {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        facilityOwnerId
        facilityOwner {
          id
          name
          type
          createdAt
          createdByUserId
          deleted
          updatedAt
          organizationCompaniesId
          __typename
        }
        facilityOwnerContactId
        facilityOwnerContact {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        inventoryAccounting
        deliveryToPlane {
          nextToken
          __typename
        }
        deliveryToFacility {
          nextToken
          __typename
        }
        storage {
          nextToken
          __typename
        }
        createdAt
        createdBy {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        modifications {
          fieldName
          fieldValue
          dataOperation
          modifiedAt
          id
          createdAt
          updatedAt
          __typename
        }
        organizationAirportsId
        deleted
        updatedAt
        __typename
      }
      year
      volume
      createdAt
      createdBy {
        id
        cognitoUserId
        termsAgree
        termsAgreeDate
        participationAgreement
        participationAgreementDate
        organization {
          nextToken
          __typename
        }
        roles
        companyId
        company {
          id
          name
          type
          createdAt
          createdByUserId
          deleted
          updatedAt
          organizationCompaniesId
          __typename
        }
        firstName
        lastName
        email
        office
        mobile
        linkedInUrl
        imageUrl
        timeZone
        monthlyUpdates
        generalAnnouncements
        createdAt
        createdByUserId
        createdBy {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        modifications {
          fieldName
          fieldValue
          dataOperation
          modifiedAt
          id
          createdAt
          updatedAt
          __typename
        }
        organizationAdmin {
          nextToken
          __typename
        }
        organizationMember {
          nextToken
          __typename
        }
        deleted
        lastLoginDate
        weeklyDigestNotification
        monthlyDigestNotification
        quarterlyEmailNotification
        annualDigestNotification
        membershipAlertsNotification
        generalEmailNotification
        organizationSupportAdmin {
          nextToken
          __typename
        }
        updatedAt
        organizationContactsId
        __typename
      }
      modifications {
        fieldName
        fieldValue
        dataOperation
        modifiedAt
        modifiedBy {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        id
        createdAt
        updatedAt
        __typename
      }
      updatedAt
      __typename
    }
  }
`;
export const createAirport = /* GraphQL */ `
  mutation CreateAirport(
    $input: CreateAirportInput!
    $condition: ModelAirportConditionInput
  ) {
    createAirport(input: $input, condition: $condition) {
      id
      name
      code
      oldCode
      facility
      region
      state
      place {
        terminal
        gate
        lat
        lon
        __typename
      }
      consortiumGroup {
        items {
          id
          organizationId
          airportId
          chairId
          chairContactId
          operatorId
          operatorGeneralManagerId
          secondaryContact
          facilityOwner
          facilityOwnerContact
          legalCounselContact
          legalCounsel
          facilityLocation
          totalCapacityDays
          totalCapacityGallons
          secured
          moExpiration
          moType
          moTypeCustomValue
          leaseExpiration
          leaseType
          leaseTypeCustomValue
          dateLastFinancialSUP
          dateLastA4aOperationalReview
          netInventoryCalculation
          entryFee
          nonMemberRate
          costSharingFormula
          reserveDepositPrebill
          thirdPartyDebt
          memberLoans
          dateLastPropertyAppraisal
          aviationLiabilityLimit
          environmentalLiabilityLimit
          comments
          deleted
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      consortiumType
      documents {
        items {
          id
          organizationId
          airportId
          categoryType
          documentCategoryId
          bucketType
          title
          description
          publishedByUserId
          publishedDate
          url
          fileSize
          companyId
          createdAt
          createByUserId
          categoryTypeId
          deleted
          updatedAt
          organizationDocumentsId
          documentCategoryDocumentsId
          documentFileTypeId
          __typename
        }
        nextToken
        __typename
      }
      chairId
      chair {
        id
        name
        type
        organizations {
          nextToken
          __typename
        }
        members {
          nextToken
          __typename
        }
        createdAt
        createdByUserId
        createdBy {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        deleted
        modifications {
          fieldName
          fieldValue
          dataOperation
          modifiedAt
          id
          createdAt
          updatedAt
          __typename
        }
        updatedAt
        organizationCompaniesId
        __typename
      }
      chairContactId
      chairContact {
        id
        cognitoUserId
        termsAgree
        termsAgreeDate
        participationAgreement
        participationAgreementDate
        organization {
          nextToken
          __typename
        }
        roles
        companyId
        company {
          id
          name
          type
          createdAt
          createdByUserId
          deleted
          updatedAt
          organizationCompaniesId
          __typename
        }
        firstName
        lastName
        email
        office
        mobile
        linkedInUrl
        imageUrl
        timeZone
        monthlyUpdates
        generalAnnouncements
        createdAt
        createdByUserId
        createdBy {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        modifications {
          fieldName
          fieldValue
          dataOperation
          modifiedAt
          id
          createdAt
          updatedAt
          __typename
        }
        organizationAdmin {
          nextToken
          __typename
        }
        organizationMember {
          nextToken
          __typename
        }
        deleted
        lastLoginDate
        weeklyDigestNotification
        monthlyDigestNotification
        quarterlyEmailNotification
        annualDigestNotification
        membershipAlertsNotification
        generalEmailNotification
        organizationSupportAdmin {
          nextToken
          __typename
        }
        updatedAt
        organizationContactsId
        __typename
      }
      operatorId
      operator {
        id
        name
        type
        organizations {
          nextToken
          __typename
        }
        members {
          nextToken
          __typename
        }
        createdAt
        createdByUserId
        createdBy {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        deleted
        modifications {
          fieldName
          fieldValue
          dataOperation
          modifiedAt
          id
          createdAt
          updatedAt
          __typename
        }
        updatedAt
        organizationCompaniesId
        __typename
      }
      operatorGeneralManagerId
      operatorGeneralManager {
        id
        cognitoUserId
        termsAgree
        termsAgreeDate
        participationAgreement
        participationAgreementDate
        organization {
          nextToken
          __typename
        }
        roles
        companyId
        company {
          id
          name
          type
          createdAt
          createdByUserId
          deleted
          updatedAt
          organizationCompaniesId
          __typename
        }
        firstName
        lastName
        email
        office
        mobile
        linkedInUrl
        imageUrl
        timeZone
        monthlyUpdates
        generalAnnouncements
        createdAt
        createdByUserId
        createdBy {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        modifications {
          fieldName
          fieldValue
          dataOperation
          modifiedAt
          id
          createdAt
          updatedAt
          __typename
        }
        organizationAdmin {
          nextToken
          __typename
        }
        organizationMember {
          nextToken
          __typename
        }
        deleted
        lastLoginDate
        weeklyDigestNotification
        monthlyDigestNotification
        quarterlyEmailNotification
        annualDigestNotification
        membershipAlertsNotification
        generalEmailNotification
        organizationSupportAdmin {
          nextToken
          __typename
        }
        updatedAt
        organizationContactsId
        __typename
      }
      secondaryContactId
      secondaryContact {
        id
        cognitoUserId
        termsAgree
        termsAgreeDate
        participationAgreement
        participationAgreementDate
        organization {
          nextToken
          __typename
        }
        roles
        companyId
        company {
          id
          name
          type
          createdAt
          createdByUserId
          deleted
          updatedAt
          organizationCompaniesId
          __typename
        }
        firstName
        lastName
        email
        office
        mobile
        linkedInUrl
        imageUrl
        timeZone
        monthlyUpdates
        generalAnnouncements
        createdAt
        createdByUserId
        createdBy {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        modifications {
          fieldName
          fieldValue
          dataOperation
          modifiedAt
          id
          createdAt
          updatedAt
          __typename
        }
        organizationAdmin {
          nextToken
          __typename
        }
        organizationMember {
          nextToken
          __typename
        }
        deleted
        lastLoginDate
        weeklyDigestNotification
        monthlyDigestNotification
        quarterlyEmailNotification
        annualDigestNotification
        membershipAlertsNotification
        generalEmailNotification
        organizationSupportAdmin {
          nextToken
          __typename
        }
        updatedAt
        organizationContactsId
        __typename
      }
      facilityOwnerId
      facilityOwner {
        id
        name
        type
        organizations {
          nextToken
          __typename
        }
        members {
          nextToken
          __typename
        }
        createdAt
        createdByUserId
        createdBy {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        deleted
        modifications {
          fieldName
          fieldValue
          dataOperation
          modifiedAt
          id
          createdAt
          updatedAt
          __typename
        }
        updatedAt
        organizationCompaniesId
        __typename
      }
      facilityOwnerContactId
      facilityOwnerContact {
        id
        cognitoUserId
        termsAgree
        termsAgreeDate
        participationAgreement
        participationAgreementDate
        organization {
          nextToken
          __typename
        }
        roles
        companyId
        company {
          id
          name
          type
          createdAt
          createdByUserId
          deleted
          updatedAt
          organizationCompaniesId
          __typename
        }
        firstName
        lastName
        email
        office
        mobile
        linkedInUrl
        imageUrl
        timeZone
        monthlyUpdates
        generalAnnouncements
        createdAt
        createdByUserId
        createdBy {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        modifications {
          fieldName
          fieldValue
          dataOperation
          modifiedAt
          id
          createdAt
          updatedAt
          __typename
        }
        organizationAdmin {
          nextToken
          __typename
        }
        organizationMember {
          nextToken
          __typename
        }
        deleted
        lastLoginDate
        weeklyDigestNotification
        monthlyDigestNotification
        quarterlyEmailNotification
        annualDigestNotification
        membershipAlertsNotification
        generalEmailNotification
        organizationSupportAdmin {
          nextToken
          __typename
        }
        updatedAt
        organizationContactsId
        __typename
      }
      inventoryAccounting
      deliveryToPlane {
        items {
          id
          airportId
          organizationId
          airportDeliveryToPlaneId
          obFiltration
          hydrant
          closedLoop
          length
          hydrantLocations
          pits
          refuelerLocations
          efso
          efsoLocation
          leakDetection
          leakDetectionDescription
          flowRateF1Peak
          flowRateF1Max
          flowRateF2Peak
          flowRateF2Max
          flowRateF3Peak
          flowRateF3Max
          pipingSizeMin
          pipingSizeMax
          currentIntoPlaneOperators
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      deliveryToFacility {
        items {
          id
          airportId
          provider
          organizationId
          method
          primary
          numberLines
          frequency
          frequencyCustomValue
          filtrationType
          filtrationTypeCustomValue
          filtrationDescription
          flowRateTypical
          flowRateMax
          pipingSize
          offloadLocations
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      storage {
        items {
          id
          airportId
          organizationId
          tankId
          yearInstalled
          product
          storageLocation
          storageASTUST
          nextAPI653
          storageFunction
          totalBBL
          usableBBL
          opStatus
          owner
          security
          secondaryContainment
          cathodicProtection
          leakDetection
          totalGals
          usableGals
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      createdBy {
        id
        cognitoUserId
        termsAgree
        termsAgreeDate
        participationAgreement
        participationAgreementDate
        organization {
          nextToken
          __typename
        }
        roles
        companyId
        company {
          id
          name
          type
          createdAt
          createdByUserId
          deleted
          updatedAt
          organizationCompaniesId
          __typename
        }
        firstName
        lastName
        email
        office
        mobile
        linkedInUrl
        imageUrl
        timeZone
        monthlyUpdates
        generalAnnouncements
        createdAt
        createdByUserId
        createdBy {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        modifications {
          fieldName
          fieldValue
          dataOperation
          modifiedAt
          id
          createdAt
          updatedAt
          __typename
        }
        organizationAdmin {
          nextToken
          __typename
        }
        organizationMember {
          nextToken
          __typename
        }
        deleted
        lastLoginDate
        weeklyDigestNotification
        monthlyDigestNotification
        quarterlyEmailNotification
        annualDigestNotification
        membershipAlertsNotification
        generalEmailNotification
        organizationSupportAdmin {
          nextToken
          __typename
        }
        updatedAt
        organizationContactsId
        __typename
      }
      modifications {
        fieldName
        fieldValue
        dataOperation
        modifiedAt
        modifiedBy {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        id
        createdAt
        updatedAt
        __typename
      }
      organizationAirportsId
      deleted
      updatedAt
      __typename
    }
  }
`;
export const updateAirport = /* GraphQL */ `
  mutation UpdateAirport(
    $input: UpdateAirportInput!
    $condition: ModelAirportConditionInput
  ) {
    updateAirport(input: $input, condition: $condition) {
      id
      name
      code
      oldCode
      facility
      region
      state
      place {
        terminal
        gate
        lat
        lon
        __typename
      }
      consortiumGroup {
        items {
          id
          organizationId
          airportId
          chairId
          chairContactId
          operatorId
          operatorGeneralManagerId
          secondaryContact
          facilityOwner
          facilityOwnerContact
          legalCounselContact
          legalCounsel
          facilityLocation
          totalCapacityDays
          totalCapacityGallons
          secured
          moExpiration
          moType
          moTypeCustomValue
          leaseExpiration
          leaseType
          leaseTypeCustomValue
          dateLastFinancialSUP
          dateLastA4aOperationalReview
          netInventoryCalculation
          entryFee
          nonMemberRate
          costSharingFormula
          reserveDepositPrebill
          thirdPartyDebt
          memberLoans
          dateLastPropertyAppraisal
          aviationLiabilityLimit
          environmentalLiabilityLimit
          comments
          deleted
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      consortiumType
      documents {
        items {
          id
          organizationId
          airportId
          categoryType
          documentCategoryId
          bucketType
          title
          description
          publishedByUserId
          publishedDate
          url
          fileSize
          companyId
          createdAt
          createByUserId
          categoryTypeId
          deleted
          updatedAt
          organizationDocumentsId
          documentCategoryDocumentsId
          documentFileTypeId
          __typename
        }
        nextToken
        __typename
      }
      chairId
      chair {
        id
        name
        type
        organizations {
          nextToken
          __typename
        }
        members {
          nextToken
          __typename
        }
        createdAt
        createdByUserId
        createdBy {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        deleted
        modifications {
          fieldName
          fieldValue
          dataOperation
          modifiedAt
          id
          createdAt
          updatedAt
          __typename
        }
        updatedAt
        organizationCompaniesId
        __typename
      }
      chairContactId
      chairContact {
        id
        cognitoUserId
        termsAgree
        termsAgreeDate
        participationAgreement
        participationAgreementDate
        organization {
          nextToken
          __typename
        }
        roles
        companyId
        company {
          id
          name
          type
          createdAt
          createdByUserId
          deleted
          updatedAt
          organizationCompaniesId
          __typename
        }
        firstName
        lastName
        email
        office
        mobile
        linkedInUrl
        imageUrl
        timeZone
        monthlyUpdates
        generalAnnouncements
        createdAt
        createdByUserId
        createdBy {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        modifications {
          fieldName
          fieldValue
          dataOperation
          modifiedAt
          id
          createdAt
          updatedAt
          __typename
        }
        organizationAdmin {
          nextToken
          __typename
        }
        organizationMember {
          nextToken
          __typename
        }
        deleted
        lastLoginDate
        weeklyDigestNotification
        monthlyDigestNotification
        quarterlyEmailNotification
        annualDigestNotification
        membershipAlertsNotification
        generalEmailNotification
        organizationSupportAdmin {
          nextToken
          __typename
        }
        updatedAt
        organizationContactsId
        __typename
      }
      operatorId
      operator {
        id
        name
        type
        organizations {
          nextToken
          __typename
        }
        members {
          nextToken
          __typename
        }
        createdAt
        createdByUserId
        createdBy {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        deleted
        modifications {
          fieldName
          fieldValue
          dataOperation
          modifiedAt
          id
          createdAt
          updatedAt
          __typename
        }
        updatedAt
        organizationCompaniesId
        __typename
      }
      operatorGeneralManagerId
      operatorGeneralManager {
        id
        cognitoUserId
        termsAgree
        termsAgreeDate
        participationAgreement
        participationAgreementDate
        organization {
          nextToken
          __typename
        }
        roles
        companyId
        company {
          id
          name
          type
          createdAt
          createdByUserId
          deleted
          updatedAt
          organizationCompaniesId
          __typename
        }
        firstName
        lastName
        email
        office
        mobile
        linkedInUrl
        imageUrl
        timeZone
        monthlyUpdates
        generalAnnouncements
        createdAt
        createdByUserId
        createdBy {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        modifications {
          fieldName
          fieldValue
          dataOperation
          modifiedAt
          id
          createdAt
          updatedAt
          __typename
        }
        organizationAdmin {
          nextToken
          __typename
        }
        organizationMember {
          nextToken
          __typename
        }
        deleted
        lastLoginDate
        weeklyDigestNotification
        monthlyDigestNotification
        quarterlyEmailNotification
        annualDigestNotification
        membershipAlertsNotification
        generalEmailNotification
        organizationSupportAdmin {
          nextToken
          __typename
        }
        updatedAt
        organizationContactsId
        __typename
      }
      secondaryContactId
      secondaryContact {
        id
        cognitoUserId
        termsAgree
        termsAgreeDate
        participationAgreement
        participationAgreementDate
        organization {
          nextToken
          __typename
        }
        roles
        companyId
        company {
          id
          name
          type
          createdAt
          createdByUserId
          deleted
          updatedAt
          organizationCompaniesId
          __typename
        }
        firstName
        lastName
        email
        office
        mobile
        linkedInUrl
        imageUrl
        timeZone
        monthlyUpdates
        generalAnnouncements
        createdAt
        createdByUserId
        createdBy {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        modifications {
          fieldName
          fieldValue
          dataOperation
          modifiedAt
          id
          createdAt
          updatedAt
          __typename
        }
        organizationAdmin {
          nextToken
          __typename
        }
        organizationMember {
          nextToken
          __typename
        }
        deleted
        lastLoginDate
        weeklyDigestNotification
        monthlyDigestNotification
        quarterlyEmailNotification
        annualDigestNotification
        membershipAlertsNotification
        generalEmailNotification
        organizationSupportAdmin {
          nextToken
          __typename
        }
        updatedAt
        organizationContactsId
        __typename
      }
      facilityOwnerId
      facilityOwner {
        id
        name
        type
        organizations {
          nextToken
          __typename
        }
        members {
          nextToken
          __typename
        }
        createdAt
        createdByUserId
        createdBy {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        deleted
        modifications {
          fieldName
          fieldValue
          dataOperation
          modifiedAt
          id
          createdAt
          updatedAt
          __typename
        }
        updatedAt
        organizationCompaniesId
        __typename
      }
      facilityOwnerContactId
      facilityOwnerContact {
        id
        cognitoUserId
        termsAgree
        termsAgreeDate
        participationAgreement
        participationAgreementDate
        organization {
          nextToken
          __typename
        }
        roles
        companyId
        company {
          id
          name
          type
          createdAt
          createdByUserId
          deleted
          updatedAt
          organizationCompaniesId
          __typename
        }
        firstName
        lastName
        email
        office
        mobile
        linkedInUrl
        imageUrl
        timeZone
        monthlyUpdates
        generalAnnouncements
        createdAt
        createdByUserId
        createdBy {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        modifications {
          fieldName
          fieldValue
          dataOperation
          modifiedAt
          id
          createdAt
          updatedAt
          __typename
        }
        organizationAdmin {
          nextToken
          __typename
        }
        organizationMember {
          nextToken
          __typename
        }
        deleted
        lastLoginDate
        weeklyDigestNotification
        monthlyDigestNotification
        quarterlyEmailNotification
        annualDigestNotification
        membershipAlertsNotification
        generalEmailNotification
        organizationSupportAdmin {
          nextToken
          __typename
        }
        updatedAt
        organizationContactsId
        __typename
      }
      inventoryAccounting
      deliveryToPlane {
        items {
          id
          airportId
          organizationId
          airportDeliveryToPlaneId
          obFiltration
          hydrant
          closedLoop
          length
          hydrantLocations
          pits
          refuelerLocations
          efso
          efsoLocation
          leakDetection
          leakDetectionDescription
          flowRateF1Peak
          flowRateF1Max
          flowRateF2Peak
          flowRateF2Max
          flowRateF3Peak
          flowRateF3Max
          pipingSizeMin
          pipingSizeMax
          currentIntoPlaneOperators
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      deliveryToFacility {
        items {
          id
          airportId
          provider
          organizationId
          method
          primary
          numberLines
          frequency
          frequencyCustomValue
          filtrationType
          filtrationTypeCustomValue
          filtrationDescription
          flowRateTypical
          flowRateMax
          pipingSize
          offloadLocations
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      storage {
        items {
          id
          airportId
          organizationId
          tankId
          yearInstalled
          product
          storageLocation
          storageASTUST
          nextAPI653
          storageFunction
          totalBBL
          usableBBL
          opStatus
          owner
          security
          secondaryContainment
          cathodicProtection
          leakDetection
          totalGals
          usableGals
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      createdBy {
        id
        cognitoUserId
        termsAgree
        termsAgreeDate
        participationAgreement
        participationAgreementDate
        organization {
          nextToken
          __typename
        }
        roles
        companyId
        company {
          id
          name
          type
          createdAt
          createdByUserId
          deleted
          updatedAt
          organizationCompaniesId
          __typename
        }
        firstName
        lastName
        email
        office
        mobile
        linkedInUrl
        imageUrl
        timeZone
        monthlyUpdates
        generalAnnouncements
        createdAt
        createdByUserId
        createdBy {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        modifications {
          fieldName
          fieldValue
          dataOperation
          modifiedAt
          id
          createdAt
          updatedAt
          __typename
        }
        organizationAdmin {
          nextToken
          __typename
        }
        organizationMember {
          nextToken
          __typename
        }
        deleted
        lastLoginDate
        weeklyDigestNotification
        monthlyDigestNotification
        quarterlyEmailNotification
        annualDigestNotification
        membershipAlertsNotification
        generalEmailNotification
        organizationSupportAdmin {
          nextToken
          __typename
        }
        updatedAt
        organizationContactsId
        __typename
      }
      modifications {
        fieldName
        fieldValue
        dataOperation
        modifiedAt
        modifiedBy {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        id
        createdAt
        updatedAt
        __typename
      }
      organizationAirportsId
      deleted
      updatedAt
      __typename
    }
  }
`;
export const deleteAirport = /* GraphQL */ `
  mutation DeleteAirport(
    $input: DeleteAirportInput!
    $condition: ModelAirportConditionInput
  ) {
    deleteAirport(input: $input, condition: $condition) {
      id
      name
      code
      oldCode
      facility
      region
      state
      place {
        terminal
        gate
        lat
        lon
        __typename
      }
      consortiumGroup {
        items {
          id
          organizationId
          airportId
          chairId
          chairContactId
          operatorId
          operatorGeneralManagerId
          secondaryContact
          facilityOwner
          facilityOwnerContact
          legalCounselContact
          legalCounsel
          facilityLocation
          totalCapacityDays
          totalCapacityGallons
          secured
          moExpiration
          moType
          moTypeCustomValue
          leaseExpiration
          leaseType
          leaseTypeCustomValue
          dateLastFinancialSUP
          dateLastA4aOperationalReview
          netInventoryCalculation
          entryFee
          nonMemberRate
          costSharingFormula
          reserveDepositPrebill
          thirdPartyDebt
          memberLoans
          dateLastPropertyAppraisal
          aviationLiabilityLimit
          environmentalLiabilityLimit
          comments
          deleted
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      consortiumType
      documents {
        items {
          id
          organizationId
          airportId
          categoryType
          documentCategoryId
          bucketType
          title
          description
          publishedByUserId
          publishedDate
          url
          fileSize
          companyId
          createdAt
          createByUserId
          categoryTypeId
          deleted
          updatedAt
          organizationDocumentsId
          documentCategoryDocumentsId
          documentFileTypeId
          __typename
        }
        nextToken
        __typename
      }
      chairId
      chair {
        id
        name
        type
        organizations {
          nextToken
          __typename
        }
        members {
          nextToken
          __typename
        }
        createdAt
        createdByUserId
        createdBy {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        deleted
        modifications {
          fieldName
          fieldValue
          dataOperation
          modifiedAt
          id
          createdAt
          updatedAt
          __typename
        }
        updatedAt
        organizationCompaniesId
        __typename
      }
      chairContactId
      chairContact {
        id
        cognitoUserId
        termsAgree
        termsAgreeDate
        participationAgreement
        participationAgreementDate
        organization {
          nextToken
          __typename
        }
        roles
        companyId
        company {
          id
          name
          type
          createdAt
          createdByUserId
          deleted
          updatedAt
          organizationCompaniesId
          __typename
        }
        firstName
        lastName
        email
        office
        mobile
        linkedInUrl
        imageUrl
        timeZone
        monthlyUpdates
        generalAnnouncements
        createdAt
        createdByUserId
        createdBy {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        modifications {
          fieldName
          fieldValue
          dataOperation
          modifiedAt
          id
          createdAt
          updatedAt
          __typename
        }
        organizationAdmin {
          nextToken
          __typename
        }
        organizationMember {
          nextToken
          __typename
        }
        deleted
        lastLoginDate
        weeklyDigestNotification
        monthlyDigestNotification
        quarterlyEmailNotification
        annualDigestNotification
        membershipAlertsNotification
        generalEmailNotification
        organizationSupportAdmin {
          nextToken
          __typename
        }
        updatedAt
        organizationContactsId
        __typename
      }
      operatorId
      operator {
        id
        name
        type
        organizations {
          nextToken
          __typename
        }
        members {
          nextToken
          __typename
        }
        createdAt
        createdByUserId
        createdBy {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        deleted
        modifications {
          fieldName
          fieldValue
          dataOperation
          modifiedAt
          id
          createdAt
          updatedAt
          __typename
        }
        updatedAt
        organizationCompaniesId
        __typename
      }
      operatorGeneralManagerId
      operatorGeneralManager {
        id
        cognitoUserId
        termsAgree
        termsAgreeDate
        participationAgreement
        participationAgreementDate
        organization {
          nextToken
          __typename
        }
        roles
        companyId
        company {
          id
          name
          type
          createdAt
          createdByUserId
          deleted
          updatedAt
          organizationCompaniesId
          __typename
        }
        firstName
        lastName
        email
        office
        mobile
        linkedInUrl
        imageUrl
        timeZone
        monthlyUpdates
        generalAnnouncements
        createdAt
        createdByUserId
        createdBy {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        modifications {
          fieldName
          fieldValue
          dataOperation
          modifiedAt
          id
          createdAt
          updatedAt
          __typename
        }
        organizationAdmin {
          nextToken
          __typename
        }
        organizationMember {
          nextToken
          __typename
        }
        deleted
        lastLoginDate
        weeklyDigestNotification
        monthlyDigestNotification
        quarterlyEmailNotification
        annualDigestNotification
        membershipAlertsNotification
        generalEmailNotification
        organizationSupportAdmin {
          nextToken
          __typename
        }
        updatedAt
        organizationContactsId
        __typename
      }
      secondaryContactId
      secondaryContact {
        id
        cognitoUserId
        termsAgree
        termsAgreeDate
        participationAgreement
        participationAgreementDate
        organization {
          nextToken
          __typename
        }
        roles
        companyId
        company {
          id
          name
          type
          createdAt
          createdByUserId
          deleted
          updatedAt
          organizationCompaniesId
          __typename
        }
        firstName
        lastName
        email
        office
        mobile
        linkedInUrl
        imageUrl
        timeZone
        monthlyUpdates
        generalAnnouncements
        createdAt
        createdByUserId
        createdBy {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        modifications {
          fieldName
          fieldValue
          dataOperation
          modifiedAt
          id
          createdAt
          updatedAt
          __typename
        }
        organizationAdmin {
          nextToken
          __typename
        }
        organizationMember {
          nextToken
          __typename
        }
        deleted
        lastLoginDate
        weeklyDigestNotification
        monthlyDigestNotification
        quarterlyEmailNotification
        annualDigestNotification
        membershipAlertsNotification
        generalEmailNotification
        organizationSupportAdmin {
          nextToken
          __typename
        }
        updatedAt
        organizationContactsId
        __typename
      }
      facilityOwnerId
      facilityOwner {
        id
        name
        type
        organizations {
          nextToken
          __typename
        }
        members {
          nextToken
          __typename
        }
        createdAt
        createdByUserId
        createdBy {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        deleted
        modifications {
          fieldName
          fieldValue
          dataOperation
          modifiedAt
          id
          createdAt
          updatedAt
          __typename
        }
        updatedAt
        organizationCompaniesId
        __typename
      }
      facilityOwnerContactId
      facilityOwnerContact {
        id
        cognitoUserId
        termsAgree
        termsAgreeDate
        participationAgreement
        participationAgreementDate
        organization {
          nextToken
          __typename
        }
        roles
        companyId
        company {
          id
          name
          type
          createdAt
          createdByUserId
          deleted
          updatedAt
          organizationCompaniesId
          __typename
        }
        firstName
        lastName
        email
        office
        mobile
        linkedInUrl
        imageUrl
        timeZone
        monthlyUpdates
        generalAnnouncements
        createdAt
        createdByUserId
        createdBy {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        modifications {
          fieldName
          fieldValue
          dataOperation
          modifiedAt
          id
          createdAt
          updatedAt
          __typename
        }
        organizationAdmin {
          nextToken
          __typename
        }
        organizationMember {
          nextToken
          __typename
        }
        deleted
        lastLoginDate
        weeklyDigestNotification
        monthlyDigestNotification
        quarterlyEmailNotification
        annualDigestNotification
        membershipAlertsNotification
        generalEmailNotification
        organizationSupportAdmin {
          nextToken
          __typename
        }
        updatedAt
        organizationContactsId
        __typename
      }
      inventoryAccounting
      deliveryToPlane {
        items {
          id
          airportId
          organizationId
          airportDeliveryToPlaneId
          obFiltration
          hydrant
          closedLoop
          length
          hydrantLocations
          pits
          refuelerLocations
          efso
          efsoLocation
          leakDetection
          leakDetectionDescription
          flowRateF1Peak
          flowRateF1Max
          flowRateF2Peak
          flowRateF2Max
          flowRateF3Peak
          flowRateF3Max
          pipingSizeMin
          pipingSizeMax
          currentIntoPlaneOperators
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      deliveryToFacility {
        items {
          id
          airportId
          provider
          organizationId
          method
          primary
          numberLines
          frequency
          frequencyCustomValue
          filtrationType
          filtrationTypeCustomValue
          filtrationDescription
          flowRateTypical
          flowRateMax
          pipingSize
          offloadLocations
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      storage {
        items {
          id
          airportId
          organizationId
          tankId
          yearInstalled
          product
          storageLocation
          storageASTUST
          nextAPI653
          storageFunction
          totalBBL
          usableBBL
          opStatus
          owner
          security
          secondaryContainment
          cathodicProtection
          leakDetection
          totalGals
          usableGals
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      createdBy {
        id
        cognitoUserId
        termsAgree
        termsAgreeDate
        participationAgreement
        participationAgreementDate
        organization {
          nextToken
          __typename
        }
        roles
        companyId
        company {
          id
          name
          type
          createdAt
          createdByUserId
          deleted
          updatedAt
          organizationCompaniesId
          __typename
        }
        firstName
        lastName
        email
        office
        mobile
        linkedInUrl
        imageUrl
        timeZone
        monthlyUpdates
        generalAnnouncements
        createdAt
        createdByUserId
        createdBy {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        modifications {
          fieldName
          fieldValue
          dataOperation
          modifiedAt
          id
          createdAt
          updatedAt
          __typename
        }
        organizationAdmin {
          nextToken
          __typename
        }
        organizationMember {
          nextToken
          __typename
        }
        deleted
        lastLoginDate
        weeklyDigestNotification
        monthlyDigestNotification
        quarterlyEmailNotification
        annualDigestNotification
        membershipAlertsNotification
        generalEmailNotification
        organizationSupportAdmin {
          nextToken
          __typename
        }
        updatedAt
        organizationContactsId
        __typename
      }
      modifications {
        fieldName
        fieldValue
        dataOperation
        modifiedAt
        modifiedBy {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        id
        createdAt
        updatedAt
        __typename
      }
      organizationAirportsId
      deleted
      updatedAt
      __typename
    }
  }
`;
export const createAirportConsortiumGroup = /* GraphQL */ `
  mutation CreateAirportConsortiumGroup(
    $input: CreateAirportConsortiumGroupInput!
    $condition: ModelAirportConsortiumGroupConditionInput
  ) {
    createAirportConsortiumGroup(input: $input, condition: $condition) {
      id
      organizationId
      airportId
      airport {
        id
        name
        code
        oldCode
        facility
        region
        state
        place {
          terminal
          gate
          lat
          lon
          __typename
        }
        consortiumGroup {
          nextToken
          __typename
        }
        consortiumType
        documents {
          nextToken
          __typename
        }
        chairId
        chair {
          id
          name
          type
          createdAt
          createdByUserId
          deleted
          updatedAt
          organizationCompaniesId
          __typename
        }
        chairContactId
        chairContact {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        operatorId
        operator {
          id
          name
          type
          createdAt
          createdByUserId
          deleted
          updatedAt
          organizationCompaniesId
          __typename
        }
        operatorGeneralManagerId
        operatorGeneralManager {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        secondaryContactId
        secondaryContact {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        facilityOwnerId
        facilityOwner {
          id
          name
          type
          createdAt
          createdByUserId
          deleted
          updatedAt
          organizationCompaniesId
          __typename
        }
        facilityOwnerContactId
        facilityOwnerContact {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        inventoryAccounting
        deliveryToPlane {
          nextToken
          __typename
        }
        deliveryToFacility {
          nextToken
          __typename
        }
        storage {
          nextToken
          __typename
        }
        createdAt
        createdBy {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        modifications {
          fieldName
          fieldValue
          dataOperation
          modifiedAt
          id
          createdAt
          updatedAt
          __typename
        }
        organizationAirportsId
        deleted
        updatedAt
        __typename
      }
      organization {
        id
        name
        organizationType
        groupType
        chairId
        chair {
          id
          name
          type
          createdAt
          createdByUserId
          deleted
          updatedAt
          organizationCompaniesId
          __typename
        }
        chairContactId
        chairContact {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        operatorId
        operator {
          id
          name
          type
          createdAt
          createdByUserId
          deleted
          updatedAt
          organizationCompaniesId
          __typename
        }
        operatorContactId
        operatorContact {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        admins {
          nextToken
          __typename
        }
        airports {
          nextToken
          __typename
        }
        companies {
          nextToken
          __typename
        }
        members {
          nextToken
          __typename
        }
        documents {
          nextToken
          __typename
        }
        calendar {
          nextToken
          __typename
        }
        contacts {
          nextToken
          __typename
        }
        createdAt
        createdByUserId
        createdBy {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        modifications {
          fieldName
          fieldValue
          dataOperation
          modifiedAt
          id
          createdAt
          updatedAt
          __typename
        }
        supportAdmin {
          nextToken
          __typename
        }
        deleted
        updatedAt
        companyOrganizationsId
        userOrganizationId
        __typename
      }
      chairId
      chair {
        id
        name
        type
        organizations {
          nextToken
          __typename
        }
        members {
          nextToken
          __typename
        }
        createdAt
        createdByUserId
        createdBy {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        deleted
        modifications {
          fieldName
          fieldValue
          dataOperation
          modifiedAt
          id
          createdAt
          updatedAt
          __typename
        }
        updatedAt
        organizationCompaniesId
        __typename
      }
      chairContactId
      chairContact {
        id
        cognitoUserId
        termsAgree
        termsAgreeDate
        participationAgreement
        participationAgreementDate
        organization {
          nextToken
          __typename
        }
        roles
        companyId
        company {
          id
          name
          type
          createdAt
          createdByUserId
          deleted
          updatedAt
          organizationCompaniesId
          __typename
        }
        firstName
        lastName
        email
        office
        mobile
        linkedInUrl
        imageUrl
        timeZone
        monthlyUpdates
        generalAnnouncements
        createdAt
        createdByUserId
        createdBy {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        modifications {
          fieldName
          fieldValue
          dataOperation
          modifiedAt
          id
          createdAt
          updatedAt
          __typename
        }
        organizationAdmin {
          nextToken
          __typename
        }
        organizationMember {
          nextToken
          __typename
        }
        deleted
        lastLoginDate
        weeklyDigestNotification
        monthlyDigestNotification
        quarterlyEmailNotification
        annualDigestNotification
        membershipAlertsNotification
        generalEmailNotification
        organizationSupportAdmin {
          nextToken
          __typename
        }
        updatedAt
        organizationContactsId
        __typename
      }
      operatorId
      operator {
        id
        name
        type
        organizations {
          nextToken
          __typename
        }
        members {
          nextToken
          __typename
        }
        createdAt
        createdByUserId
        createdBy {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        deleted
        modifications {
          fieldName
          fieldValue
          dataOperation
          modifiedAt
          id
          createdAt
          updatedAt
          __typename
        }
        updatedAt
        organizationCompaniesId
        __typename
      }
      operatorGeneralManagerId
      operatorGeneralManager {
        id
        cognitoUserId
        termsAgree
        termsAgreeDate
        participationAgreement
        participationAgreementDate
        organization {
          nextToken
          __typename
        }
        roles
        companyId
        company {
          id
          name
          type
          createdAt
          createdByUserId
          deleted
          updatedAt
          organizationCompaniesId
          __typename
        }
        firstName
        lastName
        email
        office
        mobile
        linkedInUrl
        imageUrl
        timeZone
        monthlyUpdates
        generalAnnouncements
        createdAt
        createdByUserId
        createdBy {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        modifications {
          fieldName
          fieldValue
          dataOperation
          modifiedAt
          id
          createdAt
          updatedAt
          __typename
        }
        organizationAdmin {
          nextToken
          __typename
        }
        organizationMember {
          nextToken
          __typename
        }
        deleted
        lastLoginDate
        weeklyDigestNotification
        monthlyDigestNotification
        quarterlyEmailNotification
        annualDigestNotification
        membershipAlertsNotification
        generalEmailNotification
        organizationSupportAdmin {
          nextToken
          __typename
        }
        updatedAt
        organizationContactsId
        __typename
      }
      secondaryContact
      facilityOwner
      facilityOwnerContact
      legalCounselContact
      legalCounsel
      facilityLocation
      totalCapacityDays
      totalCapacityGallons
      secured
      moExpiration
      moType
      moTypeCustomValue
      leaseExpiration
      leaseType
      leaseTypeCustomValue
      dateLastFinancialSUP
      dateLastA4aOperationalReview
      netInventoryCalculation
      entryFee
      nonMemberRate
      costSharingFormula
      reserveDepositPrebill
      thirdPartyDebt
      memberLoans
      dateLastPropertyAppraisal
      aviationLiabilityLimit
      environmentalLiabilityLimit
      comments
      deleted
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateAirportConsortiumGroup = /* GraphQL */ `
  mutation UpdateAirportConsortiumGroup(
    $input: UpdateAirportConsortiumGroupInput!
    $condition: ModelAirportConsortiumGroupConditionInput
  ) {
    updateAirportConsortiumGroup(input: $input, condition: $condition) {
      id
      organizationId
      airportId
      airport {
        id
        name
        code
        oldCode
        facility
        region
        state
        place {
          terminal
          gate
          lat
          lon
          __typename
        }
        consortiumGroup {
          nextToken
          __typename
        }
        consortiumType
        documents {
          nextToken
          __typename
        }
        chairId
        chair {
          id
          name
          type
          createdAt
          createdByUserId
          deleted
          updatedAt
          organizationCompaniesId
          __typename
        }
        chairContactId
        chairContact {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        operatorId
        operator {
          id
          name
          type
          createdAt
          createdByUserId
          deleted
          updatedAt
          organizationCompaniesId
          __typename
        }
        operatorGeneralManagerId
        operatorGeneralManager {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        secondaryContactId
        secondaryContact {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        facilityOwnerId
        facilityOwner {
          id
          name
          type
          createdAt
          createdByUserId
          deleted
          updatedAt
          organizationCompaniesId
          __typename
        }
        facilityOwnerContactId
        facilityOwnerContact {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        inventoryAccounting
        deliveryToPlane {
          nextToken
          __typename
        }
        deliveryToFacility {
          nextToken
          __typename
        }
        storage {
          nextToken
          __typename
        }
        createdAt
        createdBy {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        modifications {
          fieldName
          fieldValue
          dataOperation
          modifiedAt
          id
          createdAt
          updatedAt
          __typename
        }
        organizationAirportsId
        deleted
        updatedAt
        __typename
      }
      organization {
        id
        name
        organizationType
        groupType
        chairId
        chair {
          id
          name
          type
          createdAt
          createdByUserId
          deleted
          updatedAt
          organizationCompaniesId
          __typename
        }
        chairContactId
        chairContact {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        operatorId
        operator {
          id
          name
          type
          createdAt
          createdByUserId
          deleted
          updatedAt
          organizationCompaniesId
          __typename
        }
        operatorContactId
        operatorContact {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        admins {
          nextToken
          __typename
        }
        airports {
          nextToken
          __typename
        }
        companies {
          nextToken
          __typename
        }
        members {
          nextToken
          __typename
        }
        documents {
          nextToken
          __typename
        }
        calendar {
          nextToken
          __typename
        }
        contacts {
          nextToken
          __typename
        }
        createdAt
        createdByUserId
        createdBy {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        modifications {
          fieldName
          fieldValue
          dataOperation
          modifiedAt
          id
          createdAt
          updatedAt
          __typename
        }
        supportAdmin {
          nextToken
          __typename
        }
        deleted
        updatedAt
        companyOrganizationsId
        userOrganizationId
        __typename
      }
      chairId
      chair {
        id
        name
        type
        organizations {
          nextToken
          __typename
        }
        members {
          nextToken
          __typename
        }
        createdAt
        createdByUserId
        createdBy {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        deleted
        modifications {
          fieldName
          fieldValue
          dataOperation
          modifiedAt
          id
          createdAt
          updatedAt
          __typename
        }
        updatedAt
        organizationCompaniesId
        __typename
      }
      chairContactId
      chairContact {
        id
        cognitoUserId
        termsAgree
        termsAgreeDate
        participationAgreement
        participationAgreementDate
        organization {
          nextToken
          __typename
        }
        roles
        companyId
        company {
          id
          name
          type
          createdAt
          createdByUserId
          deleted
          updatedAt
          organizationCompaniesId
          __typename
        }
        firstName
        lastName
        email
        office
        mobile
        linkedInUrl
        imageUrl
        timeZone
        monthlyUpdates
        generalAnnouncements
        createdAt
        createdByUserId
        createdBy {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        modifications {
          fieldName
          fieldValue
          dataOperation
          modifiedAt
          id
          createdAt
          updatedAt
          __typename
        }
        organizationAdmin {
          nextToken
          __typename
        }
        organizationMember {
          nextToken
          __typename
        }
        deleted
        lastLoginDate
        weeklyDigestNotification
        monthlyDigestNotification
        quarterlyEmailNotification
        annualDigestNotification
        membershipAlertsNotification
        generalEmailNotification
        organizationSupportAdmin {
          nextToken
          __typename
        }
        updatedAt
        organizationContactsId
        __typename
      }
      operatorId
      operator {
        id
        name
        type
        organizations {
          nextToken
          __typename
        }
        members {
          nextToken
          __typename
        }
        createdAt
        createdByUserId
        createdBy {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        deleted
        modifications {
          fieldName
          fieldValue
          dataOperation
          modifiedAt
          id
          createdAt
          updatedAt
          __typename
        }
        updatedAt
        organizationCompaniesId
        __typename
      }
      operatorGeneralManagerId
      operatorGeneralManager {
        id
        cognitoUserId
        termsAgree
        termsAgreeDate
        participationAgreement
        participationAgreementDate
        organization {
          nextToken
          __typename
        }
        roles
        companyId
        company {
          id
          name
          type
          createdAt
          createdByUserId
          deleted
          updatedAt
          organizationCompaniesId
          __typename
        }
        firstName
        lastName
        email
        office
        mobile
        linkedInUrl
        imageUrl
        timeZone
        monthlyUpdates
        generalAnnouncements
        createdAt
        createdByUserId
        createdBy {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        modifications {
          fieldName
          fieldValue
          dataOperation
          modifiedAt
          id
          createdAt
          updatedAt
          __typename
        }
        organizationAdmin {
          nextToken
          __typename
        }
        organizationMember {
          nextToken
          __typename
        }
        deleted
        lastLoginDate
        weeklyDigestNotification
        monthlyDigestNotification
        quarterlyEmailNotification
        annualDigestNotification
        membershipAlertsNotification
        generalEmailNotification
        organizationSupportAdmin {
          nextToken
          __typename
        }
        updatedAt
        organizationContactsId
        __typename
      }
      secondaryContact
      facilityOwner
      facilityOwnerContact
      legalCounselContact
      legalCounsel
      facilityLocation
      totalCapacityDays
      totalCapacityGallons
      secured
      moExpiration
      moType
      moTypeCustomValue
      leaseExpiration
      leaseType
      leaseTypeCustomValue
      dateLastFinancialSUP
      dateLastA4aOperationalReview
      netInventoryCalculation
      entryFee
      nonMemberRate
      costSharingFormula
      reserveDepositPrebill
      thirdPartyDebt
      memberLoans
      dateLastPropertyAppraisal
      aviationLiabilityLimit
      environmentalLiabilityLimit
      comments
      deleted
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteAirportConsortiumGroup = /* GraphQL */ `
  mutation DeleteAirportConsortiumGroup(
    $input: DeleteAirportConsortiumGroupInput!
    $condition: ModelAirportConsortiumGroupConditionInput
  ) {
    deleteAirportConsortiumGroup(input: $input, condition: $condition) {
      id
      organizationId
      airportId
      airport {
        id
        name
        code
        oldCode
        facility
        region
        state
        place {
          terminal
          gate
          lat
          lon
          __typename
        }
        consortiumGroup {
          nextToken
          __typename
        }
        consortiumType
        documents {
          nextToken
          __typename
        }
        chairId
        chair {
          id
          name
          type
          createdAt
          createdByUserId
          deleted
          updatedAt
          organizationCompaniesId
          __typename
        }
        chairContactId
        chairContact {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        operatorId
        operator {
          id
          name
          type
          createdAt
          createdByUserId
          deleted
          updatedAt
          organizationCompaniesId
          __typename
        }
        operatorGeneralManagerId
        operatorGeneralManager {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        secondaryContactId
        secondaryContact {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        facilityOwnerId
        facilityOwner {
          id
          name
          type
          createdAt
          createdByUserId
          deleted
          updatedAt
          organizationCompaniesId
          __typename
        }
        facilityOwnerContactId
        facilityOwnerContact {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        inventoryAccounting
        deliveryToPlane {
          nextToken
          __typename
        }
        deliveryToFacility {
          nextToken
          __typename
        }
        storage {
          nextToken
          __typename
        }
        createdAt
        createdBy {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        modifications {
          fieldName
          fieldValue
          dataOperation
          modifiedAt
          id
          createdAt
          updatedAt
          __typename
        }
        organizationAirportsId
        deleted
        updatedAt
        __typename
      }
      organization {
        id
        name
        organizationType
        groupType
        chairId
        chair {
          id
          name
          type
          createdAt
          createdByUserId
          deleted
          updatedAt
          organizationCompaniesId
          __typename
        }
        chairContactId
        chairContact {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        operatorId
        operator {
          id
          name
          type
          createdAt
          createdByUserId
          deleted
          updatedAt
          organizationCompaniesId
          __typename
        }
        operatorContactId
        operatorContact {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        admins {
          nextToken
          __typename
        }
        airports {
          nextToken
          __typename
        }
        companies {
          nextToken
          __typename
        }
        members {
          nextToken
          __typename
        }
        documents {
          nextToken
          __typename
        }
        calendar {
          nextToken
          __typename
        }
        contacts {
          nextToken
          __typename
        }
        createdAt
        createdByUserId
        createdBy {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        modifications {
          fieldName
          fieldValue
          dataOperation
          modifiedAt
          id
          createdAt
          updatedAt
          __typename
        }
        supportAdmin {
          nextToken
          __typename
        }
        deleted
        updatedAt
        companyOrganizationsId
        userOrganizationId
        __typename
      }
      chairId
      chair {
        id
        name
        type
        organizations {
          nextToken
          __typename
        }
        members {
          nextToken
          __typename
        }
        createdAt
        createdByUserId
        createdBy {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        deleted
        modifications {
          fieldName
          fieldValue
          dataOperation
          modifiedAt
          id
          createdAt
          updatedAt
          __typename
        }
        updatedAt
        organizationCompaniesId
        __typename
      }
      chairContactId
      chairContact {
        id
        cognitoUserId
        termsAgree
        termsAgreeDate
        participationAgreement
        participationAgreementDate
        organization {
          nextToken
          __typename
        }
        roles
        companyId
        company {
          id
          name
          type
          createdAt
          createdByUserId
          deleted
          updatedAt
          organizationCompaniesId
          __typename
        }
        firstName
        lastName
        email
        office
        mobile
        linkedInUrl
        imageUrl
        timeZone
        monthlyUpdates
        generalAnnouncements
        createdAt
        createdByUserId
        createdBy {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        modifications {
          fieldName
          fieldValue
          dataOperation
          modifiedAt
          id
          createdAt
          updatedAt
          __typename
        }
        organizationAdmin {
          nextToken
          __typename
        }
        organizationMember {
          nextToken
          __typename
        }
        deleted
        lastLoginDate
        weeklyDigestNotification
        monthlyDigestNotification
        quarterlyEmailNotification
        annualDigestNotification
        membershipAlertsNotification
        generalEmailNotification
        organizationSupportAdmin {
          nextToken
          __typename
        }
        updatedAt
        organizationContactsId
        __typename
      }
      operatorId
      operator {
        id
        name
        type
        organizations {
          nextToken
          __typename
        }
        members {
          nextToken
          __typename
        }
        createdAt
        createdByUserId
        createdBy {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        deleted
        modifications {
          fieldName
          fieldValue
          dataOperation
          modifiedAt
          id
          createdAt
          updatedAt
          __typename
        }
        updatedAt
        organizationCompaniesId
        __typename
      }
      operatorGeneralManagerId
      operatorGeneralManager {
        id
        cognitoUserId
        termsAgree
        termsAgreeDate
        participationAgreement
        participationAgreementDate
        organization {
          nextToken
          __typename
        }
        roles
        companyId
        company {
          id
          name
          type
          createdAt
          createdByUserId
          deleted
          updatedAt
          organizationCompaniesId
          __typename
        }
        firstName
        lastName
        email
        office
        mobile
        linkedInUrl
        imageUrl
        timeZone
        monthlyUpdates
        generalAnnouncements
        createdAt
        createdByUserId
        createdBy {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        modifications {
          fieldName
          fieldValue
          dataOperation
          modifiedAt
          id
          createdAt
          updatedAt
          __typename
        }
        organizationAdmin {
          nextToken
          __typename
        }
        organizationMember {
          nextToken
          __typename
        }
        deleted
        lastLoginDate
        weeklyDigestNotification
        monthlyDigestNotification
        quarterlyEmailNotification
        annualDigestNotification
        membershipAlertsNotification
        generalEmailNotification
        organizationSupportAdmin {
          nextToken
          __typename
        }
        updatedAt
        organizationContactsId
        __typename
      }
      secondaryContact
      facilityOwner
      facilityOwnerContact
      legalCounselContact
      legalCounsel
      facilityLocation
      totalCapacityDays
      totalCapacityGallons
      secured
      moExpiration
      moType
      moTypeCustomValue
      leaseExpiration
      leaseType
      leaseTypeCustomValue
      dateLastFinancialSUP
      dateLastA4aOperationalReview
      netInventoryCalculation
      entryFee
      nonMemberRate
      costSharingFormula
      reserveDepositPrebill
      thirdPartyDebt
      memberLoans
      dateLastPropertyAppraisal
      aviationLiabilityLimit
      environmentalLiabilityLimit
      comments
      deleted
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createDeliveryToPlane = /* GraphQL */ `
  mutation CreateDeliveryToPlane(
    $input: CreateDeliveryToPlaneInput!
    $condition: ModelDeliveryToPlaneConditionInput
  ) {
    createDeliveryToPlane(input: $input, condition: $condition) {
      id
      airportId
      airport {
        id
        name
        code
        oldCode
        facility
        region
        state
        place {
          terminal
          gate
          lat
          lon
          __typename
        }
        consortiumGroup {
          nextToken
          __typename
        }
        consortiumType
        documents {
          nextToken
          __typename
        }
        chairId
        chair {
          id
          name
          type
          createdAt
          createdByUserId
          deleted
          updatedAt
          organizationCompaniesId
          __typename
        }
        chairContactId
        chairContact {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        operatorId
        operator {
          id
          name
          type
          createdAt
          createdByUserId
          deleted
          updatedAt
          organizationCompaniesId
          __typename
        }
        operatorGeneralManagerId
        operatorGeneralManager {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        secondaryContactId
        secondaryContact {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        facilityOwnerId
        facilityOwner {
          id
          name
          type
          createdAt
          createdByUserId
          deleted
          updatedAt
          organizationCompaniesId
          __typename
        }
        facilityOwnerContactId
        facilityOwnerContact {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        inventoryAccounting
        deliveryToPlane {
          nextToken
          __typename
        }
        deliveryToFacility {
          nextToken
          __typename
        }
        storage {
          nextToken
          __typename
        }
        createdAt
        createdBy {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        modifications {
          fieldName
          fieldValue
          dataOperation
          modifiedAt
          id
          createdAt
          updatedAt
          __typename
        }
        organizationAirportsId
        deleted
        updatedAt
        __typename
      }
      organizationId
      organization {
        id
        name
        organizationType
        groupType
        chairId
        chair {
          id
          name
          type
          createdAt
          createdByUserId
          deleted
          updatedAt
          organizationCompaniesId
          __typename
        }
        chairContactId
        chairContact {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        operatorId
        operator {
          id
          name
          type
          createdAt
          createdByUserId
          deleted
          updatedAt
          organizationCompaniesId
          __typename
        }
        operatorContactId
        operatorContact {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        admins {
          nextToken
          __typename
        }
        airports {
          nextToken
          __typename
        }
        companies {
          nextToken
          __typename
        }
        members {
          nextToken
          __typename
        }
        documents {
          nextToken
          __typename
        }
        calendar {
          nextToken
          __typename
        }
        contacts {
          nextToken
          __typename
        }
        createdAt
        createdByUserId
        createdBy {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        modifications {
          fieldName
          fieldValue
          dataOperation
          modifiedAt
          id
          createdAt
          updatedAt
          __typename
        }
        supportAdmin {
          nextToken
          __typename
        }
        deleted
        updatedAt
        companyOrganizationsId
        userOrganizationId
        __typename
      }
      airportDeliveryToPlaneId
      obFiltration
      hydrant
      closedLoop
      length
      hydrantLocations
      pits
      refuelerLocations
      efso
      efsoLocation
      leakDetection
      leakDetectionDescription
      flowRateF1Peak
      flowRateF1Max
      flowRateF2Peak
      flowRateF2Max
      flowRateF3Peak
      flowRateF3Max
      pipingSizeMin
      pipingSizeMax
      currentIntoPlaneOperators
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateDeliveryToPlane = /* GraphQL */ `
  mutation UpdateDeliveryToPlane(
    $input: UpdateDeliveryToPlaneInput!
    $condition: ModelDeliveryToPlaneConditionInput
  ) {
    updateDeliveryToPlane(input: $input, condition: $condition) {
      id
      airportId
      airport {
        id
        name
        code
        oldCode
        facility
        region
        state
        place {
          terminal
          gate
          lat
          lon
          __typename
        }
        consortiumGroup {
          nextToken
          __typename
        }
        consortiumType
        documents {
          nextToken
          __typename
        }
        chairId
        chair {
          id
          name
          type
          createdAt
          createdByUserId
          deleted
          updatedAt
          organizationCompaniesId
          __typename
        }
        chairContactId
        chairContact {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        operatorId
        operator {
          id
          name
          type
          createdAt
          createdByUserId
          deleted
          updatedAt
          organizationCompaniesId
          __typename
        }
        operatorGeneralManagerId
        operatorGeneralManager {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        secondaryContactId
        secondaryContact {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        facilityOwnerId
        facilityOwner {
          id
          name
          type
          createdAt
          createdByUserId
          deleted
          updatedAt
          organizationCompaniesId
          __typename
        }
        facilityOwnerContactId
        facilityOwnerContact {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        inventoryAccounting
        deliveryToPlane {
          nextToken
          __typename
        }
        deliveryToFacility {
          nextToken
          __typename
        }
        storage {
          nextToken
          __typename
        }
        createdAt
        createdBy {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        modifications {
          fieldName
          fieldValue
          dataOperation
          modifiedAt
          id
          createdAt
          updatedAt
          __typename
        }
        organizationAirportsId
        deleted
        updatedAt
        __typename
      }
      organizationId
      organization {
        id
        name
        organizationType
        groupType
        chairId
        chair {
          id
          name
          type
          createdAt
          createdByUserId
          deleted
          updatedAt
          organizationCompaniesId
          __typename
        }
        chairContactId
        chairContact {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        operatorId
        operator {
          id
          name
          type
          createdAt
          createdByUserId
          deleted
          updatedAt
          organizationCompaniesId
          __typename
        }
        operatorContactId
        operatorContact {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        admins {
          nextToken
          __typename
        }
        airports {
          nextToken
          __typename
        }
        companies {
          nextToken
          __typename
        }
        members {
          nextToken
          __typename
        }
        documents {
          nextToken
          __typename
        }
        calendar {
          nextToken
          __typename
        }
        contacts {
          nextToken
          __typename
        }
        createdAt
        createdByUserId
        createdBy {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        modifications {
          fieldName
          fieldValue
          dataOperation
          modifiedAt
          id
          createdAt
          updatedAt
          __typename
        }
        supportAdmin {
          nextToken
          __typename
        }
        deleted
        updatedAt
        companyOrganizationsId
        userOrganizationId
        __typename
      }
      airportDeliveryToPlaneId
      obFiltration
      hydrant
      closedLoop
      length
      hydrantLocations
      pits
      refuelerLocations
      efso
      efsoLocation
      leakDetection
      leakDetectionDescription
      flowRateF1Peak
      flowRateF1Max
      flowRateF2Peak
      flowRateF2Max
      flowRateF3Peak
      flowRateF3Max
      pipingSizeMin
      pipingSizeMax
      currentIntoPlaneOperators
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteDeliveryToPlane = /* GraphQL */ `
  mutation DeleteDeliveryToPlane(
    $input: DeleteDeliveryToPlaneInput!
    $condition: ModelDeliveryToPlaneConditionInput
  ) {
    deleteDeliveryToPlane(input: $input, condition: $condition) {
      id
      airportId
      airport {
        id
        name
        code
        oldCode
        facility
        region
        state
        place {
          terminal
          gate
          lat
          lon
          __typename
        }
        consortiumGroup {
          nextToken
          __typename
        }
        consortiumType
        documents {
          nextToken
          __typename
        }
        chairId
        chair {
          id
          name
          type
          createdAt
          createdByUserId
          deleted
          updatedAt
          organizationCompaniesId
          __typename
        }
        chairContactId
        chairContact {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        operatorId
        operator {
          id
          name
          type
          createdAt
          createdByUserId
          deleted
          updatedAt
          organizationCompaniesId
          __typename
        }
        operatorGeneralManagerId
        operatorGeneralManager {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        secondaryContactId
        secondaryContact {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        facilityOwnerId
        facilityOwner {
          id
          name
          type
          createdAt
          createdByUserId
          deleted
          updatedAt
          organizationCompaniesId
          __typename
        }
        facilityOwnerContactId
        facilityOwnerContact {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        inventoryAccounting
        deliveryToPlane {
          nextToken
          __typename
        }
        deliveryToFacility {
          nextToken
          __typename
        }
        storage {
          nextToken
          __typename
        }
        createdAt
        createdBy {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        modifications {
          fieldName
          fieldValue
          dataOperation
          modifiedAt
          id
          createdAt
          updatedAt
          __typename
        }
        organizationAirportsId
        deleted
        updatedAt
        __typename
      }
      organizationId
      organization {
        id
        name
        organizationType
        groupType
        chairId
        chair {
          id
          name
          type
          createdAt
          createdByUserId
          deleted
          updatedAt
          organizationCompaniesId
          __typename
        }
        chairContactId
        chairContact {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        operatorId
        operator {
          id
          name
          type
          createdAt
          createdByUserId
          deleted
          updatedAt
          organizationCompaniesId
          __typename
        }
        operatorContactId
        operatorContact {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        admins {
          nextToken
          __typename
        }
        airports {
          nextToken
          __typename
        }
        companies {
          nextToken
          __typename
        }
        members {
          nextToken
          __typename
        }
        documents {
          nextToken
          __typename
        }
        calendar {
          nextToken
          __typename
        }
        contacts {
          nextToken
          __typename
        }
        createdAt
        createdByUserId
        createdBy {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        modifications {
          fieldName
          fieldValue
          dataOperation
          modifiedAt
          id
          createdAt
          updatedAt
          __typename
        }
        supportAdmin {
          nextToken
          __typename
        }
        deleted
        updatedAt
        companyOrganizationsId
        userOrganizationId
        __typename
      }
      airportDeliveryToPlaneId
      obFiltration
      hydrant
      closedLoop
      length
      hydrantLocations
      pits
      refuelerLocations
      efso
      efsoLocation
      leakDetection
      leakDetectionDescription
      flowRateF1Peak
      flowRateF1Max
      flowRateF2Peak
      flowRateF2Max
      flowRateF3Peak
      flowRateF3Max
      pipingSizeMin
      pipingSizeMax
      currentIntoPlaneOperators
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createDeliveryToFacility = /* GraphQL */ `
  mutation CreateDeliveryToFacility(
    $input: CreateDeliveryToFacilityInput!
    $condition: ModelDeliveryToFacilityConditionInput
  ) {
    createDeliveryToFacility(input: $input, condition: $condition) {
      id
      airportId
      airport {
        id
        name
        code
        oldCode
        facility
        region
        state
        place {
          terminal
          gate
          lat
          lon
          __typename
        }
        consortiumGroup {
          nextToken
          __typename
        }
        consortiumType
        documents {
          nextToken
          __typename
        }
        chairId
        chair {
          id
          name
          type
          createdAt
          createdByUserId
          deleted
          updatedAt
          organizationCompaniesId
          __typename
        }
        chairContactId
        chairContact {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        operatorId
        operator {
          id
          name
          type
          createdAt
          createdByUserId
          deleted
          updatedAt
          organizationCompaniesId
          __typename
        }
        operatorGeneralManagerId
        operatorGeneralManager {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        secondaryContactId
        secondaryContact {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        facilityOwnerId
        facilityOwner {
          id
          name
          type
          createdAt
          createdByUserId
          deleted
          updatedAt
          organizationCompaniesId
          __typename
        }
        facilityOwnerContactId
        facilityOwnerContact {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        inventoryAccounting
        deliveryToPlane {
          nextToken
          __typename
        }
        deliveryToFacility {
          nextToken
          __typename
        }
        storage {
          nextToken
          __typename
        }
        createdAt
        createdBy {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        modifications {
          fieldName
          fieldValue
          dataOperation
          modifiedAt
          id
          createdAt
          updatedAt
          __typename
        }
        organizationAirportsId
        deleted
        updatedAt
        __typename
      }
      provider
      organizationId
      organization {
        id
        name
        organizationType
        groupType
        chairId
        chair {
          id
          name
          type
          createdAt
          createdByUserId
          deleted
          updatedAt
          organizationCompaniesId
          __typename
        }
        chairContactId
        chairContact {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        operatorId
        operator {
          id
          name
          type
          createdAt
          createdByUserId
          deleted
          updatedAt
          organizationCompaniesId
          __typename
        }
        operatorContactId
        operatorContact {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        admins {
          nextToken
          __typename
        }
        airports {
          nextToken
          __typename
        }
        companies {
          nextToken
          __typename
        }
        members {
          nextToken
          __typename
        }
        documents {
          nextToken
          __typename
        }
        calendar {
          nextToken
          __typename
        }
        contacts {
          nextToken
          __typename
        }
        createdAt
        createdByUserId
        createdBy {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        modifications {
          fieldName
          fieldValue
          dataOperation
          modifiedAt
          id
          createdAt
          updatedAt
          __typename
        }
        supportAdmin {
          nextToken
          __typename
        }
        deleted
        updatedAt
        companyOrganizationsId
        userOrganizationId
        __typename
      }
      method
      primary
      numberLines
      frequency
      frequencyCustomValue
      filtrationType
      filtrationTypeCustomValue
      filtrationDescription
      flowRateTypical
      flowRateMax
      pipingSize
      offloadLocations
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateDeliveryToFacility = /* GraphQL */ `
  mutation UpdateDeliveryToFacility(
    $input: UpdateDeliveryToFacilityInput!
    $condition: ModelDeliveryToFacilityConditionInput
  ) {
    updateDeliveryToFacility(input: $input, condition: $condition) {
      id
      airportId
      airport {
        id
        name
        code
        oldCode
        facility
        region
        state
        place {
          terminal
          gate
          lat
          lon
          __typename
        }
        consortiumGroup {
          nextToken
          __typename
        }
        consortiumType
        documents {
          nextToken
          __typename
        }
        chairId
        chair {
          id
          name
          type
          createdAt
          createdByUserId
          deleted
          updatedAt
          organizationCompaniesId
          __typename
        }
        chairContactId
        chairContact {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        operatorId
        operator {
          id
          name
          type
          createdAt
          createdByUserId
          deleted
          updatedAt
          organizationCompaniesId
          __typename
        }
        operatorGeneralManagerId
        operatorGeneralManager {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        secondaryContactId
        secondaryContact {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        facilityOwnerId
        facilityOwner {
          id
          name
          type
          createdAt
          createdByUserId
          deleted
          updatedAt
          organizationCompaniesId
          __typename
        }
        facilityOwnerContactId
        facilityOwnerContact {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        inventoryAccounting
        deliveryToPlane {
          nextToken
          __typename
        }
        deliveryToFacility {
          nextToken
          __typename
        }
        storage {
          nextToken
          __typename
        }
        createdAt
        createdBy {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        modifications {
          fieldName
          fieldValue
          dataOperation
          modifiedAt
          id
          createdAt
          updatedAt
          __typename
        }
        organizationAirportsId
        deleted
        updatedAt
        __typename
      }
      provider
      organizationId
      organization {
        id
        name
        organizationType
        groupType
        chairId
        chair {
          id
          name
          type
          createdAt
          createdByUserId
          deleted
          updatedAt
          organizationCompaniesId
          __typename
        }
        chairContactId
        chairContact {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        operatorId
        operator {
          id
          name
          type
          createdAt
          createdByUserId
          deleted
          updatedAt
          organizationCompaniesId
          __typename
        }
        operatorContactId
        operatorContact {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        admins {
          nextToken
          __typename
        }
        airports {
          nextToken
          __typename
        }
        companies {
          nextToken
          __typename
        }
        members {
          nextToken
          __typename
        }
        documents {
          nextToken
          __typename
        }
        calendar {
          nextToken
          __typename
        }
        contacts {
          nextToken
          __typename
        }
        createdAt
        createdByUserId
        createdBy {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        modifications {
          fieldName
          fieldValue
          dataOperation
          modifiedAt
          id
          createdAt
          updatedAt
          __typename
        }
        supportAdmin {
          nextToken
          __typename
        }
        deleted
        updatedAt
        companyOrganizationsId
        userOrganizationId
        __typename
      }
      method
      primary
      numberLines
      frequency
      frequencyCustomValue
      filtrationType
      filtrationTypeCustomValue
      filtrationDescription
      flowRateTypical
      flowRateMax
      pipingSize
      offloadLocations
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteDeliveryToFacility = /* GraphQL */ `
  mutation DeleteDeliveryToFacility(
    $input: DeleteDeliveryToFacilityInput!
    $condition: ModelDeliveryToFacilityConditionInput
  ) {
    deleteDeliveryToFacility(input: $input, condition: $condition) {
      id
      airportId
      airport {
        id
        name
        code
        oldCode
        facility
        region
        state
        place {
          terminal
          gate
          lat
          lon
          __typename
        }
        consortiumGroup {
          nextToken
          __typename
        }
        consortiumType
        documents {
          nextToken
          __typename
        }
        chairId
        chair {
          id
          name
          type
          createdAt
          createdByUserId
          deleted
          updatedAt
          organizationCompaniesId
          __typename
        }
        chairContactId
        chairContact {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        operatorId
        operator {
          id
          name
          type
          createdAt
          createdByUserId
          deleted
          updatedAt
          organizationCompaniesId
          __typename
        }
        operatorGeneralManagerId
        operatorGeneralManager {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        secondaryContactId
        secondaryContact {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        facilityOwnerId
        facilityOwner {
          id
          name
          type
          createdAt
          createdByUserId
          deleted
          updatedAt
          organizationCompaniesId
          __typename
        }
        facilityOwnerContactId
        facilityOwnerContact {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        inventoryAccounting
        deliveryToPlane {
          nextToken
          __typename
        }
        deliveryToFacility {
          nextToken
          __typename
        }
        storage {
          nextToken
          __typename
        }
        createdAt
        createdBy {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        modifications {
          fieldName
          fieldValue
          dataOperation
          modifiedAt
          id
          createdAt
          updatedAt
          __typename
        }
        organizationAirportsId
        deleted
        updatedAt
        __typename
      }
      provider
      organizationId
      organization {
        id
        name
        organizationType
        groupType
        chairId
        chair {
          id
          name
          type
          createdAt
          createdByUserId
          deleted
          updatedAt
          organizationCompaniesId
          __typename
        }
        chairContactId
        chairContact {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        operatorId
        operator {
          id
          name
          type
          createdAt
          createdByUserId
          deleted
          updatedAt
          organizationCompaniesId
          __typename
        }
        operatorContactId
        operatorContact {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        admins {
          nextToken
          __typename
        }
        airports {
          nextToken
          __typename
        }
        companies {
          nextToken
          __typename
        }
        members {
          nextToken
          __typename
        }
        documents {
          nextToken
          __typename
        }
        calendar {
          nextToken
          __typename
        }
        contacts {
          nextToken
          __typename
        }
        createdAt
        createdByUserId
        createdBy {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        modifications {
          fieldName
          fieldValue
          dataOperation
          modifiedAt
          id
          createdAt
          updatedAt
          __typename
        }
        supportAdmin {
          nextToken
          __typename
        }
        deleted
        updatedAt
        companyOrganizationsId
        userOrganizationId
        __typename
      }
      method
      primary
      numberLines
      frequency
      frequencyCustomValue
      filtrationType
      filtrationTypeCustomValue
      filtrationDescription
      flowRateTypical
      flowRateMax
      pipingSize
      offloadLocations
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createStorage = /* GraphQL */ `
  mutation CreateStorage(
    $input: CreateStorageInput!
    $condition: ModelStorageConditionInput
  ) {
    createStorage(input: $input, condition: $condition) {
      id
      airportId
      airport {
        id
        name
        code
        oldCode
        facility
        region
        state
        place {
          terminal
          gate
          lat
          lon
          __typename
        }
        consortiumGroup {
          nextToken
          __typename
        }
        consortiumType
        documents {
          nextToken
          __typename
        }
        chairId
        chair {
          id
          name
          type
          createdAt
          createdByUserId
          deleted
          updatedAt
          organizationCompaniesId
          __typename
        }
        chairContactId
        chairContact {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        operatorId
        operator {
          id
          name
          type
          createdAt
          createdByUserId
          deleted
          updatedAt
          organizationCompaniesId
          __typename
        }
        operatorGeneralManagerId
        operatorGeneralManager {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        secondaryContactId
        secondaryContact {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        facilityOwnerId
        facilityOwner {
          id
          name
          type
          createdAt
          createdByUserId
          deleted
          updatedAt
          organizationCompaniesId
          __typename
        }
        facilityOwnerContactId
        facilityOwnerContact {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        inventoryAccounting
        deliveryToPlane {
          nextToken
          __typename
        }
        deliveryToFacility {
          nextToken
          __typename
        }
        storage {
          nextToken
          __typename
        }
        createdAt
        createdBy {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        modifications {
          fieldName
          fieldValue
          dataOperation
          modifiedAt
          id
          createdAt
          updatedAt
          __typename
        }
        organizationAirportsId
        deleted
        updatedAt
        __typename
      }
      organizationId
      organization {
        id
        name
        organizationType
        groupType
        chairId
        chair {
          id
          name
          type
          createdAt
          createdByUserId
          deleted
          updatedAt
          organizationCompaniesId
          __typename
        }
        chairContactId
        chairContact {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        operatorId
        operator {
          id
          name
          type
          createdAt
          createdByUserId
          deleted
          updatedAt
          organizationCompaniesId
          __typename
        }
        operatorContactId
        operatorContact {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        admins {
          nextToken
          __typename
        }
        airports {
          nextToken
          __typename
        }
        companies {
          nextToken
          __typename
        }
        members {
          nextToken
          __typename
        }
        documents {
          nextToken
          __typename
        }
        calendar {
          nextToken
          __typename
        }
        contacts {
          nextToken
          __typename
        }
        createdAt
        createdByUserId
        createdBy {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        modifications {
          fieldName
          fieldValue
          dataOperation
          modifiedAt
          id
          createdAt
          updatedAt
          __typename
        }
        supportAdmin {
          nextToken
          __typename
        }
        deleted
        updatedAt
        companyOrganizationsId
        userOrganizationId
        __typename
      }
      tankId
      yearInstalled
      product
      storageLocation
      storageASTUST
      nextAPI653
      storageFunction
      totalBBL
      usableBBL
      opStatus
      owner
      security
      secondaryContainment
      cathodicProtection
      leakDetection
      totalGals
      usableGals
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateStorage = /* GraphQL */ `
  mutation UpdateStorage(
    $input: UpdateStorageInput!
    $condition: ModelStorageConditionInput
  ) {
    updateStorage(input: $input, condition: $condition) {
      id
      airportId
      airport {
        id
        name
        code
        oldCode
        facility
        region
        state
        place {
          terminal
          gate
          lat
          lon
          __typename
        }
        consortiumGroup {
          nextToken
          __typename
        }
        consortiumType
        documents {
          nextToken
          __typename
        }
        chairId
        chair {
          id
          name
          type
          createdAt
          createdByUserId
          deleted
          updatedAt
          organizationCompaniesId
          __typename
        }
        chairContactId
        chairContact {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        operatorId
        operator {
          id
          name
          type
          createdAt
          createdByUserId
          deleted
          updatedAt
          organizationCompaniesId
          __typename
        }
        operatorGeneralManagerId
        operatorGeneralManager {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        secondaryContactId
        secondaryContact {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        facilityOwnerId
        facilityOwner {
          id
          name
          type
          createdAt
          createdByUserId
          deleted
          updatedAt
          organizationCompaniesId
          __typename
        }
        facilityOwnerContactId
        facilityOwnerContact {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        inventoryAccounting
        deliveryToPlane {
          nextToken
          __typename
        }
        deliveryToFacility {
          nextToken
          __typename
        }
        storage {
          nextToken
          __typename
        }
        createdAt
        createdBy {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        modifications {
          fieldName
          fieldValue
          dataOperation
          modifiedAt
          id
          createdAt
          updatedAt
          __typename
        }
        organizationAirportsId
        deleted
        updatedAt
        __typename
      }
      organizationId
      organization {
        id
        name
        organizationType
        groupType
        chairId
        chair {
          id
          name
          type
          createdAt
          createdByUserId
          deleted
          updatedAt
          organizationCompaniesId
          __typename
        }
        chairContactId
        chairContact {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        operatorId
        operator {
          id
          name
          type
          createdAt
          createdByUserId
          deleted
          updatedAt
          organizationCompaniesId
          __typename
        }
        operatorContactId
        operatorContact {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        admins {
          nextToken
          __typename
        }
        airports {
          nextToken
          __typename
        }
        companies {
          nextToken
          __typename
        }
        members {
          nextToken
          __typename
        }
        documents {
          nextToken
          __typename
        }
        calendar {
          nextToken
          __typename
        }
        contacts {
          nextToken
          __typename
        }
        createdAt
        createdByUserId
        createdBy {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        modifications {
          fieldName
          fieldValue
          dataOperation
          modifiedAt
          id
          createdAt
          updatedAt
          __typename
        }
        supportAdmin {
          nextToken
          __typename
        }
        deleted
        updatedAt
        companyOrganizationsId
        userOrganizationId
        __typename
      }
      tankId
      yearInstalled
      product
      storageLocation
      storageASTUST
      nextAPI653
      storageFunction
      totalBBL
      usableBBL
      opStatus
      owner
      security
      secondaryContainment
      cathodicProtection
      leakDetection
      totalGals
      usableGals
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteStorage = /* GraphQL */ `
  mutation DeleteStorage(
    $input: DeleteStorageInput!
    $condition: ModelStorageConditionInput
  ) {
    deleteStorage(input: $input, condition: $condition) {
      id
      airportId
      airport {
        id
        name
        code
        oldCode
        facility
        region
        state
        place {
          terminal
          gate
          lat
          lon
          __typename
        }
        consortiumGroup {
          nextToken
          __typename
        }
        consortiumType
        documents {
          nextToken
          __typename
        }
        chairId
        chair {
          id
          name
          type
          createdAt
          createdByUserId
          deleted
          updatedAt
          organizationCompaniesId
          __typename
        }
        chairContactId
        chairContact {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        operatorId
        operator {
          id
          name
          type
          createdAt
          createdByUserId
          deleted
          updatedAt
          organizationCompaniesId
          __typename
        }
        operatorGeneralManagerId
        operatorGeneralManager {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        secondaryContactId
        secondaryContact {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        facilityOwnerId
        facilityOwner {
          id
          name
          type
          createdAt
          createdByUserId
          deleted
          updatedAt
          organizationCompaniesId
          __typename
        }
        facilityOwnerContactId
        facilityOwnerContact {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        inventoryAccounting
        deliveryToPlane {
          nextToken
          __typename
        }
        deliveryToFacility {
          nextToken
          __typename
        }
        storage {
          nextToken
          __typename
        }
        createdAt
        createdBy {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        modifications {
          fieldName
          fieldValue
          dataOperation
          modifiedAt
          id
          createdAt
          updatedAt
          __typename
        }
        organizationAirportsId
        deleted
        updatedAt
        __typename
      }
      organizationId
      organization {
        id
        name
        organizationType
        groupType
        chairId
        chair {
          id
          name
          type
          createdAt
          createdByUserId
          deleted
          updatedAt
          organizationCompaniesId
          __typename
        }
        chairContactId
        chairContact {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        operatorId
        operator {
          id
          name
          type
          createdAt
          createdByUserId
          deleted
          updatedAt
          organizationCompaniesId
          __typename
        }
        operatorContactId
        operatorContact {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        admins {
          nextToken
          __typename
        }
        airports {
          nextToken
          __typename
        }
        companies {
          nextToken
          __typename
        }
        members {
          nextToken
          __typename
        }
        documents {
          nextToken
          __typename
        }
        calendar {
          nextToken
          __typename
        }
        contacts {
          nextToken
          __typename
        }
        createdAt
        createdByUserId
        createdBy {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        modifications {
          fieldName
          fieldValue
          dataOperation
          modifiedAt
          id
          createdAt
          updatedAt
          __typename
        }
        supportAdmin {
          nextToken
          __typename
        }
        deleted
        updatedAt
        companyOrganizationsId
        userOrganizationId
        __typename
      }
      tankId
      yearInstalled
      product
      storageLocation
      storageASTUST
      nextAPI653
      storageFunction
      totalBBL
      usableBBL
      opStatus
      owner
      security
      secondaryContainment
      cathodicProtection
      leakDetection
      totalGals
      usableGals
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createNotification = /* GraphQL */ `
  mutation CreateNotification(
    $input: CreateNotificationInput!
    $condition: ModelNotificationConditionInput
  ) {
    createNotification(input: $input, condition: $condition) {
      id
      type
      method
      scope {
        id
        name
        organizationType
        groupType
        chairId
        chair {
          id
          name
          type
          createdAt
          createdByUserId
          deleted
          updatedAt
          organizationCompaniesId
          __typename
        }
        chairContactId
        chairContact {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        operatorId
        operator {
          id
          name
          type
          createdAt
          createdByUserId
          deleted
          updatedAt
          organizationCompaniesId
          __typename
        }
        operatorContactId
        operatorContact {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        admins {
          nextToken
          __typename
        }
        airports {
          nextToken
          __typename
        }
        companies {
          nextToken
          __typename
        }
        members {
          nextToken
          __typename
        }
        documents {
          nextToken
          __typename
        }
        calendar {
          nextToken
          __typename
        }
        contacts {
          nextToken
          __typename
        }
        createdAt
        createdByUserId
        createdBy {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        modifications {
          fieldName
          fieldValue
          dataOperation
          modifiedAt
          id
          createdAt
          updatedAt
          __typename
        }
        supportAdmin {
          nextToken
          __typename
        }
        deleted
        updatedAt
        companyOrganizationsId
        userOrganizationId
        __typename
      }
      notificationDate
      title
      description
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateNotification = /* GraphQL */ `
  mutation UpdateNotification(
    $input: UpdateNotificationInput!
    $condition: ModelNotificationConditionInput
  ) {
    updateNotification(input: $input, condition: $condition) {
      id
      type
      method
      scope {
        id
        name
        organizationType
        groupType
        chairId
        chair {
          id
          name
          type
          createdAt
          createdByUserId
          deleted
          updatedAt
          organizationCompaniesId
          __typename
        }
        chairContactId
        chairContact {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        operatorId
        operator {
          id
          name
          type
          createdAt
          createdByUserId
          deleted
          updatedAt
          organizationCompaniesId
          __typename
        }
        operatorContactId
        operatorContact {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        admins {
          nextToken
          __typename
        }
        airports {
          nextToken
          __typename
        }
        companies {
          nextToken
          __typename
        }
        members {
          nextToken
          __typename
        }
        documents {
          nextToken
          __typename
        }
        calendar {
          nextToken
          __typename
        }
        contacts {
          nextToken
          __typename
        }
        createdAt
        createdByUserId
        createdBy {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        modifications {
          fieldName
          fieldValue
          dataOperation
          modifiedAt
          id
          createdAt
          updatedAt
          __typename
        }
        supportAdmin {
          nextToken
          __typename
        }
        deleted
        updatedAt
        companyOrganizationsId
        userOrganizationId
        __typename
      }
      notificationDate
      title
      description
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteNotification = /* GraphQL */ `
  mutation DeleteNotification(
    $input: DeleteNotificationInput!
    $condition: ModelNotificationConditionInput
  ) {
    deleteNotification(input: $input, condition: $condition) {
      id
      type
      method
      scope {
        id
        name
        organizationType
        groupType
        chairId
        chair {
          id
          name
          type
          createdAt
          createdByUserId
          deleted
          updatedAt
          organizationCompaniesId
          __typename
        }
        chairContactId
        chairContact {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        operatorId
        operator {
          id
          name
          type
          createdAt
          createdByUserId
          deleted
          updatedAt
          organizationCompaniesId
          __typename
        }
        operatorContactId
        operatorContact {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        admins {
          nextToken
          __typename
        }
        airports {
          nextToken
          __typename
        }
        companies {
          nextToken
          __typename
        }
        members {
          nextToken
          __typename
        }
        documents {
          nextToken
          __typename
        }
        calendar {
          nextToken
          __typename
        }
        contacts {
          nextToken
          __typename
        }
        createdAt
        createdByUserId
        createdBy {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        modifications {
          fieldName
          fieldValue
          dataOperation
          modifiedAt
          id
          createdAt
          updatedAt
          __typename
        }
        supportAdmin {
          nextToken
          __typename
        }
        deleted
        updatedAt
        companyOrganizationsId
        userOrganizationId
        __typename
      }
      notificationDate
      title
      description
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createModifyRecord = /* GraphQL */ `
  mutation CreateModifyRecord(
    $input: CreateModifyRecordInput!
    $condition: ModelModifyRecordConditionInput
  ) {
    createModifyRecord(input: $input, condition: $condition) {
      fieldName
      fieldValue
      dataOperation
      modifiedAt
      modifiedBy {
        id
        cognitoUserId
        termsAgree
        termsAgreeDate
        participationAgreement
        participationAgreementDate
        organization {
          nextToken
          __typename
        }
        roles
        companyId
        company {
          id
          name
          type
          createdAt
          createdByUserId
          deleted
          updatedAt
          organizationCompaniesId
          __typename
        }
        firstName
        lastName
        email
        office
        mobile
        linkedInUrl
        imageUrl
        timeZone
        monthlyUpdates
        generalAnnouncements
        createdAt
        createdByUserId
        createdBy {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        modifications {
          fieldName
          fieldValue
          dataOperation
          modifiedAt
          id
          createdAt
          updatedAt
          __typename
        }
        organizationAdmin {
          nextToken
          __typename
        }
        organizationMember {
          nextToken
          __typename
        }
        deleted
        lastLoginDate
        weeklyDigestNotification
        monthlyDigestNotification
        quarterlyEmailNotification
        annualDigestNotification
        membershipAlertsNotification
        generalEmailNotification
        organizationSupportAdmin {
          nextToken
          __typename
        }
        updatedAt
        organizationContactsId
        __typename
      }
      id
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateModifyRecord = /* GraphQL */ `
  mutation UpdateModifyRecord(
    $input: UpdateModifyRecordInput!
    $condition: ModelModifyRecordConditionInput
  ) {
    updateModifyRecord(input: $input, condition: $condition) {
      fieldName
      fieldValue
      dataOperation
      modifiedAt
      modifiedBy {
        id
        cognitoUserId
        termsAgree
        termsAgreeDate
        participationAgreement
        participationAgreementDate
        organization {
          nextToken
          __typename
        }
        roles
        companyId
        company {
          id
          name
          type
          createdAt
          createdByUserId
          deleted
          updatedAt
          organizationCompaniesId
          __typename
        }
        firstName
        lastName
        email
        office
        mobile
        linkedInUrl
        imageUrl
        timeZone
        monthlyUpdates
        generalAnnouncements
        createdAt
        createdByUserId
        createdBy {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        modifications {
          fieldName
          fieldValue
          dataOperation
          modifiedAt
          id
          createdAt
          updatedAt
          __typename
        }
        organizationAdmin {
          nextToken
          __typename
        }
        organizationMember {
          nextToken
          __typename
        }
        deleted
        lastLoginDate
        weeklyDigestNotification
        monthlyDigestNotification
        quarterlyEmailNotification
        annualDigestNotification
        membershipAlertsNotification
        generalEmailNotification
        organizationSupportAdmin {
          nextToken
          __typename
        }
        updatedAt
        organizationContactsId
        __typename
      }
      id
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteModifyRecord = /* GraphQL */ `
  mutation DeleteModifyRecord(
    $input: DeleteModifyRecordInput!
    $condition: ModelModifyRecordConditionInput
  ) {
    deleteModifyRecord(input: $input, condition: $condition) {
      fieldName
      fieldValue
      dataOperation
      modifiedAt
      modifiedBy {
        id
        cognitoUserId
        termsAgree
        termsAgreeDate
        participationAgreement
        participationAgreementDate
        organization {
          nextToken
          __typename
        }
        roles
        companyId
        company {
          id
          name
          type
          createdAt
          createdByUserId
          deleted
          updatedAt
          organizationCompaniesId
          __typename
        }
        firstName
        lastName
        email
        office
        mobile
        linkedInUrl
        imageUrl
        timeZone
        monthlyUpdates
        generalAnnouncements
        createdAt
        createdByUserId
        createdBy {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        modifications {
          fieldName
          fieldValue
          dataOperation
          modifiedAt
          id
          createdAt
          updatedAt
          __typename
        }
        organizationAdmin {
          nextToken
          __typename
        }
        organizationMember {
          nextToken
          __typename
        }
        deleted
        lastLoginDate
        weeklyDigestNotification
        monthlyDigestNotification
        quarterlyEmailNotification
        annualDigestNotification
        membershipAlertsNotification
        generalEmailNotification
        organizationSupportAdmin {
          nextToken
          __typename
        }
        updatedAt
        organizationContactsId
        __typename
      }
      id
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createPageVisitLog = /* GraphQL */ `
  mutation CreatePageVisitLog(
    $input: CreatePageVisitLogInput!
    $condition: ModelPageVisitLogConditionInput
  ) {
    createPageVisitLog(input: $input, condition: $condition) {
      id
      userId
      name
      email
      cognitoUserId
      path
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updatePageVisitLog = /* GraphQL */ `
  mutation UpdatePageVisitLog(
    $input: UpdatePageVisitLogInput!
    $condition: ModelPageVisitLogConditionInput
  ) {
    updatePageVisitLog(input: $input, condition: $condition) {
      id
      userId
      name
      email
      cognitoUserId
      path
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deletePageVisitLog = /* GraphQL */ `
  mutation DeletePageVisitLog(
    $input: DeletePageVisitLogInput!
    $condition: ModelPageVisitLogConditionInput
  ) {
    deletePageVisitLog(input: $input, condition: $condition) {
      id
      userId
      name
      email
      cognitoUserId
      path
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createInviteLog = /* GraphQL */ `
  mutation CreateInviteLog(
    $input: CreateInviteLogInput!
    $condition: ModelInviteLogConditionInput
  ) {
    createInviteLog(input: $input, condition: $condition) {
      id
      organizationId
      organization {
        id
        name
        organizationType
        groupType
        chairId
        chair {
          id
          name
          type
          createdAt
          createdByUserId
          deleted
          updatedAt
          organizationCompaniesId
          __typename
        }
        chairContactId
        chairContact {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        operatorId
        operator {
          id
          name
          type
          createdAt
          createdByUserId
          deleted
          updatedAt
          organizationCompaniesId
          __typename
        }
        operatorContactId
        operatorContact {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        admins {
          nextToken
          __typename
        }
        airports {
          nextToken
          __typename
        }
        companies {
          nextToken
          __typename
        }
        members {
          nextToken
          __typename
        }
        documents {
          nextToken
          __typename
        }
        calendar {
          nextToken
          __typename
        }
        contacts {
          nextToken
          __typename
        }
        createdAt
        createdByUserId
        createdBy {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        modifications {
          fieldName
          fieldValue
          dataOperation
          modifiedAt
          id
          createdAt
          updatedAt
          __typename
        }
        supportAdmin {
          nextToken
          __typename
        }
        deleted
        updatedAt
        companyOrganizationsId
        userOrganizationId
        __typename
      }
      userId
      user {
        id
        cognitoUserId
        termsAgree
        termsAgreeDate
        participationAgreement
        participationAgreementDate
        organization {
          nextToken
          __typename
        }
        roles
        companyId
        company {
          id
          name
          type
          createdAt
          createdByUserId
          deleted
          updatedAt
          organizationCompaniesId
          __typename
        }
        firstName
        lastName
        email
        office
        mobile
        linkedInUrl
        imageUrl
        timeZone
        monthlyUpdates
        generalAnnouncements
        createdAt
        createdByUserId
        createdBy {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        modifications {
          fieldName
          fieldValue
          dataOperation
          modifiedAt
          id
          createdAt
          updatedAt
          __typename
        }
        organizationAdmin {
          nextToken
          __typename
        }
        organizationMember {
          nextToken
          __typename
        }
        deleted
        lastLoginDate
        weeklyDigestNotification
        monthlyDigestNotification
        quarterlyEmailNotification
        annualDigestNotification
        membershipAlertsNotification
        generalEmailNotification
        organizationSupportAdmin {
          nextToken
          __typename
        }
        updatedAt
        organizationContactsId
        __typename
      }
      isAccepted
      type
      sendByUserId
      sendBy {
        id
        cognitoUserId
        termsAgree
        termsAgreeDate
        participationAgreement
        participationAgreementDate
        organization {
          nextToken
          __typename
        }
        roles
        companyId
        company {
          id
          name
          type
          createdAt
          createdByUserId
          deleted
          updatedAt
          organizationCompaniesId
          __typename
        }
        firstName
        lastName
        email
        office
        mobile
        linkedInUrl
        imageUrl
        timeZone
        monthlyUpdates
        generalAnnouncements
        createdAt
        createdByUserId
        createdBy {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        modifications {
          fieldName
          fieldValue
          dataOperation
          modifiedAt
          id
          createdAt
          updatedAt
          __typename
        }
        organizationAdmin {
          nextToken
          __typename
        }
        organizationMember {
          nextToken
          __typename
        }
        deleted
        lastLoginDate
        weeklyDigestNotification
        monthlyDigestNotification
        quarterlyEmailNotification
        annualDigestNotification
        membershipAlertsNotification
        generalEmailNotification
        organizationSupportAdmin {
          nextToken
          __typename
        }
        updatedAt
        organizationContactsId
        __typename
      }
      createdAt
      acceptedAt
      deleted
      updatedAt
      __typename
    }
  }
`;
export const updateInviteLog = /* GraphQL */ `
  mutation UpdateInviteLog(
    $input: UpdateInviteLogInput!
    $condition: ModelInviteLogConditionInput
  ) {
    updateInviteLog(input: $input, condition: $condition) {
      id
      organizationId
      organization {
        id
        name
        organizationType
        groupType
        chairId
        chair {
          id
          name
          type
          createdAt
          createdByUserId
          deleted
          updatedAt
          organizationCompaniesId
          __typename
        }
        chairContactId
        chairContact {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        operatorId
        operator {
          id
          name
          type
          createdAt
          createdByUserId
          deleted
          updatedAt
          organizationCompaniesId
          __typename
        }
        operatorContactId
        operatorContact {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        admins {
          nextToken
          __typename
        }
        airports {
          nextToken
          __typename
        }
        companies {
          nextToken
          __typename
        }
        members {
          nextToken
          __typename
        }
        documents {
          nextToken
          __typename
        }
        calendar {
          nextToken
          __typename
        }
        contacts {
          nextToken
          __typename
        }
        createdAt
        createdByUserId
        createdBy {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        modifications {
          fieldName
          fieldValue
          dataOperation
          modifiedAt
          id
          createdAt
          updatedAt
          __typename
        }
        supportAdmin {
          nextToken
          __typename
        }
        deleted
        updatedAt
        companyOrganizationsId
        userOrganizationId
        __typename
      }
      userId
      user {
        id
        cognitoUserId
        termsAgree
        termsAgreeDate
        participationAgreement
        participationAgreementDate
        organization {
          nextToken
          __typename
        }
        roles
        companyId
        company {
          id
          name
          type
          createdAt
          createdByUserId
          deleted
          updatedAt
          organizationCompaniesId
          __typename
        }
        firstName
        lastName
        email
        office
        mobile
        linkedInUrl
        imageUrl
        timeZone
        monthlyUpdates
        generalAnnouncements
        createdAt
        createdByUserId
        createdBy {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        modifications {
          fieldName
          fieldValue
          dataOperation
          modifiedAt
          id
          createdAt
          updatedAt
          __typename
        }
        organizationAdmin {
          nextToken
          __typename
        }
        organizationMember {
          nextToken
          __typename
        }
        deleted
        lastLoginDate
        weeklyDigestNotification
        monthlyDigestNotification
        quarterlyEmailNotification
        annualDigestNotification
        membershipAlertsNotification
        generalEmailNotification
        organizationSupportAdmin {
          nextToken
          __typename
        }
        updatedAt
        organizationContactsId
        __typename
      }
      isAccepted
      type
      sendByUserId
      sendBy {
        id
        cognitoUserId
        termsAgree
        termsAgreeDate
        participationAgreement
        participationAgreementDate
        organization {
          nextToken
          __typename
        }
        roles
        companyId
        company {
          id
          name
          type
          createdAt
          createdByUserId
          deleted
          updatedAt
          organizationCompaniesId
          __typename
        }
        firstName
        lastName
        email
        office
        mobile
        linkedInUrl
        imageUrl
        timeZone
        monthlyUpdates
        generalAnnouncements
        createdAt
        createdByUserId
        createdBy {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        modifications {
          fieldName
          fieldValue
          dataOperation
          modifiedAt
          id
          createdAt
          updatedAt
          __typename
        }
        organizationAdmin {
          nextToken
          __typename
        }
        organizationMember {
          nextToken
          __typename
        }
        deleted
        lastLoginDate
        weeklyDigestNotification
        monthlyDigestNotification
        quarterlyEmailNotification
        annualDigestNotification
        membershipAlertsNotification
        generalEmailNotification
        organizationSupportAdmin {
          nextToken
          __typename
        }
        updatedAt
        organizationContactsId
        __typename
      }
      createdAt
      acceptedAt
      deleted
      updatedAt
      __typename
    }
  }
`;
export const deleteInviteLog = /* GraphQL */ `
  mutation DeleteInviteLog(
    $input: DeleteInviteLogInput!
    $condition: ModelInviteLogConditionInput
  ) {
    deleteInviteLog(input: $input, condition: $condition) {
      id
      organizationId
      organization {
        id
        name
        organizationType
        groupType
        chairId
        chair {
          id
          name
          type
          createdAt
          createdByUserId
          deleted
          updatedAt
          organizationCompaniesId
          __typename
        }
        chairContactId
        chairContact {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        operatorId
        operator {
          id
          name
          type
          createdAt
          createdByUserId
          deleted
          updatedAt
          organizationCompaniesId
          __typename
        }
        operatorContactId
        operatorContact {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        admins {
          nextToken
          __typename
        }
        airports {
          nextToken
          __typename
        }
        companies {
          nextToken
          __typename
        }
        members {
          nextToken
          __typename
        }
        documents {
          nextToken
          __typename
        }
        calendar {
          nextToken
          __typename
        }
        contacts {
          nextToken
          __typename
        }
        createdAt
        createdByUserId
        createdBy {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        modifications {
          fieldName
          fieldValue
          dataOperation
          modifiedAt
          id
          createdAt
          updatedAt
          __typename
        }
        supportAdmin {
          nextToken
          __typename
        }
        deleted
        updatedAt
        companyOrganizationsId
        userOrganizationId
        __typename
      }
      userId
      user {
        id
        cognitoUserId
        termsAgree
        termsAgreeDate
        participationAgreement
        participationAgreementDate
        organization {
          nextToken
          __typename
        }
        roles
        companyId
        company {
          id
          name
          type
          createdAt
          createdByUserId
          deleted
          updatedAt
          organizationCompaniesId
          __typename
        }
        firstName
        lastName
        email
        office
        mobile
        linkedInUrl
        imageUrl
        timeZone
        monthlyUpdates
        generalAnnouncements
        createdAt
        createdByUserId
        createdBy {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        modifications {
          fieldName
          fieldValue
          dataOperation
          modifiedAt
          id
          createdAt
          updatedAt
          __typename
        }
        organizationAdmin {
          nextToken
          __typename
        }
        organizationMember {
          nextToken
          __typename
        }
        deleted
        lastLoginDate
        weeklyDigestNotification
        monthlyDigestNotification
        quarterlyEmailNotification
        annualDigestNotification
        membershipAlertsNotification
        generalEmailNotification
        organizationSupportAdmin {
          nextToken
          __typename
        }
        updatedAt
        organizationContactsId
        __typename
      }
      isAccepted
      type
      sendByUserId
      sendBy {
        id
        cognitoUserId
        termsAgree
        termsAgreeDate
        participationAgreement
        participationAgreementDate
        organization {
          nextToken
          __typename
        }
        roles
        companyId
        company {
          id
          name
          type
          createdAt
          createdByUserId
          deleted
          updatedAt
          organizationCompaniesId
          __typename
        }
        firstName
        lastName
        email
        office
        mobile
        linkedInUrl
        imageUrl
        timeZone
        monthlyUpdates
        generalAnnouncements
        createdAt
        createdByUserId
        createdBy {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        modifications {
          fieldName
          fieldValue
          dataOperation
          modifiedAt
          id
          createdAt
          updatedAt
          __typename
        }
        organizationAdmin {
          nextToken
          __typename
        }
        organizationMember {
          nextToken
          __typename
        }
        deleted
        lastLoginDate
        weeklyDigestNotification
        monthlyDigestNotification
        quarterlyEmailNotification
        annualDigestNotification
        membershipAlertsNotification
        generalEmailNotification
        organizationSupportAdmin {
          nextToken
          __typename
        }
        updatedAt
        organizationContactsId
        __typename
      }
      createdAt
      acceptedAt
      deleted
      updatedAt
      __typename
    }
  }
`;
export const createOrgAdminUser = /* GraphQL */ `
  mutation CreateOrgAdminUser(
    $input: CreateOrgAdminUserInput!
    $condition: ModelOrgAdminUserConditionInput
  ) {
    createOrgAdminUser(input: $input, condition: $condition) {
      id
      organizationId
      userId
      organization {
        id
        name
        organizationType
        groupType
        chairId
        chair {
          id
          name
          type
          createdAt
          createdByUserId
          deleted
          updatedAt
          organizationCompaniesId
          __typename
        }
        chairContactId
        chairContact {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        operatorId
        operator {
          id
          name
          type
          createdAt
          createdByUserId
          deleted
          updatedAt
          organizationCompaniesId
          __typename
        }
        operatorContactId
        operatorContact {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        admins {
          nextToken
          __typename
        }
        airports {
          nextToken
          __typename
        }
        companies {
          nextToken
          __typename
        }
        members {
          nextToken
          __typename
        }
        documents {
          nextToken
          __typename
        }
        calendar {
          nextToken
          __typename
        }
        contacts {
          nextToken
          __typename
        }
        createdAt
        createdByUserId
        createdBy {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        modifications {
          fieldName
          fieldValue
          dataOperation
          modifiedAt
          id
          createdAt
          updatedAt
          __typename
        }
        supportAdmin {
          nextToken
          __typename
        }
        deleted
        updatedAt
        companyOrganizationsId
        userOrganizationId
        __typename
      }
      user {
        id
        cognitoUserId
        termsAgree
        termsAgreeDate
        participationAgreement
        participationAgreementDate
        organization {
          nextToken
          __typename
        }
        roles
        companyId
        company {
          id
          name
          type
          createdAt
          createdByUserId
          deleted
          updatedAt
          organizationCompaniesId
          __typename
        }
        firstName
        lastName
        email
        office
        mobile
        linkedInUrl
        imageUrl
        timeZone
        monthlyUpdates
        generalAnnouncements
        createdAt
        createdByUserId
        createdBy {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        modifications {
          fieldName
          fieldValue
          dataOperation
          modifiedAt
          id
          createdAt
          updatedAt
          __typename
        }
        organizationAdmin {
          nextToken
          __typename
        }
        organizationMember {
          nextToken
          __typename
        }
        deleted
        lastLoginDate
        weeklyDigestNotification
        monthlyDigestNotification
        quarterlyEmailNotification
        annualDigestNotification
        membershipAlertsNotification
        generalEmailNotification
        organizationSupportAdmin {
          nextToken
          __typename
        }
        updatedAt
        organizationContactsId
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateOrgAdminUser = /* GraphQL */ `
  mutation UpdateOrgAdminUser(
    $input: UpdateOrgAdminUserInput!
    $condition: ModelOrgAdminUserConditionInput
  ) {
    updateOrgAdminUser(input: $input, condition: $condition) {
      id
      organizationId
      userId
      organization {
        id
        name
        organizationType
        groupType
        chairId
        chair {
          id
          name
          type
          createdAt
          createdByUserId
          deleted
          updatedAt
          organizationCompaniesId
          __typename
        }
        chairContactId
        chairContact {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        operatorId
        operator {
          id
          name
          type
          createdAt
          createdByUserId
          deleted
          updatedAt
          organizationCompaniesId
          __typename
        }
        operatorContactId
        operatorContact {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        admins {
          nextToken
          __typename
        }
        airports {
          nextToken
          __typename
        }
        companies {
          nextToken
          __typename
        }
        members {
          nextToken
          __typename
        }
        documents {
          nextToken
          __typename
        }
        calendar {
          nextToken
          __typename
        }
        contacts {
          nextToken
          __typename
        }
        createdAt
        createdByUserId
        createdBy {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        modifications {
          fieldName
          fieldValue
          dataOperation
          modifiedAt
          id
          createdAt
          updatedAt
          __typename
        }
        supportAdmin {
          nextToken
          __typename
        }
        deleted
        updatedAt
        companyOrganizationsId
        userOrganizationId
        __typename
      }
      user {
        id
        cognitoUserId
        termsAgree
        termsAgreeDate
        participationAgreement
        participationAgreementDate
        organization {
          nextToken
          __typename
        }
        roles
        companyId
        company {
          id
          name
          type
          createdAt
          createdByUserId
          deleted
          updatedAt
          organizationCompaniesId
          __typename
        }
        firstName
        lastName
        email
        office
        mobile
        linkedInUrl
        imageUrl
        timeZone
        monthlyUpdates
        generalAnnouncements
        createdAt
        createdByUserId
        createdBy {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        modifications {
          fieldName
          fieldValue
          dataOperation
          modifiedAt
          id
          createdAt
          updatedAt
          __typename
        }
        organizationAdmin {
          nextToken
          __typename
        }
        organizationMember {
          nextToken
          __typename
        }
        deleted
        lastLoginDate
        weeklyDigestNotification
        monthlyDigestNotification
        quarterlyEmailNotification
        annualDigestNotification
        membershipAlertsNotification
        generalEmailNotification
        organizationSupportAdmin {
          nextToken
          __typename
        }
        updatedAt
        organizationContactsId
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteOrgAdminUser = /* GraphQL */ `
  mutation DeleteOrgAdminUser(
    $input: DeleteOrgAdminUserInput!
    $condition: ModelOrgAdminUserConditionInput
  ) {
    deleteOrgAdminUser(input: $input, condition: $condition) {
      id
      organizationId
      userId
      organization {
        id
        name
        organizationType
        groupType
        chairId
        chair {
          id
          name
          type
          createdAt
          createdByUserId
          deleted
          updatedAt
          organizationCompaniesId
          __typename
        }
        chairContactId
        chairContact {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        operatorId
        operator {
          id
          name
          type
          createdAt
          createdByUserId
          deleted
          updatedAt
          organizationCompaniesId
          __typename
        }
        operatorContactId
        operatorContact {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        admins {
          nextToken
          __typename
        }
        airports {
          nextToken
          __typename
        }
        companies {
          nextToken
          __typename
        }
        members {
          nextToken
          __typename
        }
        documents {
          nextToken
          __typename
        }
        calendar {
          nextToken
          __typename
        }
        contacts {
          nextToken
          __typename
        }
        createdAt
        createdByUserId
        createdBy {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        modifications {
          fieldName
          fieldValue
          dataOperation
          modifiedAt
          id
          createdAt
          updatedAt
          __typename
        }
        supportAdmin {
          nextToken
          __typename
        }
        deleted
        updatedAt
        companyOrganizationsId
        userOrganizationId
        __typename
      }
      user {
        id
        cognitoUserId
        termsAgree
        termsAgreeDate
        participationAgreement
        participationAgreementDate
        organization {
          nextToken
          __typename
        }
        roles
        companyId
        company {
          id
          name
          type
          createdAt
          createdByUserId
          deleted
          updatedAt
          organizationCompaniesId
          __typename
        }
        firstName
        lastName
        email
        office
        mobile
        linkedInUrl
        imageUrl
        timeZone
        monthlyUpdates
        generalAnnouncements
        createdAt
        createdByUserId
        createdBy {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        modifications {
          fieldName
          fieldValue
          dataOperation
          modifiedAt
          id
          createdAt
          updatedAt
          __typename
        }
        organizationAdmin {
          nextToken
          __typename
        }
        organizationMember {
          nextToken
          __typename
        }
        deleted
        lastLoginDate
        weeklyDigestNotification
        monthlyDigestNotification
        quarterlyEmailNotification
        annualDigestNotification
        membershipAlertsNotification
        generalEmailNotification
        organizationSupportAdmin {
          nextToken
          __typename
        }
        updatedAt
        organizationContactsId
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createOrgMemberUser = /* GraphQL */ `
  mutation CreateOrgMemberUser(
    $input: CreateOrgMemberUserInput!
    $condition: ModelOrgMemberUserConditionInput
  ) {
    createOrgMemberUser(input: $input, condition: $condition) {
      id
      organizationId
      userId
      organization {
        id
        name
        organizationType
        groupType
        chairId
        chair {
          id
          name
          type
          createdAt
          createdByUserId
          deleted
          updatedAt
          organizationCompaniesId
          __typename
        }
        chairContactId
        chairContact {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        operatorId
        operator {
          id
          name
          type
          createdAt
          createdByUserId
          deleted
          updatedAt
          organizationCompaniesId
          __typename
        }
        operatorContactId
        operatorContact {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        admins {
          nextToken
          __typename
        }
        airports {
          nextToken
          __typename
        }
        companies {
          nextToken
          __typename
        }
        members {
          nextToken
          __typename
        }
        documents {
          nextToken
          __typename
        }
        calendar {
          nextToken
          __typename
        }
        contacts {
          nextToken
          __typename
        }
        createdAt
        createdByUserId
        createdBy {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        modifications {
          fieldName
          fieldValue
          dataOperation
          modifiedAt
          id
          createdAt
          updatedAt
          __typename
        }
        supportAdmin {
          nextToken
          __typename
        }
        deleted
        updatedAt
        companyOrganizationsId
        userOrganizationId
        __typename
      }
      user {
        id
        cognitoUserId
        termsAgree
        termsAgreeDate
        participationAgreement
        participationAgreementDate
        organization {
          nextToken
          __typename
        }
        roles
        companyId
        company {
          id
          name
          type
          createdAt
          createdByUserId
          deleted
          updatedAt
          organizationCompaniesId
          __typename
        }
        firstName
        lastName
        email
        office
        mobile
        linkedInUrl
        imageUrl
        timeZone
        monthlyUpdates
        generalAnnouncements
        createdAt
        createdByUserId
        createdBy {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        modifications {
          fieldName
          fieldValue
          dataOperation
          modifiedAt
          id
          createdAt
          updatedAt
          __typename
        }
        organizationAdmin {
          nextToken
          __typename
        }
        organizationMember {
          nextToken
          __typename
        }
        deleted
        lastLoginDate
        weeklyDigestNotification
        monthlyDigestNotification
        quarterlyEmailNotification
        annualDigestNotification
        membershipAlertsNotification
        generalEmailNotification
        organizationSupportAdmin {
          nextToken
          __typename
        }
        updatedAt
        organizationContactsId
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateOrgMemberUser = /* GraphQL */ `
  mutation UpdateOrgMemberUser(
    $input: UpdateOrgMemberUserInput!
    $condition: ModelOrgMemberUserConditionInput
  ) {
    updateOrgMemberUser(input: $input, condition: $condition) {
      id
      organizationId
      userId
      organization {
        id
        name
        organizationType
        groupType
        chairId
        chair {
          id
          name
          type
          createdAt
          createdByUserId
          deleted
          updatedAt
          organizationCompaniesId
          __typename
        }
        chairContactId
        chairContact {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        operatorId
        operator {
          id
          name
          type
          createdAt
          createdByUserId
          deleted
          updatedAt
          organizationCompaniesId
          __typename
        }
        operatorContactId
        operatorContact {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        admins {
          nextToken
          __typename
        }
        airports {
          nextToken
          __typename
        }
        companies {
          nextToken
          __typename
        }
        members {
          nextToken
          __typename
        }
        documents {
          nextToken
          __typename
        }
        calendar {
          nextToken
          __typename
        }
        contacts {
          nextToken
          __typename
        }
        createdAt
        createdByUserId
        createdBy {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        modifications {
          fieldName
          fieldValue
          dataOperation
          modifiedAt
          id
          createdAt
          updatedAt
          __typename
        }
        supportAdmin {
          nextToken
          __typename
        }
        deleted
        updatedAt
        companyOrganizationsId
        userOrganizationId
        __typename
      }
      user {
        id
        cognitoUserId
        termsAgree
        termsAgreeDate
        participationAgreement
        participationAgreementDate
        organization {
          nextToken
          __typename
        }
        roles
        companyId
        company {
          id
          name
          type
          createdAt
          createdByUserId
          deleted
          updatedAt
          organizationCompaniesId
          __typename
        }
        firstName
        lastName
        email
        office
        mobile
        linkedInUrl
        imageUrl
        timeZone
        monthlyUpdates
        generalAnnouncements
        createdAt
        createdByUserId
        createdBy {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        modifications {
          fieldName
          fieldValue
          dataOperation
          modifiedAt
          id
          createdAt
          updatedAt
          __typename
        }
        organizationAdmin {
          nextToken
          __typename
        }
        organizationMember {
          nextToken
          __typename
        }
        deleted
        lastLoginDate
        weeklyDigestNotification
        monthlyDigestNotification
        quarterlyEmailNotification
        annualDigestNotification
        membershipAlertsNotification
        generalEmailNotification
        organizationSupportAdmin {
          nextToken
          __typename
        }
        updatedAt
        organizationContactsId
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteOrgMemberUser = /* GraphQL */ `
  mutation DeleteOrgMemberUser(
    $input: DeleteOrgMemberUserInput!
    $condition: ModelOrgMemberUserConditionInput
  ) {
    deleteOrgMemberUser(input: $input, condition: $condition) {
      id
      organizationId
      userId
      organization {
        id
        name
        organizationType
        groupType
        chairId
        chair {
          id
          name
          type
          createdAt
          createdByUserId
          deleted
          updatedAt
          organizationCompaniesId
          __typename
        }
        chairContactId
        chairContact {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        operatorId
        operator {
          id
          name
          type
          createdAt
          createdByUserId
          deleted
          updatedAt
          organizationCompaniesId
          __typename
        }
        operatorContactId
        operatorContact {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        admins {
          nextToken
          __typename
        }
        airports {
          nextToken
          __typename
        }
        companies {
          nextToken
          __typename
        }
        members {
          nextToken
          __typename
        }
        documents {
          nextToken
          __typename
        }
        calendar {
          nextToken
          __typename
        }
        contacts {
          nextToken
          __typename
        }
        createdAt
        createdByUserId
        createdBy {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        modifications {
          fieldName
          fieldValue
          dataOperation
          modifiedAt
          id
          createdAt
          updatedAt
          __typename
        }
        supportAdmin {
          nextToken
          __typename
        }
        deleted
        updatedAt
        companyOrganizationsId
        userOrganizationId
        __typename
      }
      user {
        id
        cognitoUserId
        termsAgree
        termsAgreeDate
        participationAgreement
        participationAgreementDate
        organization {
          nextToken
          __typename
        }
        roles
        companyId
        company {
          id
          name
          type
          createdAt
          createdByUserId
          deleted
          updatedAt
          organizationCompaniesId
          __typename
        }
        firstName
        lastName
        email
        office
        mobile
        linkedInUrl
        imageUrl
        timeZone
        monthlyUpdates
        generalAnnouncements
        createdAt
        createdByUserId
        createdBy {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        modifications {
          fieldName
          fieldValue
          dataOperation
          modifiedAt
          id
          createdAt
          updatedAt
          __typename
        }
        organizationAdmin {
          nextToken
          __typename
        }
        organizationMember {
          nextToken
          __typename
        }
        deleted
        lastLoginDate
        weeklyDigestNotification
        monthlyDigestNotification
        quarterlyEmailNotification
        annualDigestNotification
        membershipAlertsNotification
        generalEmailNotification
        organizationSupportAdmin {
          nextToken
          __typename
        }
        updatedAt
        organizationContactsId
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createOrgSupportAdminUser = /* GraphQL */ `
  mutation CreateOrgSupportAdminUser(
    $input: CreateOrgSupportAdminUserInput!
    $condition: ModelOrgSupportAdminUserConditionInput
  ) {
    createOrgSupportAdminUser(input: $input, condition: $condition) {
      id
      organizationId
      userId
      organization {
        id
        name
        organizationType
        groupType
        chairId
        chair {
          id
          name
          type
          createdAt
          createdByUserId
          deleted
          updatedAt
          organizationCompaniesId
          __typename
        }
        chairContactId
        chairContact {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        operatorId
        operator {
          id
          name
          type
          createdAt
          createdByUserId
          deleted
          updatedAt
          organizationCompaniesId
          __typename
        }
        operatorContactId
        operatorContact {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        admins {
          nextToken
          __typename
        }
        airports {
          nextToken
          __typename
        }
        companies {
          nextToken
          __typename
        }
        members {
          nextToken
          __typename
        }
        documents {
          nextToken
          __typename
        }
        calendar {
          nextToken
          __typename
        }
        contacts {
          nextToken
          __typename
        }
        createdAt
        createdByUserId
        createdBy {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        modifications {
          fieldName
          fieldValue
          dataOperation
          modifiedAt
          id
          createdAt
          updatedAt
          __typename
        }
        supportAdmin {
          nextToken
          __typename
        }
        deleted
        updatedAt
        companyOrganizationsId
        userOrganizationId
        __typename
      }
      user {
        id
        cognitoUserId
        termsAgree
        termsAgreeDate
        participationAgreement
        participationAgreementDate
        organization {
          nextToken
          __typename
        }
        roles
        companyId
        company {
          id
          name
          type
          createdAt
          createdByUserId
          deleted
          updatedAt
          organizationCompaniesId
          __typename
        }
        firstName
        lastName
        email
        office
        mobile
        linkedInUrl
        imageUrl
        timeZone
        monthlyUpdates
        generalAnnouncements
        createdAt
        createdByUserId
        createdBy {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        modifications {
          fieldName
          fieldValue
          dataOperation
          modifiedAt
          id
          createdAt
          updatedAt
          __typename
        }
        organizationAdmin {
          nextToken
          __typename
        }
        organizationMember {
          nextToken
          __typename
        }
        deleted
        lastLoginDate
        weeklyDigestNotification
        monthlyDigestNotification
        quarterlyEmailNotification
        annualDigestNotification
        membershipAlertsNotification
        generalEmailNotification
        organizationSupportAdmin {
          nextToken
          __typename
        }
        updatedAt
        organizationContactsId
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateOrgSupportAdminUser = /* GraphQL */ `
  mutation UpdateOrgSupportAdminUser(
    $input: UpdateOrgSupportAdminUserInput!
    $condition: ModelOrgSupportAdminUserConditionInput
  ) {
    updateOrgSupportAdminUser(input: $input, condition: $condition) {
      id
      organizationId
      userId
      organization {
        id
        name
        organizationType
        groupType
        chairId
        chair {
          id
          name
          type
          createdAt
          createdByUserId
          deleted
          updatedAt
          organizationCompaniesId
          __typename
        }
        chairContactId
        chairContact {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        operatorId
        operator {
          id
          name
          type
          createdAt
          createdByUserId
          deleted
          updatedAt
          organizationCompaniesId
          __typename
        }
        operatorContactId
        operatorContact {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        admins {
          nextToken
          __typename
        }
        airports {
          nextToken
          __typename
        }
        companies {
          nextToken
          __typename
        }
        members {
          nextToken
          __typename
        }
        documents {
          nextToken
          __typename
        }
        calendar {
          nextToken
          __typename
        }
        contacts {
          nextToken
          __typename
        }
        createdAt
        createdByUserId
        createdBy {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        modifications {
          fieldName
          fieldValue
          dataOperation
          modifiedAt
          id
          createdAt
          updatedAt
          __typename
        }
        supportAdmin {
          nextToken
          __typename
        }
        deleted
        updatedAt
        companyOrganizationsId
        userOrganizationId
        __typename
      }
      user {
        id
        cognitoUserId
        termsAgree
        termsAgreeDate
        participationAgreement
        participationAgreementDate
        organization {
          nextToken
          __typename
        }
        roles
        companyId
        company {
          id
          name
          type
          createdAt
          createdByUserId
          deleted
          updatedAt
          organizationCompaniesId
          __typename
        }
        firstName
        lastName
        email
        office
        mobile
        linkedInUrl
        imageUrl
        timeZone
        monthlyUpdates
        generalAnnouncements
        createdAt
        createdByUserId
        createdBy {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        modifications {
          fieldName
          fieldValue
          dataOperation
          modifiedAt
          id
          createdAt
          updatedAt
          __typename
        }
        organizationAdmin {
          nextToken
          __typename
        }
        organizationMember {
          nextToken
          __typename
        }
        deleted
        lastLoginDate
        weeklyDigestNotification
        monthlyDigestNotification
        quarterlyEmailNotification
        annualDigestNotification
        membershipAlertsNotification
        generalEmailNotification
        organizationSupportAdmin {
          nextToken
          __typename
        }
        updatedAt
        organizationContactsId
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteOrgSupportAdminUser = /* GraphQL */ `
  mutation DeleteOrgSupportAdminUser(
    $input: DeleteOrgSupportAdminUserInput!
    $condition: ModelOrgSupportAdminUserConditionInput
  ) {
    deleteOrgSupportAdminUser(input: $input, condition: $condition) {
      id
      organizationId
      userId
      organization {
        id
        name
        organizationType
        groupType
        chairId
        chair {
          id
          name
          type
          createdAt
          createdByUserId
          deleted
          updatedAt
          organizationCompaniesId
          __typename
        }
        chairContactId
        chairContact {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        operatorId
        operator {
          id
          name
          type
          createdAt
          createdByUserId
          deleted
          updatedAt
          organizationCompaniesId
          __typename
        }
        operatorContactId
        operatorContact {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        admins {
          nextToken
          __typename
        }
        airports {
          nextToken
          __typename
        }
        companies {
          nextToken
          __typename
        }
        members {
          nextToken
          __typename
        }
        documents {
          nextToken
          __typename
        }
        calendar {
          nextToken
          __typename
        }
        contacts {
          nextToken
          __typename
        }
        createdAt
        createdByUserId
        createdBy {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        modifications {
          fieldName
          fieldValue
          dataOperation
          modifiedAt
          id
          createdAt
          updatedAt
          __typename
        }
        supportAdmin {
          nextToken
          __typename
        }
        deleted
        updatedAt
        companyOrganizationsId
        userOrganizationId
        __typename
      }
      user {
        id
        cognitoUserId
        termsAgree
        termsAgreeDate
        participationAgreement
        participationAgreementDate
        organization {
          nextToken
          __typename
        }
        roles
        companyId
        company {
          id
          name
          type
          createdAt
          createdByUserId
          deleted
          updatedAt
          organizationCompaniesId
          __typename
        }
        firstName
        lastName
        email
        office
        mobile
        linkedInUrl
        imageUrl
        timeZone
        monthlyUpdates
        generalAnnouncements
        createdAt
        createdByUserId
        createdBy {
          id
          cognitoUserId
          termsAgree
          termsAgreeDate
          participationAgreement
          participationAgreementDate
          roles
          companyId
          firstName
          lastName
          email
          office
          mobile
          linkedInUrl
          imageUrl
          timeZone
          monthlyUpdates
          generalAnnouncements
          createdAt
          createdByUserId
          deleted
          lastLoginDate
          weeklyDigestNotification
          monthlyDigestNotification
          quarterlyEmailNotification
          annualDigestNotification
          membershipAlertsNotification
          generalEmailNotification
          updatedAt
          organizationContactsId
          __typename
        }
        modifications {
          fieldName
          fieldValue
          dataOperation
          modifiedAt
          id
          createdAt
          updatedAt
          __typename
        }
        organizationAdmin {
          nextToken
          __typename
        }
        organizationMember {
          nextToken
          __typename
        }
        deleted
        lastLoginDate
        weeklyDigestNotification
        monthlyDigestNotification
        quarterlyEmailNotification
        annualDigestNotification
        membershipAlertsNotification
        generalEmailNotification
        organizationSupportAdmin {
          nextToken
          __typename
        }
        updatedAt
        organizationContactsId
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
